import { jsx as j, jsxs as Re, Fragment as Fn } from "react/jsx-runtime";
import Be, { forwardRef as Wn, useState as pt, useRef as nn, useEffect as rn, useLayoutEffect as Fo } from "react";
var Wo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $o(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Vr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var o = {}.hasOwnProperty;
    function a() {
      for (var s = [], l = 0; l < arguments.length; l++) {
        var d = arguments[l];
        if (d) {
          var b = typeof d;
          if (b === "string" || b === "number")
            s.push(d);
          else if (Array.isArray(d)) {
            if (d.length) {
              var L = a.apply(null, d);
              L && s.push(L);
            }
          } else if (b === "object") {
            if (d.toString !== Object.prototype.toString && !d.toString.toString().includes("[native code]")) {
              s.push(d.toString());
              continue;
            }
            for (var E in d)
              o.call(d, E) && d[E] && s.push(E);
          }
        }
      }
      return s.join(" ");
    }
    t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
  })();
})(Vr);
var Do = Vr.exports;
const Wt = /* @__PURE__ */ $o(Do), No = "rgba(31,36,38,0.64)", Yo = "#f5f7f8", Xo = "#ffffff", Uo = "#f5f7f8", Ho = "#1b8533", qo = "#cc392f", Vo = "#ffffff", Go = "#000000", Zo = "#f5f7f8", Jo = "#e8eced", Qo = "#d5d9db", Ko = "#b6bec2", ei = "#8e999e", ti = "#69757a", ni = "#495257", ri = "#333a3d", oi = "#1f2426", ii = "#ffc6e6", ai = "#ff93cf", si = "#f863b7", ci = "#ed3d9f", ui = "#e30a8d", li = "#c40879", fi = "#9c085c", di = "#770644", hi = "#55022e", pi = "#ffc7f2", vi = "#f59de2", mi = "#e07ecb", yi = "#d160b7", gi = "#b34fa0", bi = "#964286", Ci = "#773569", wi = "#5b284f", Li = "#401c36", Si = "#d8c7ff", Pi = "#b69df5", Ti = "#9379e0", Bi = "#7b62cc", Ri = "#634fb3", _i = "#534296", xi = "#44367b", Ei = "#352a60", Oi = "#271f47", Mi = "#ebf4fa", ki = "#d8f1fc", Ai = "#ade9ff", Ii = "#61d5ff", zi = "#00b2f6", ji = "#0091d9", Fi = "#0073b9", Wi = "#005b98", $i = "#004477", Di = "#003561", Ni = "#002342", Yi = "#adffff", Xi = "#75f8fc", Ui = "#3bebf5", Hi = "#00d6e6", qi = "#00b6c7", Vi = "#0097a8", Gi = "#007384", Zi = "#005362", Ji = "#003540", Qi = "#adfff4", Ki = "#67f5e2", ea = "#2de0c8", ta = "#1cc8b4", na = "#16a597", ra = "#0e8e7e", oa = "#077565", ia = "#035a4b", aa = "#004033", sa = "#eaf8ee", ca = "#d9fae1", ua = "#adffbe", la = "#83f295", fa = "#5ae072", da = "#48ce65", ha = "#35bd59", pa = "#24a344", va = "#1b8533", ma = "#106621", ya = "#094212", ga = "#e5ffa8", ba = "#cdf383", Ca = "#b3e65c", wa = "#a0d64a", La = "#8ec738", Sa = "#73ab29", Pa = "#588f1a", Ta = "#3b6610", Ba = "#234208", Ra = "#fff6a8", _a = "#ffec82", xa = "#ffe45e", Ea = "#ffda47", Oa = "#fcd214", Ma = "#e3b409", ka = "#b88907", Aa = "#805203", Ia = "#4d2d02", za = "#ffe6a8", ja = "#ffd784", Fa = "#ffc95e", Wa = "#fdba40", $a = "#faab19", Da = "#e3900b", Na = "#b86b07", Ya = "#804103", Xa = "#4d2502", Ua = "#ffd3ad", Ha = "#feb881", qa = "#fa9f5a", Va = "#f58331", Ga = "#e66f20", Za = "#c95a14", Ja = "#a6400d", Qa = "#7d2c09", Ka = "#571c03", es = "#fcedeb", ts = "#fdded8", ns = "#ffc4b8", rs = "#ff9c8c", os = "#fa7c69", is = "#f26552", as = "#e64b40", ss = "#cc392f", cs = "#a62b24", us = "#821d1a", ls = "#520d0b", fs = "#69757a", ds = "#d5d9db", hs = "#0073b9", ps = "#cc392f", vs = "#1da1f2", ms = "#0077b5", ys = "#3b5998", gs = "#bd081c", bs = "#ff0000", Cs = "rgba(31,36,38,0.1)", ws = "rgba(31,36,38,0.12)", Ls = "rgba(31,36,38,0.18)", Ss = "#1f2426", Ps = "#ffffff", Ts = "#495257", Bs = "#0073b9", Rs = "#005b98", _s = "#a62b24", xs = "#106621", Es = "#b6bec2", Os = "Arial, sans-serif", Ms = "canada-type-gibson, Arial, sans-serif", ks = "canada-type-gibson, Arial, sans-serif", As = 400, Is = 600, zs = 700, js = 600, Fs = 600, Ws = "none", $s = "0 2px 4px 0 rgba(31,36,38,0.1)", Ds = "0 4px 16px 0 rgba(31,36,38,0.12)", Ns = "0 8px 24px 0 rgba(31,36,38,0.18)", Ys = "0px", Xs = "1px", Us = "2px", Hs = "4px", qs = "8px", Vs = "1px", Gs = "37.5em", Zs = "56.25em", Js = "75em", Qs = "93.75em", Ks = "112.5em", ec = "12px", tc = "14px", nc = "16px", rc = "18px", oc = "20px", ic = "24px", ac = "28px", sc = "34px", cc = "40px", uc = "48px", lc = "60px", fc = "72px", dc = "96px", hc = "14px", pc = "16px", vc = "18px", mc = "12px", yc = "14px", gc = "16px", bc = "24px", Cc = "32px", wc = 1, Lc = 1.1, Sc = 1.25, Pc = 1.5, Tc = "0px", Bc = "4px", Rc = "8px", _c = "16px", xc = "9999px", Ec = "4px", Oc = "0px", Mc = "8px", kc = "8px", Ac = "12px", Ic = "16px", zc = "24px", jc = "32px", Fc = "48px", Wc = "4px 8px", $c = "8px 16px", Dc = "12px 20px", Nc = "16px 24px", Yc = "20px 28px", Xc = "2px", Uc = "4px", Hc = "8px", qc = "16px", Vc = "24px", Gc = "32px", Zc = "48px", Jc = "64px", Qc = "2px", Kc = "4px", eu = "8px", tu = "16px", nu = "24px", ru = "32px", ou = "48px", iu = "64px", au = "96px", su = "160px", cu = "256px", uu = "384px", Ln = {
  ColorBackgroundOverlay: No,
  ColorBackgroundBase: Yo,
  ColorBackgroundControl: Xo,
  ColorBackgroundControlDisabled: Uo,
  ColorBackgroundSuccess: Ho,
  ColorBackgroundError: qo,
  ColorBaseWhite: Vo,
  ColorBaseBlack: Go,
  ColorBaseGray10: Zo,
  ColorBaseGray20: Jo,
  ColorBaseGray30: Qo,
  ColorBaseGray40: Ko,
  ColorBaseGray50: ei,
  ColorBaseGray60: ti,
  ColorBaseGray70: ni,
  ColorBaseGray80: ri,
  ColorBaseGray90: oi,
  ColorBaseMagenta10: ii,
  ColorBaseMagenta20: ai,
  ColorBaseMagenta30: si,
  ColorBaseMagenta40: ci,
  ColorBaseMagenta50: ui,
  ColorBaseMagenta60: li,
  ColorBaseMagenta70: fi,
  ColorBaseMagenta80: di,
  ColorBaseMagenta90: hi,
  ColorBasePurple10: pi,
  ColorBasePurple20: vi,
  ColorBasePurple30: mi,
  ColorBasePurple40: yi,
  ColorBasePurple50: gi,
  ColorBasePurple60: bi,
  ColorBasePurple70: Ci,
  ColorBasePurple80: wi,
  ColorBasePurple90: Li,
  ColorBaseViolet10: Si,
  ColorBaseViolet20: Pi,
  ColorBaseViolet30: Ti,
  ColorBaseViolet40: Bi,
  ColorBaseViolet50: Ri,
  ColorBaseViolet60: _i,
  ColorBaseViolet70: xi,
  ColorBaseViolet80: Ei,
  ColorBaseViolet90: Oi,
  ColorBaseBlue5: Mi,
  ColorBaseBlue8: ki,
  ColorBaseBlue10: Ai,
  ColorBaseBlue20: Ii,
  ColorBaseBlue30: zi,
  ColorBaseBlue40: ji,
  ColorBaseBlue50: Fi,
  ColorBaseBlue60: Wi,
  ColorBaseBlue70: $i,
  ColorBaseBlue80: Di,
  ColorBaseBlue90: Ni,
  ColorBaseAqua10: Yi,
  ColorBaseAqua20: Xi,
  ColorBaseAqua30: Ui,
  ColorBaseAqua40: Hi,
  ColorBaseAqua50: qi,
  ColorBaseAqua60: Vi,
  ColorBaseAqua70: Gi,
  ColorBaseAqua80: Zi,
  ColorBaseAqua90: Ji,
  ColorBaseTeal10: Qi,
  ColorBaseTeal20: Ki,
  ColorBaseTeal30: ea,
  ColorBaseTeal40: ta,
  ColorBaseTeal50: na,
  ColorBaseTeal60: ra,
  ColorBaseTeal70: oa,
  ColorBaseTeal80: ia,
  ColorBaseTeal90: aa,
  ColorBaseGreen5: sa,
  ColorBaseGreen8: ca,
  ColorBaseGreen10: ua,
  ColorBaseGreen20: la,
  ColorBaseGreen30: fa,
  ColorBaseGreen40: da,
  ColorBaseGreen50: ha,
  ColorBaseGreen60: pa,
  ColorBaseGreen70: va,
  ColorBaseGreen80: ma,
  ColorBaseGreen90: ya,
  ColorBaseLime10: ga,
  ColorBaseLime20: ba,
  ColorBaseLime30: Ca,
  ColorBaseLime40: wa,
  ColorBaseLime50: La,
  ColorBaseLime60: Sa,
  ColorBaseLime70: Pa,
  ColorBaseLime80: Ta,
  ColorBaseLime90: Ba,
  ColorBaseYellow10: Ra,
  ColorBaseYellow20: _a,
  ColorBaseYellow30: xa,
  ColorBaseYellow40: Ea,
  ColorBaseYellow50: Oa,
  ColorBaseYellow60: Ma,
  ColorBaseYellow70: ka,
  ColorBaseYellow80: Aa,
  ColorBaseYellow90: Ia,
  ColorBaseAmber10: za,
  ColorBaseAmber20: ja,
  ColorBaseAmber30: Fa,
  ColorBaseAmber40: Wa,
  ColorBaseAmber50: $a,
  ColorBaseAmber60: Da,
  ColorBaseAmber70: Na,
  ColorBaseAmber80: Ya,
  ColorBaseAmber90: Xa,
  ColorBaseOrange10: Ua,
  ColorBaseOrange20: Ha,
  ColorBaseOrange30: qa,
  ColorBaseOrange40: Va,
  ColorBaseOrange50: Ga,
  ColorBaseOrange60: Za,
  ColorBaseOrange70: Ja,
  ColorBaseOrange80: Qa,
  ColorBaseOrange90: Ka,
  ColorBaseRed5: es,
  ColorBaseRed8: ts,
  ColorBaseRed10: ns,
  ColorBaseRed20: rs,
  ColorBaseRed30: os,
  ColorBaseRed40: is,
  ColorBaseRed50: as,
  ColorBaseRed60: ss,
  ColorBaseRed70: cs,
  ColorBaseRed80: us,
  ColorBaseRed90: ls,
  ColorBorderControl: fs,
  ColorBorderControlDisabled: ds,
  ColorBorderControlInteractive: hs,
  ColorBorderError: ps,
  ColorBrandTwitter: vs,
  ColorBrandLinkedin: ms,
  ColorBrandFacebook: ys,
  ColorBrandPinterest: gs,
  ColorBrandYoutube: bs,
  ColorShadowSm: Cs,
  ColorShadowMd: ws,
  ColorShadowLg: Ls,
  ColorTextBase: Ss,
  ColorTextDarkCanvas: Ps,
  ColorTextSubdued: Ts,
  ColorTextLink: Bs,
  ColorTextLinkInteractive: Rs,
  ColorTextError: _s,
  ColorTextSuccess: xs,
  ColorTextDisabled: Es,
  FontFamilyArial: Os,
  FontFamilyGibson: Ms,
  FontFamilyBase: ks,
  FontWeightNormal: As,
  FontWeightSemibold: Is,
  FontWeightBold: zs,
  FontWeightStrong: js,
  FontWeightHeading: Fs,
  ShadowBoxNone: Ws,
  ShadowBoxSm: $s,
  ShadowBoxMd: Ds,
  ShadowBoxLg: Ns,
  SizeBorderNone: Ys,
  SizeBorderSm: Xs,
  SizeBorderMd: Us,
  SizeBorderLg: Hs,
  SizeBorderXl: qs,
  SizeBorderControl: Vs,
  SizeBreakpointSm: Gs,
  SizeBreakpointMd: Zs,
  SizeBreakpointLg: Js,
  SizeBreakpointXl: Qs,
  SizeBreakpoint2xl: Ks,
  SizeFont1: ec,
  SizeFont2: tc,
  SizeFont3: nc,
  SizeFont4: rc,
  SizeFont5: oc,
  SizeFont6: ic,
  SizeFont7: ac,
  SizeFont8: sc,
  SizeFont9: cc,
  SizeFont10: uc,
  SizeFont11: lc,
  SizeFont12: fc,
  SizeFont13: dc,
  SizeFontControlSm: hc,
  SizeFontControlMd: pc,
  SizeFontControlLg: vc,
  SizeIconXs: mc,
  SizeIconSm: yc,
  SizeIconMd: gc,
  SizeIconLg: bc,
  SizeIconXl: Cc,
  SizeLineHeightReset: wc,
  SizeLineHeightSm: Lc,
  SizeLineHeightMd: Sc,
  SizeLineHeightLg: Pc,
  SizeRadiusNone: Tc,
  SizeRadiusSm: Bc,
  SizeRadiusMd: Rc,
  SizeRadiusLg: _c,
  SizeRadiusFull: xc,
  SizeRadiusControl: Ec,
  SizeSpacingNone: Oc,
  SizeSpacingBasis: Mc,
  SizeSpacingInsetXs: kc,
  SizeSpacingInsetSm: Ac,
  SizeSpacingInsetMd: Ic,
  SizeSpacingInsetLg: zc,
  SizeSpacingInsetXl: jc,
  SizeSpacingInset2xl: Fc,
  SizeSpacingInsetSquishXs: Wc,
  SizeSpacingInsetSquishSm: $c,
  SizeSpacingInsetSquishMd: Dc,
  SizeSpacingInsetSquishLg: Nc,
  SizeSpacingInsetSquishXl: Yc,
  SizeSpacingInline2xs: Xc,
  SizeSpacingInlineXs: Uc,
  SizeSpacingInlineSm: Hc,
  SizeSpacingInlineMd: qc,
  SizeSpacingInlineLg: Vc,
  SizeSpacingInlineXl: Gc,
  SizeSpacingInline2xl: Zc,
  SizeSpacingInline3xl: Jc,
  SizeSpacingBlock2xs: Qc,
  SizeSpacingBlockXs: Kc,
  SizeSpacingBlockSm: eu,
  SizeSpacingBlockMd: tu,
  SizeSpacingBlockLg: nu,
  SizeSpacingBlockXl: ru,
  SizeSpacingBlock2xl: ou,
  SizeSpacingBlock3xl: iu,
  SizeSpacingBlock4xl: au,
  SizeSpacingBlock5xl: su,
  SizeSpacingBlock6xl: cu,
  SizeSpacingBlock7xl: uu
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var jt = function() {
  return jt = Object.assign || function(o) {
    for (var a, s = 1, l = arguments.length; s < l; s++) {
      a = arguments[s];
      for (var d in a)
        Object.prototype.hasOwnProperty.call(a, d) && (o[d] = a[d]);
    }
    return o;
  }, jt.apply(this, arguments);
};
function lu(t, o) {
  var a = {};
  for (var s in t)
    Object.prototype.hasOwnProperty.call(t, s) && o.indexOf(s) < 0 && (a[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, s = Object.getOwnPropertySymbols(t); l < s.length; l++)
      o.indexOf(s[l]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[l]) && (a[s[l]] = t[s[l]]);
  return a;
}
var fu = function(t, o, a) {
  return {
    "aria-disabled": o && t || void 0,
    disabled: !o && t,
    href: t ? void 0 : a
  };
}, Mr = function(t, o, a) {
  var s, l, d = Wt("rds-Button-icon", (s = {}, s["rds-Button-icon--".concat(o)] = !t, s)), b = a === "small" ? Ln.SizeIconSm : Ln.SizeIconMd;
  return t && (a === "large" || a === "xlarge") && (b = Ln.SizeIconLg), l = {
    fill: "currentColor",
    className: d,
    height: b,
    width: b
  }, l["aria-hidden"] = !0, l.focusable = !1, l;
}, du = function(t, o) {
  t && !o && console.error("If you are adding an 'iconOnly' Button, please provide an accessible 'aria-label' attribute. See the Button Accessibility docs for more information: https://design.ramseysolutions.com/components/button/#accessibility");
};
function Gr(t, o) {
  var a, s = t.appearance, l = s === void 0 ? "primary" : s, d = t["aria-label"], b = t.children, L = t.className, E = t.disabled, A = E === void 0 ? !1 : E, M = t.element, I = t.fullWidthOnMobile, O = I === void 0 ? !1 : I, h = t.href, X = t.icon, Z = t.iconOnly, K = Z === void 0 ? !1 : Z, ce = t.iconPosition, x = ce === void 0 ? "left" : ce, F = t.isOnDarkCanvas, B = F === void 0 ? !1 : F, y = t.size, D = y === void 0 ? "medium" : y, U = lu(t, ["appearance", "aria-label", "children", "className", "disabled", "element", "fullWidthOnMobile", "href", "icon", "iconOnly", "iconPosition", "isOnDarkCanvas", "size"]), ue = M !== void 0 && M !== "button", de = M || "button", ie = Wt("rds-Button", (a = {}, a["rds-Button--".concat(l)] = l !== "primary", a["rds-Button--".concat(D)] = D !== "medium", a["rds-Button--fullWidthOnMobile"] = !K && O, a["rds-Button--iconOnly"] = K, a["is-disabled"] = ue && A, a["on-darkCanvas"] = B, a), L);
  return du(K, d), Be.createElement(
    de,
    jt({ className: ie }, fu(A, ue, h), U, { "aria-label": d, ref: o }),
    X && x === "left" && Be.createElement(X, jt({}, Mr(K, x, D))),
    !K && b,
    X && x === "right" && Be.createElement(X, jt({}, Mr(K, x, D)))
  );
}
var Pt = Wn(Gr);
Gr.displayName = "Button";
const $n = (t, o) => {
  const a = {
    "Content-Type": "application/json"
  };
  return o && (a["X-CSRF-Token"] = o), {
    method: "POST",
    body: JSON.stringify(t),
    headers: a
  };
}, hu = (t, o, a) => fetch(`${t}`, $n(o, a)).then((s) => s.json()), kr = (t, o, a, s) => fetch(
  `${t}/${o}/feedback/thumbs-up`,
  $n(a, s)
).then((l) => l.json()), pu = (t, o, a, s) => fetch(
  `${t}/${o}/feedback/feedback-text`,
  $n(a, s)
).then((l) => l.json()), Zr = (t, o, a) => new Promise(
  (s, l) => setTimeout(
    () => a === void 0 ? s(o) : l(a),
    t
  )
), vu = (t, o, a, s = 2e3) => (console.log("mock search: ", o), console.log("csrf: ", a), Zr(s, {
  search_results: [
    {
      resource_uri: "https://cdn.ramseysolutions.net/static-assets/developer-tooling/shepherd-media-search/transcoded-ramsey-show/20230103/RS_010323_00211.mp4",
      start_time: 107.98,
      search_result_id: 343,
      call_title: "Should I Buy a House as a Premarital Asset to Protect Myself?"
    }
  ]
}, void 0)), Sn = (t, o, a, s, l = 2e3) => (console.log("mock feedback: ", a), console.log("csrf: ", s), Zr(l, {
  feedback_id: "123"
}, void 0));
var Jr = {}, Ar = Array.isArray, Ir = Object.keys, mu = Object.prototype.hasOwnProperty, yu = typeof Element < "u";
function On(t, o) {
  if (t === o)
    return !0;
  if (t && o && typeof t == "object" && typeof o == "object") {
    var a = Ar(t), s = Ar(o), l, d, b;
    if (a && s) {
      if (d = t.length, d != o.length)
        return !1;
      for (l = d; l-- !== 0; )
        if (!On(t[l], o[l]))
          return !1;
      return !0;
    }
    if (a != s)
      return !1;
    var L = t instanceof Date, E = o instanceof Date;
    if (L != E)
      return !1;
    if (L && E)
      return t.getTime() == o.getTime();
    var A = t instanceof RegExp, M = o instanceof RegExp;
    if (A != M)
      return !1;
    if (A && M)
      return t.toString() == o.toString();
    var I = Ir(t);
    if (d = I.length, d !== Ir(o).length)
      return !1;
    for (l = d; l-- !== 0; )
      if (!mu.call(o, I[l]))
        return !1;
    if (yu && t instanceof Element && o instanceof Element)
      return t === o;
    for (l = d; l-- !== 0; )
      if (b = I[l], !(b === "_owner" && t.$$typeof) && !On(t[b], o[b]))
        return !1;
    return !0;
  }
  return t !== t && o !== o;
}
var gu = function(o, a) {
  try {
    return On(o, a);
  } catch (s) {
    if (s.message && s.message.match(/stack|recursion/i) || s.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", s.name, s.message), !1;
    throw s;
  }
}, Dn = {}, Nn = {};
Object.defineProperty(Nn, "__esModule", {
  value: !0
});
function bu(t) {
  this.state.adHasPlayed ? this.props.onAdResume(t) : (this.props.onAdPlay(t), this.setState({
    adHasPlayed: !0
  }));
}
Nn.default = bu;
var Yn = {};
Object.defineProperty(Yn, "__esModule", {
  value: !0
});
function Cu(t, o) {
  var a = o.getPlaylistItem();
  !this.state.hasPlayed && !this.state.adHasPlayed && typeof this.props.generatePrerollUrl == "function" && o.playAd(this.props.generatePrerollUrl(a));
}
Yn.default = Cu;
var Xn = {};
Object.defineProperty(Xn, "__esModule", {
  value: !0
});
function wu(t) {
  t.fullscreen ? this.props.onEnterFullScreen(t) : this.props.onExitFullScreen(t);
}
Xn.default = wu;
var Un = {};
Object.defineProperty(Un, "__esModule", {
  value: !0
});
function Lu(t) {
  t.mute ? this.props.onMute(t) : this.props.onUnmute(t);
}
Un.default = Lu;
var Hn = {};
Object.defineProperty(Hn, "__esModule", {
  value: !0
});
function Su(t) {
  t.playReason === "autostart" ? (this.setState({
    hasPlayed: !0
  }), this.props.onAutoStart(t)) : this.state.hasPlayed && (t.oldstate === "buffering" || t.oldstate === "paused") ? this.props.onResume(t) : (this.props.onPlay(t), this.setState({
    hasPlayed: !0
  }));
}
Hn.default = Su;
var qn = {};
Object.defineProperty(qn, "__esModule", {
  value: !0
});
function Pu(t) {
  var o = this.state.hasFired, a = t.position, s = t.duration, l = !1;
  this.props.onTime(t), !o.threeSeconds && a > 3 && (this.props.onThreeSeconds(), o.threeSeconds = !0, l = !0), !o.tenSeconds && a > 10 && (this.props.onTenSeconds(), o.tenSeconds = !0, l = !0), !o.thirtySeconds && a > 30 && (this.props.onThirtySeconds(), o.thirtySeconds = !0, l = !0), !o.twentyFivePercent && a / s * 100 > 25 && (this.props.onTwentyFivePercent(), o.twentyFivePercent = !0, l = !0), !o.fiftyPercent && a / s * 100 > 50 && (this.props.onFiftyPercent(), o.fiftyPercent = !0, l = !0), !o.seventyFivePercent && a / s * 100 > 75 && (this.props.onSeventyFivePercent(), o.seventyFivePercent = !0, l = !0), !o.ninetyFivePercent && a / s * 100 > 95 && (this.props.onNinetyFivePercent(), o.ninetyFivePercent = !0, l = !0), l && this.setState({
    hasFired: o
  });
}
qn.default = Pu;
var Vn = {};
Object.defineProperty(Vn, "__esModule", {
  value: !0
});
function Tu(t) {
  this.setState({
    hasFired: {}
  }), this.props.onVideoLoad(t);
}
Vn.default = Tu;
Object.defineProperty(Dn, "__esModule", {
  value: !0
});
var Bu = Nn, Ru = yt(Bu), _u = Yn, xu = yt(_u), Eu = Xn, Ou = yt(Eu), Mu = Un, ku = yt(Mu), Au = Hn, Iu = yt(Au), zu = qn, ju = yt(zu), Fu = Vn, Wu = yt(Fu);
function yt(t) {
  return t && t.__esModule ? t : { default: t };
}
function $u(t) {
  return {
    onAdPlay: Ru.default.bind(t),
    onBeforePlay: xu.default.bind(t),
    onFullScreen: Ou.default.bind(t),
    onMute: ku.default.bind(t),
    onPlay: Iu.default.bind(t),
    onTime: ju.default.bind(t),
    onVideoLoad: Wu.default.bind(t)
  };
}
Dn.default = $u;
var Gn = {};
Object.defineProperty(Gn, "__esModule", {
  value: !0
});
function Du(t, o) {
  var a = t.onload || function() {
  }, s = function() {
    a(), o();
  };
  return s;
}
Gn.default = Du;
var Zn = {};
Object.defineProperty(Zn, "__esModule", {
  value: !0
});
var Nu = Object.assign || function(t) {
  for (var o = 1; o < arguments.length; o++) {
    var a = arguments[o];
    for (var s in a)
      Object.prototype.hasOwnProperty.call(a, s) && (t[s] = a[s]);
  }
  return t;
};
function Yu(t) {
  var o = t.aspectRatio, a = t.customProps, s = a === void 0 ? {} : a, l = t.file, d = t.generatePrerollUrl, b = t.image, L = t.isAutoPlay, E = t.isMuted, A = t.licenseKey, M = t.playlist, I = !!d, O = {};
  return A && (O.key = A), M ? O.playlist = M : l && (O.file = l), o && o !== "inherit" && (O.aspectratio = o), I && (O.advertising = {
    client: "googima",
    admessage: "Ad — xxs left",
    autoplayadsmuted: !0
  }), typeof L < "u" && (O.autostart = !!L), typeof E < "u" && (O.mute = !!E), b && (O.image = b), Nu(O, s);
}
Zn.default = Yu;
var Jn = {}, Qn = {};
Object.defineProperty(Qn, "__esModule", {
  value: !0
});
function Xu(t) {
  return Array.isArray(t) ? t : Array.from(t);
}
var Uu = function(o) {
  var a = o.slice(0, 2) === "on";
  if (a) {
    var s = o.slice(2), l = Xu(s), d = l[0], b = l.slice(1);
    return "" + d.toLowerCase() + b.join("");
  }
  return null;
};
Qn.default = Uu;
Object.defineProperty(Jn, "__esModule", {
  value: !0
});
var Hu = Qn, qu = Vu(Hu);
function Vu(t) {
  return t && t.__esModule ? t : { default: t };
}
function Gu(t) {
  var o = t.component, a = t.player, s = t.playerOpts;
  function l(b) {
    o.eventHandlers.onBeforePlay(b, a);
  }
  a.setup(s);
  var d = {};
  Object.keys(o.props).forEach(function(b) {
    var L = (0, qu.default)(b);
    L && (d[L] = o.props[b]);
  }), d.adPlay = o.eventHandlers.onAdPlay, d.beforeComplete = o.props.onOneHundredPercent, d.beforePlay = l, d.fullscreen = o.eventHandlers.onFullScreen, d.mute = o.eventHandlers.onMute, d.play = o.eventHandlers.onPlay, d.playlistItem = o.eventHandlers.onVideoLoad, d.time = o.eventHandlers.onTime, Object.keys(d).forEach(function(b) {
    a.on(b, d[b]);
  });
}
Jn.default = Gu;
var Kn = {};
Object.defineProperty(Kn, "__esModule", {
  value: !0
});
function Zu(t) {
  var o = t.context, a = t.onLoadCallback, s = t.scriptSrc, l = t.uniqueScriptId, d = o.createElement("script");
  d.id = l, d.src = s, d.onload = a, o.head.appendChild(d);
}
Kn.default = Zu;
var er = {};
Object.defineProperty(er, "__esModule", {
  value: !0
});
function Ju(t, o) {
  var a = o.jwplayer && o.jwplayer(t);
  a && a.remove();
}
er.default = Ju;
var tr = {};
Object.defineProperty(tr, "__esModule", {
  value: !0
});
var Qu = function(o) {
  var a = o.context, s = o.playerId, l = a.__JW_PLAYER_CONFIGS__ = a.__JW_PLAYER_CONFIGS__ || {}, d = l[s];
  d ? a.jwplayer.defaults = d : l[s] = a.jwplayer.defaults;
};
tr.default = Qu;
var nr = {};
Object.defineProperty(nr, "__esModule", {
  value: !0
});
var Pe = function() {
}, Ku = {
  aspectRatio: "inherit",
  file: "",
  isAutoPlay: void 0,
  isMuted: void 0,
  onAdPlay: Pe,
  onAdResume: Pe,
  onAdSkipped: Pe,
  onAdComplete: Pe,
  onEnterFullScreen: Pe,
  onExitFullScreen: Pe,
  onMute: Pe,
  onUnmute: Pe,
  onAutoStart: Pe,
  onResume: Pe,
  onPlay: Pe,
  onClose: Pe,
  onReady: Pe,
  onError: Pe,
  onAdPause: Pe,
  onPause: Pe,
  onVideoLoad: Pe,
  onOneHundredPercent: Pe,
  onThreeSeconds: Pe,
  onTenSeconds: Pe,
  onThirtySeconds: Pe,
  onTwentyFivePercent: Pe,
  onFiftyPercent: Pe,
  onSeventyFivePercent: Pe,
  onNinetyFivePercent: Pe,
  onTime: Pe,
  onBuffer: Pe,
  onBufferChange: Pe,
  playlist: "",
  useMultiplePlayerScripts: !1
};
nr.default = Ku;
var rr = {}, Mn = { exports: {} }, en = { exports: {} }, Ce = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zr;
function el() {
  if (zr)
    return Ce;
  zr = 1;
  var t = typeof Symbol == "function" && Symbol.for, o = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, s = t ? Symbol.for("react.fragment") : 60107, l = t ? Symbol.for("react.strict_mode") : 60108, d = t ? Symbol.for("react.profiler") : 60114, b = t ? Symbol.for("react.provider") : 60109, L = t ? Symbol.for("react.context") : 60110, E = t ? Symbol.for("react.async_mode") : 60111, A = t ? Symbol.for("react.concurrent_mode") : 60111, M = t ? Symbol.for("react.forward_ref") : 60112, I = t ? Symbol.for("react.suspense") : 60113, O = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, X = t ? Symbol.for("react.lazy") : 60116, Z = t ? Symbol.for("react.block") : 60121, K = t ? Symbol.for("react.fundamental") : 60117, ce = t ? Symbol.for("react.responder") : 60118, x = t ? Symbol.for("react.scope") : 60119;
  function F(y) {
    if (typeof y == "object" && y !== null) {
      var D = y.$$typeof;
      switch (D) {
        case o:
          switch (y = y.type, y) {
            case E:
            case A:
            case s:
            case d:
            case l:
            case I:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case L:
                case M:
                case X:
                case h:
                case b:
                  return y;
                default:
                  return D;
              }
          }
        case a:
          return D;
      }
    }
  }
  function B(y) {
    return F(y) === A;
  }
  return Ce.AsyncMode = E, Ce.ConcurrentMode = A, Ce.ContextConsumer = L, Ce.ContextProvider = b, Ce.Element = o, Ce.ForwardRef = M, Ce.Fragment = s, Ce.Lazy = X, Ce.Memo = h, Ce.Portal = a, Ce.Profiler = d, Ce.StrictMode = l, Ce.Suspense = I, Ce.isAsyncMode = function(y) {
    return B(y) || F(y) === E;
  }, Ce.isConcurrentMode = B, Ce.isContextConsumer = function(y) {
    return F(y) === L;
  }, Ce.isContextProvider = function(y) {
    return F(y) === b;
  }, Ce.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === o;
  }, Ce.isForwardRef = function(y) {
    return F(y) === M;
  }, Ce.isFragment = function(y) {
    return F(y) === s;
  }, Ce.isLazy = function(y) {
    return F(y) === X;
  }, Ce.isMemo = function(y) {
    return F(y) === h;
  }, Ce.isPortal = function(y) {
    return F(y) === a;
  }, Ce.isProfiler = function(y) {
    return F(y) === d;
  }, Ce.isStrictMode = function(y) {
    return F(y) === l;
  }, Ce.isSuspense = function(y) {
    return F(y) === I;
  }, Ce.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === s || y === A || y === d || y === l || y === I || y === O || typeof y == "object" && y !== null && (y.$$typeof === X || y.$$typeof === h || y.$$typeof === b || y.$$typeof === L || y.$$typeof === M || y.$$typeof === K || y.$$typeof === ce || y.$$typeof === x || y.$$typeof === Z);
  }, Ce.typeOf = F, Ce;
}
var we = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function tl() {
  return jr || (jr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, o = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, s = t ? Symbol.for("react.fragment") : 60107, l = t ? Symbol.for("react.strict_mode") : 60108, d = t ? Symbol.for("react.profiler") : 60114, b = t ? Symbol.for("react.provider") : 60109, L = t ? Symbol.for("react.context") : 60110, E = t ? Symbol.for("react.async_mode") : 60111, A = t ? Symbol.for("react.concurrent_mode") : 60111, M = t ? Symbol.for("react.forward_ref") : 60112, I = t ? Symbol.for("react.suspense") : 60113, O = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, X = t ? Symbol.for("react.lazy") : 60116, Z = t ? Symbol.for("react.block") : 60121, K = t ? Symbol.for("react.fundamental") : 60117, ce = t ? Symbol.for("react.responder") : 60118, x = t ? Symbol.for("react.scope") : 60119;
    function F(N) {
      return typeof N == "string" || typeof N == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      N === s || N === A || N === d || N === l || N === I || N === O || typeof N == "object" && N !== null && (N.$$typeof === X || N.$$typeof === h || N.$$typeof === b || N.$$typeof === L || N.$$typeof === M || N.$$typeof === K || N.$$typeof === ce || N.$$typeof === x || N.$$typeof === Z);
    }
    function B(N) {
      if (typeof N == "object" && N !== null) {
        var Fe = N.$$typeof;
        switch (Fe) {
          case o:
            var ke = N.type;
            switch (ke) {
              case E:
              case A:
              case s:
              case d:
              case l:
              case I:
                return ke;
              default:
                var Ae = ke && ke.$$typeof;
                switch (Ae) {
                  case L:
                  case M:
                  case X:
                  case h:
                  case b:
                    return Ae;
                  default:
                    return Fe;
                }
            }
          case a:
            return Fe;
        }
      }
    }
    var y = E, D = A, U = L, ue = b, de = o, ie = M, te = s, f = X, r = h, u = a, g = d, S = l, R = I, k = !1;
    function ee(N) {
      return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(N) || B(N) === E;
    }
    function C(N) {
      return B(N) === A;
    }
    function m(N) {
      return B(N) === L;
    }
    function Y(N) {
      return B(N) === b;
    }
    function G(N) {
      return typeof N == "object" && N !== null && N.$$typeof === o;
    }
    function J(N) {
      return B(N) === M;
    }
    function q(N) {
      return B(N) === s;
    }
    function Q(N) {
      return B(N) === X;
    }
    function ne(N) {
      return B(N) === h;
    }
    function pe(N) {
      return B(N) === a;
    }
    function ve(N) {
      return B(N) === d;
    }
    function se(N) {
      return B(N) === l;
    }
    function xe(N) {
      return B(N) === I;
    }
    we.AsyncMode = y, we.ConcurrentMode = D, we.ContextConsumer = U, we.ContextProvider = ue, we.Element = de, we.ForwardRef = ie, we.Fragment = te, we.Lazy = f, we.Memo = r, we.Portal = u, we.Profiler = g, we.StrictMode = S, we.Suspense = R, we.isAsyncMode = ee, we.isConcurrentMode = C, we.isContextConsumer = m, we.isContextProvider = Y, we.isElement = G, we.isForwardRef = J, we.isFragment = q, we.isLazy = Q, we.isMemo = ne, we.isPortal = pe, we.isProfiler = ve, we.isStrictMode = se, we.isSuspense = xe, we.isValidElementType = F, we.typeOf = B;
  }()), we;
}
var Fr;
function Qr() {
  return Fr || (Fr = 1, process.env.NODE_ENV === "production" ? en.exports = el() : en.exports = tl()), en.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Pn, Wr;
function nl() {
  if (Wr)
    return Pn;
  Wr = 1;
  var t = Object.getOwnPropertySymbols, o = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function s(d) {
    if (d == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(d);
  }
  function l() {
    try {
      if (!Object.assign)
        return !1;
      var d = new String("abc");
      if (d[5] = "de", Object.getOwnPropertyNames(d)[0] === "5")
        return !1;
      for (var b = {}, L = 0; L < 10; L++)
        b["_" + String.fromCharCode(L)] = L;
      var E = Object.getOwnPropertyNames(b).map(function(M) {
        return b[M];
      });
      if (E.join("") !== "0123456789")
        return !1;
      var A = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(M) {
        A[M] = M;
      }), Object.keys(Object.assign({}, A)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Pn = l() ? Object.assign : function(d, b) {
    for (var L, E = s(d), A, M = 1; M < arguments.length; M++) {
      L = Object(arguments[M]);
      for (var I in L)
        o.call(L, I) && (E[I] = L[I]);
      if (t) {
        A = t(L);
        for (var O = 0; O < A.length; O++)
          a.call(L, A[O]) && (E[A[O]] = L[A[O]]);
      }
    }
    return E;
  }, Pn;
}
var Tn, $r;
function or() {
  if ($r)
    return Tn;
  $r = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Tn = t, Tn;
}
var Bn, Dr;
function Kr() {
  return Dr || (Dr = 1, Bn = Function.call.bind(Object.prototype.hasOwnProperty)), Bn;
}
var Rn, Nr;
function rl() {
  if (Nr)
    return Rn;
  Nr = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var o = or(), a = {}, s = Kr();
    t = function(d) {
      var b = "Warning: " + d;
      typeof console < "u" && console.error(b);
      try {
        throw new Error(b);
      } catch {
      }
    };
  }
  function l(d, b, L, E, A) {
    if (process.env.NODE_ENV !== "production") {
      for (var M in d)
        if (s(d, M)) {
          var I;
          try {
            if (typeof d[M] != "function") {
              var O = Error(
                (E || "React class") + ": " + L + " type `" + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[M] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw O.name = "Invariant Violation", O;
            }
            I = d[M](b, M, E, L, null, o);
          } catch (X) {
            I = X;
          }
          if (I && !(I instanceof Error) && t(
            (E || "React class") + ": type specification of " + L + " `" + M + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof I + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), I instanceof Error && !(I.message in a)) {
            a[I.message] = !0;
            var h = A ? A() : "";
            t(
              "Failed " + L + " type: " + I.message + (h ?? "")
            );
          }
        }
    }
  }
  return l.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, Rn = l, Rn;
}
var _n, Yr;
function ol() {
  if (Yr)
    return _n;
  Yr = 1;
  var t = Qr(), o = nl(), a = or(), s = Kr(), l = rl(), d = function() {
  };
  process.env.NODE_ENV !== "production" && (d = function(L) {
    var E = "Warning: " + L;
    typeof console < "u" && console.error(E);
    try {
      throw new Error(E);
    } catch {
    }
  });
  function b() {
    return null;
  }
  return _n = function(L, E) {
    var A = typeof Symbol == "function" && Symbol.iterator, M = "@@iterator";
    function I(C) {
      var m = C && (A && C[A] || C[M]);
      if (typeof m == "function")
        return m;
    }
    var O = "<<anonymous>>", h = {
      array: ce("array"),
      bigint: ce("bigint"),
      bool: ce("boolean"),
      func: ce("function"),
      number: ce("number"),
      object: ce("object"),
      string: ce("string"),
      symbol: ce("symbol"),
      any: x(),
      arrayOf: F,
      element: B(),
      elementType: y(),
      instanceOf: D,
      node: ie(),
      objectOf: ue,
      oneOf: U,
      oneOfType: de,
      shape: f,
      exact: r
    };
    function X(C, m) {
      return C === m ? C !== 0 || 1 / C === 1 / m : C !== C && m !== m;
    }
    function Z(C, m) {
      this.message = C, this.data = m && typeof m == "object" ? m : {}, this.stack = "";
    }
    Z.prototype = Error.prototype;
    function K(C) {
      if (process.env.NODE_ENV !== "production")
        var m = {}, Y = 0;
      function G(q, Q, ne, pe, ve, se, xe) {
        if (pe = pe || O, se = se || ne, xe !== a) {
          if (E) {
            var N = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw N.name = "Invariant Violation", N;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Fe = pe + ":" + ne;
            !m[Fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (d(
              "You are manually calling a React.PropTypes validation function for the `" + se + "` prop on `" + pe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), m[Fe] = !0, Y++);
          }
        }
        return Q[ne] == null ? q ? Q[ne] === null ? new Z("The " + ve + " `" + se + "` is marked as required " + ("in `" + pe + "`, but its value is `null`.")) : new Z("The " + ve + " `" + se + "` is marked as required in " + ("`" + pe + "`, but its value is `undefined`.")) : null : C(Q, ne, pe, ve, se);
      }
      var J = G.bind(null, !1);
      return J.isRequired = G.bind(null, !0), J;
    }
    function ce(C) {
      function m(Y, G, J, q, Q, ne) {
        var pe = Y[G], ve = S(pe);
        if (ve !== C) {
          var se = R(pe);
          return new Z(
            "Invalid " + q + " `" + Q + "` of type " + ("`" + se + "` supplied to `" + J + "`, expected ") + ("`" + C + "`."),
            { expectedType: C }
          );
        }
        return null;
      }
      return K(m);
    }
    function x() {
      return K(b);
    }
    function F(C) {
      function m(Y, G, J, q, Q) {
        if (typeof C != "function")
          return new Z("Property `" + Q + "` of component `" + J + "` has invalid PropType notation inside arrayOf.");
        var ne = Y[G];
        if (!Array.isArray(ne)) {
          var pe = S(ne);
          return new Z("Invalid " + q + " `" + Q + "` of type " + ("`" + pe + "` supplied to `" + J + "`, expected an array."));
        }
        for (var ve = 0; ve < ne.length; ve++) {
          var se = C(ne, ve, J, q, Q + "[" + ve + "]", a);
          if (se instanceof Error)
            return se;
        }
        return null;
      }
      return K(m);
    }
    function B() {
      function C(m, Y, G, J, q) {
        var Q = m[Y];
        if (!L(Q)) {
          var ne = S(Q);
          return new Z("Invalid " + J + " `" + q + "` of type " + ("`" + ne + "` supplied to `" + G + "`, expected a single ReactElement."));
        }
        return null;
      }
      return K(C);
    }
    function y() {
      function C(m, Y, G, J, q) {
        var Q = m[Y];
        if (!t.isValidElementType(Q)) {
          var ne = S(Q);
          return new Z("Invalid " + J + " `" + q + "` of type " + ("`" + ne + "` supplied to `" + G + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return K(C);
    }
    function D(C) {
      function m(Y, G, J, q, Q) {
        if (!(Y[G] instanceof C)) {
          var ne = C.name || O, pe = ee(Y[G]);
          return new Z("Invalid " + q + " `" + Q + "` of type " + ("`" + pe + "` supplied to `" + J + "`, expected ") + ("instance of `" + ne + "`."));
        }
        return null;
      }
      return K(m);
    }
    function U(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? d(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : d("Invalid argument supplied to oneOf, expected an array.")), b;
      function m(Y, G, J, q, Q) {
        for (var ne = Y[G], pe = 0; pe < C.length; pe++)
          if (X(ne, C[pe]))
            return null;
        var ve = JSON.stringify(C, function(xe, N) {
          var Fe = R(N);
          return Fe === "symbol" ? String(N) : N;
        });
        return new Z("Invalid " + q + " `" + Q + "` of value `" + String(ne) + "` " + ("supplied to `" + J + "`, expected one of " + ve + "."));
      }
      return K(m);
    }
    function ue(C) {
      function m(Y, G, J, q, Q) {
        if (typeof C != "function")
          return new Z("Property `" + Q + "` of component `" + J + "` has invalid PropType notation inside objectOf.");
        var ne = Y[G], pe = S(ne);
        if (pe !== "object")
          return new Z("Invalid " + q + " `" + Q + "` of type " + ("`" + pe + "` supplied to `" + J + "`, expected an object."));
        for (var ve in ne)
          if (s(ne, ve)) {
            var se = C(ne, ve, J, q, Q + "." + ve, a);
            if (se instanceof Error)
              return se;
          }
        return null;
      }
      return K(m);
    }
    function de(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && d("Invalid argument supplied to oneOfType, expected an instance of array."), b;
      for (var m = 0; m < C.length; m++) {
        var Y = C[m];
        if (typeof Y != "function")
          return d(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + k(Y) + " at index " + m + "."
          ), b;
      }
      function G(J, q, Q, ne, pe) {
        for (var ve = [], se = 0; se < C.length; se++) {
          var xe = C[se], N = xe(J, q, Q, ne, pe, a);
          if (N == null)
            return null;
          N.data && s(N.data, "expectedType") && ve.push(N.data.expectedType);
        }
        var Fe = ve.length > 0 ? ", expected one of type [" + ve.join(", ") + "]" : "";
        return new Z("Invalid " + ne + " `" + pe + "` supplied to " + ("`" + Q + "`" + Fe + "."));
      }
      return K(G);
    }
    function ie() {
      function C(m, Y, G, J, q) {
        return u(m[Y]) ? null : new Z("Invalid " + J + " `" + q + "` supplied to " + ("`" + G + "`, expected a ReactNode."));
      }
      return K(C);
    }
    function te(C, m, Y, G, J) {
      return new Z(
        (C || "React class") + ": " + m + " type `" + Y + "." + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + J + "`."
      );
    }
    function f(C) {
      function m(Y, G, J, q, Q) {
        var ne = Y[G], pe = S(ne);
        if (pe !== "object")
          return new Z("Invalid " + q + " `" + Q + "` of type `" + pe + "` " + ("supplied to `" + J + "`, expected `object`."));
        for (var ve in C) {
          var se = C[ve];
          if (typeof se != "function")
            return te(J, q, Q, ve, R(se));
          var xe = se(ne, ve, J, q, Q + "." + ve, a);
          if (xe)
            return xe;
        }
        return null;
      }
      return K(m);
    }
    function r(C) {
      function m(Y, G, J, q, Q) {
        var ne = Y[G], pe = S(ne);
        if (pe !== "object")
          return new Z("Invalid " + q + " `" + Q + "` of type `" + pe + "` " + ("supplied to `" + J + "`, expected `object`."));
        var ve = o({}, Y[G], C);
        for (var se in ve) {
          var xe = C[se];
          if (s(C, se) && typeof xe != "function")
            return te(J, q, Q, se, R(xe));
          if (!xe)
            return new Z(
              "Invalid " + q + " `" + Q + "` key `" + se + "` supplied to `" + J + "`.\nBad object: " + JSON.stringify(Y[G], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(C), null, "  ")
            );
          var N = xe(ne, se, J, q, Q + "." + se, a);
          if (N)
            return N;
        }
        return null;
      }
      return K(m);
    }
    function u(C) {
      switch (typeof C) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !C;
        case "object":
          if (Array.isArray(C))
            return C.every(u);
          if (C === null || L(C))
            return !0;
          var m = I(C);
          if (m) {
            var Y = m.call(C), G;
            if (m !== C.entries) {
              for (; !(G = Y.next()).done; )
                if (!u(G.value))
                  return !1;
            } else
              for (; !(G = Y.next()).done; ) {
                var J = G.value;
                if (J && !u(J[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function g(C, m) {
      return C === "symbol" ? !0 : m ? m["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && m instanceof Symbol : !1;
    }
    function S(C) {
      var m = typeof C;
      return Array.isArray(C) ? "array" : C instanceof RegExp ? "object" : g(m, C) ? "symbol" : m;
    }
    function R(C) {
      if (typeof C > "u" || C === null)
        return "" + C;
      var m = S(C);
      if (m === "object") {
        if (C instanceof Date)
          return "date";
        if (C instanceof RegExp)
          return "regexp";
      }
      return m;
    }
    function k(C) {
      var m = R(C);
      switch (m) {
        case "array":
        case "object":
          return "an " + m;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + m;
        default:
          return m;
      }
    }
    function ee(C) {
      return !C.constructor || !C.constructor.name ? O : C.constructor.name;
    }
    return h.checkPropTypes = l, h.resetWarningCache = l.resetWarningCache, h.PropTypes = h, h;
  }, _n;
}
var xn, Xr;
function il() {
  if (Xr)
    return xn;
  Xr = 1;
  var t = or();
  function o() {
  }
  function a() {
  }
  return a.resetWarningCache = o, xn = function() {
    function s(b, L, E, A, M, I) {
      if (I !== t) {
        var O = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw O.name = "Invariant Violation", O;
      }
    }
    s.isRequired = s;
    function l() {
      return s;
    }
    var d = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: l,
      element: s,
      elementType: s,
      instanceOf: l,
      node: s,
      objectOf: l,
      oneOf: l,
      oneOfType: l,
      shape: l,
      exact: l,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return d.PropTypes = d, d;
  }, xn;
}
if (process.env.NODE_ENV !== "production") {
  var al = Qr(), sl = !0;
  Mn.exports = ol()(al.isElement, sl);
} else
  Mn.exports = il()();
var cl = Mn.exports;
Object.defineProperty(rr, "__esModule", {
  value: !0
});
var ul = cl, fe = ll(ul);
function ll(t) {
  return t && t.__esModule ? t : { default: t };
}
var fl = {
  aspectRatio: fe.default.oneOf(["inherit", "1:1", "16:9"]),
  className: fe.default.string,
  customProps: fe.default.object,
  file: fe.default.string,
  generatePrerollUrl: fe.default.func,
  image: fe.default.string,
  isAutoPlay: fe.default.bool,
  isMuted: fe.default.bool,
  licenseKey: fe.default.string,
  onAdPause: fe.default.func,
  onAdPlay: fe.default.func,
  onAdResume: fe.default.func,
  onAdSkipped: fe.default.func,
  onAdComplete: fe.default.func,
  onAutoStart: fe.default.func,
  onEnterFullScreen: fe.default.func,
  onError: fe.default.func,
  onExitFullScreen: fe.default.func,
  onFiftyPercent: fe.default.func,
  onMute: fe.default.func,
  onNinetyFivePercent: fe.default.func,
  onOneHundredPercent: fe.default.func,
  onPause: fe.default.func,
  onPlay: fe.default.func,
  onReady: fe.default.func,
  onResume: fe.default.func,
  onSeventyFivePercent: fe.default.func,
  onTenSeconds: fe.default.func,
  onThirtySeconds: fe.default.func,
  onThreeSeconds: fe.default.func,
  onTwentyFivePercent: fe.default.func,
  onUnmute: fe.default.func,
  onVideoLoad: fe.default.func,
  onBuffer: fe.default.func,
  onBufferChange: fe.default.func,
  playerId: fe.default.string.isRequired,
  playerScript: fe.default.string.isRequired,
  playlist: fe.default.oneOfType([fe.default.string, fe.default.array]),
  useMultiplePlayerScripts: fe.default.bool
};
rr.default = fl;
Object.defineProperty(Jr, "__esModule", {
  value: !0
});
var dl = function() {
  function t(o, a) {
    for (var s = 0; s < a.length; s++) {
      var l = a[s];
      l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(o, l.key, l);
    }
  }
  return function(o, a, s) {
    return a && t(o.prototype, a), s && t(o, s), o;
  };
}(), eo = Be, Ur = Ge(eo), hl = gu, pl = Ge(hl), vl = Dn, ml = Ge(vl), yl = Gn, gl = Ge(yl), bl = Zn, Cl = Ge(bl), wl = Jn, Ll = Ge(wl), Sl = Kn, Pl = Ge(Sl), Tl = er, Bl = Ge(Tl), Rl = tr, _l = Ge(Rl), xl = nr, El = Ge(xl), Ol = rr, Ml = Ge(Ol);
function Ge(t) {
  return t && t.__esModule ? t : { default: t };
}
function kl(t, o) {
  if (!(t instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function Al(t, o) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : t;
}
function Il(t, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  t.prototype = Object.create(o && o.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(t, o) : t.__proto__ = o);
}
var zl = "ReactJWPlayer", cn = function(t) {
  Il(o, t);
  function o(a) {
    kl(this, o);
    var s = Al(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, a));
    return s.state = {
      adHasPlayed: !1,
      hasPlayed: !1,
      hasFired: {}
    }, s.eventHandlers = (0, ml.default)(s), s.uniqueScriptId = "jw-player-script", a.useMultiplePlayerScripts && (s.uniqueScriptId += "-" + a.playerId), s.videoRef = null, s._initialize = s._initialize.bind(s), s._setVideoRef = s._setVideoRef.bind(s), s;
  }
  return dl(o, [{
    key: "componentDidMount",
    value: function() {
      var s = !!window.jwplayer, l = document.getElementById(this.uniqueScriptId), d = this.props.useMultiplePlayerScripts;
      if (!d && s) {
        this._initialize();
        return;
      }
      if (d && l) {
        this._initialize();
        return;
      }
      l ? l.onload = (0, gl.default)(l, this._initialize) : (0, Pl.default)({
        context: document,
        onLoadCallback: this._initialize,
        scriptSrc: this.props.playerScript,
        uniqueScriptId: this.uniqueScriptId
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function(s) {
      var l = this.props.file !== s.file, d = !(0, pl.default)(this.props.playlist, s.playlist);
      return l || d;
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      window.jwplayer && window.jwplayer(this.videoRef) && this._initialize();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      (0, Bl.default)(this.videoRef, window);
    }
  }, {
    key: "_initialize",
    value: function() {
      var s = this.props, l = s.playerId, d = s.useMultiplePlayerScripts;
      d && (0, _l.default)({ context: window, playerId: l });
      var b = this, L = window.jwplayer(this.videoRef);
      if (L) {
        var E = (0, Cl.default)(this.props);
        (0, Ll.default)({ component: b, player: L, playerOpts: E });
      }
    }
  }, {
    key: "_setVideoRef",
    value: function(s) {
      this.videoRef = s;
    }
  }, {
    key: "render",
    value: function() {
      return Ur.default.createElement(
        "div",
        { className: this.props.className },
        Ur.default.createElement("div", { id: this.props.playerId, ref: this._setVideoRef })
      );
    }
  }]), o;
}(eo.Component);
cn.defaultProps = El.default;
cn.displayName = zl;
cn.propTypes = Ml.default;
var jl = Jr.default = cn;
const Fl = "_containerwithlogo_1ej2x_1", Wl = "_container_1ej2x_1", $l = "_asklogo_1ej2x_14", Dl = "_videowrapper_1ej2x_25", Nl = "_title_1ej2x_31", Yl = "_suggestedclip_1ej2x_36", St = {
  containerwithlogo: Fl,
  container: Wl,
  asklogo: $l,
  videowrapper: Dl,
  title: Nl,
  suggestedclip: Yl
}, to = () => /* @__PURE__ */ j(
  "svg",
  {
    width: "177",
    height: "126",
    viewBox: "0 0 177 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Re("g", { id: "ask-dave-logo", children: [
      /* @__PURE__ */ Re("g", { id: "Frame 7483", children: [
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 34",
            d: "M64.043 82.6914L47.1262 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 41",
            d: "M58.1621 82.6914L41.2453 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 42",
            d: "M52.2754 82.6914L35.3586 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 43",
            d: "M46.3906 82.6914L29.4738 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 44",
            d: "M40.5078 82.6914L23.591 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 45",
            d: "M34.623 82.6914L17.7062 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 46",
            d: "M28.7383 82.6914L11.8215 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 47",
            d: "M22.8555 82.6914L5.93866 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 48",
            d: "M22.8555 76.8086L5.93866 93.7257",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 49",
            d: "M22.8555 70.9258L5.93866 87.8429",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 50",
            d: "M22.8555 65.041L5.93866 81.9581",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 51",
            d: "M22.8555 59.1562L5.93866 76.0734",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 52",
            d: "M22.8555 53.2734L5.93866 70.1905",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 53",
            d: "M22.8555 47.3887L5.93866 64.3058",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 54",
            d: "M22.8555 41.502L5.93866 58.4191",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 55",
            d: "M22.8555 35.6191L5.93866 52.5362",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 56",
            d: "M22.8555 29.7402L5.93866 46.6573",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 57",
            d: "M20.3926 26.5332L5.94232 40.7682",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 35",
            d: "M69.9238 82.6914L53.007 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 36",
            d: "M75.8105 82.6914L58.8937 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 37",
            d: "M81.6953 82.6914L64.7785 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 38",
            d: "M87.6055 82.6914L70.6887 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 39",
            d: "M93.457 82.6914L76.5402 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 40",
            d: "M99.373 82.6914L82.4562 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 58",
            d: "M105.225 82.6914L88.3078 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Line 59",
            d: "M111.139 82.6914L94.2219 99.6085",
            stroke: "#005B98",
            strokeWidth: "1.8388",
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ Re("g", { id: "Group 5", children: [
        /* @__PURE__ */ j(
          "rect",
          {
            id: "Rectangle Copy 5",
            x: "16.7168",
            y: "18.6836",
            width: "135.967",
            height: "70.2817",
            fill: "#002342"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            id: "Triangle Copy 3",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M127.796 111.81L78.5093 79.2678L124.257 52.8548L127.796 111.81Z",
            fill: "#002342"
          }
        )
      ] }),
      /* @__PURE__ */ j(
        "path",
        {
          id: "ask",
          d: "M74.5956 68.666H66.5109L64.2601 62.281H52.96L50.7092 68.666H42.992L54.9352 36.9247H62.6524L74.5956 68.666ZM62.5605 56.4931L58.6101 45.1012L54.6596 56.4931H62.5605ZM94.328 61.6838C94.328 67.1042 89.413 69.1713 84.7276 69.1713C81.3283 69.1713 77.7454 68.1148 75.173 65.6802L77.9291 61.3164C79.7665 62.8782 82.7983 64.0725 84.6357 64.0725C86.4731 64.0725 87.7593 63.6131 87.7593 62.1432C87.7593 60.6733 84.4519 59.9383 83.6251 59.6627C79.8584 58.698 76.5511 57.3659 76.5511 52.6805C76.5511 48.2707 80.4096 45.5605 85.141 45.5605C89.8723 45.5605 92.5366 47.3061 93.8228 48.3626L91.4341 52.6805C90.1479 51.6699 87.5755 50.4756 85.7381 50.4756C83.9926 50.4756 83.0279 50.935 83.0279 52.1293C83.0279 53.3236 84.7735 53.8748 86.3353 54.3342C90.2398 55.4826 94.328 56.6769 94.328 61.6838ZM121.346 68.666H112.894L107.336 59.8464L105.314 61.8216V68.666H97.9648V36.9706H105.314V53.5073L112.205 46.0199H120.657L112.389 54.5179L121.346 68.666Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ Re("g", { id: "Vector", children: [
        /* @__PURE__ */ j(
          "path",
          {
            d: "M14.2335 0.926348C14.2335 0.926348 14.2172 0.947975 14.2181 0.954286L14.2243 1.08859L14.409 1.2104L14.5503 1.3448L14.3916 1.54118L14.4582 1.69265L14.6807 1.80908L14.6157 1.9857L14.7508 2.12099L14.6109 2.31468L14.728 2.45898L14.9649 2.54116L14.7141 3.04033L14.7861 3.1846L14.9536 3.27665L14.9237 3.47402L15.2229 3.49587L15.0614 3.76346L15.3903 3.76819L15.3424 3.97457L15.5045 4.07382L15.5287 4.24419L15.6431 4.36956L15.5591 4.59394L15.6608 4.7211L15.9185 4.76815L15.7742 5.02041L15.9958 5.08547L15.9416 5.29274L16.2236 5.32989L16.3803 5.43636L16.236 5.68864L16.4405 5.769L16.434 5.95017L16.4033 6.14122L16.541 6.25038L16.842 6.28485L16.7995 6.48401L16.7985 6.65797L16.8218 6.82203L16.9596 6.93119L17.2153 7.23602L17.5352 7.17765L17.5089 7.40026L17.7387 7.43197L17.633 7.73025L17.8339 7.78536L18.1043 7.78556C18.1043 7.78556 18.097 7.91534 18.1717 7.94334C18.2465 7.97133 18.433 7.97056 18.5737 7.87331C19.2198 7.89089 18.8434 7.41652 18.8434 7.41652L18.83 7.23173L18.8941 7.04881L18.8889 6.87575L18.7169 6.70708L18.8585 6.52601L18.764 6.35919L18.9119 6.17722L18.8877 6.00685L18.9337 5.83293L18.7059 5.67865L18.8646 5.43719L18.5619 5.39011L18.6882 5.14684L18.6631 4.97016L18.6019 4.81148L18.2695 4.7815L18.2867 4.58592L18.3283 4.38045L18.2068 4.24967L18.206 4.06309L17.9889 3.98452L18.0061 3.78894L17.9269 3.63926L17.7279 3.5517L17.8407 3.30391L17.7254 3.17223L17.6345 3.03066L17.5679 2.87918L17.5437 2.70881L17.4889 2.54924L17.3808 2.42297L17.2962 2.2805L17.2233 2.12993L17.2947 1.90734L17.055 1.85129L17.0606 1.66382L17.0832 1.46104L16.8462 1.60419L16.6236 1.57789L16.649 1.34896L16.4679 1.29746L16.4996 1.06764L16.4222 0.930587L16.2763 0.854775L16.0781 0.818579L16.19 0.519413L16.1135 0.388662L15.8134 0.450647L15.8206 0.410993C15.8206 0.410993 15.8107 0.386648 15.8135 0.360511C15.8306 0.300132 15.773 0.301895 15.7441 0.280243C15.7234 0.270314 15.7144 0.252281 15.6883 0.24956C15.6567 0.254045 15.6072 0.26753 15.5062 0.326947C15.4593 0.359362 15.407 0.398987 15.3484 0.439506C15.2727 0.495337 15.1387 0.0959485 15.0423 0.141851C14.9413 0.201268 14.834 0.261578 14.7268 0.321892C14.3995 0.510044 14.9437 0.625801 14.686 0.713952C14.5012 0.772411 14.3678 0.830002 14.2785 0.881316C14.2542 0.891215 14.2434 0.905633 14.2317 0.913735L14.2335 0.926348Z",
            fill: "#002342"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            d: "M2.61063 4.40727C2.61063 4.40727 2.61511 4.4388 2.6169 4.45142L2.72222 4.60383L2.98711 4.6563L3.22493 4.74478L3.25514 5.36493L3.41903 5.52187L3.71546 5.56986L3.77025 5.81957L3.99815 5.92879L3.98983 6.23254L4.20059 6.35706L4.44652 6.4573L4.42648 6.76914L4.55611 6.95671L4.77318 7.08034L4.81085 7.34537L5.14964 7.37444L5.04035 7.73761L5.58642 7.73077L5.66283 7.99674L5.90337 8.05909L6.03479 8.25927L6.23205 8.37929L6.27509 8.68217L6.46693 8.8094L6.78052 8.79699L6.77307 9.15212L7.0587 9.16944L7.12249 9.43719L7.45321 9.40947L7.67842 9.49977L7.65745 9.85037L7.92775 9.89563L8.01229 10.1282L8.25525 10.6151L8.48318 10.6793L8.82475 10.5921C8.86164 10.6705 8.89312 10.7562 8.9246 10.8418L9.05061 11.0492L9.18654 11.2359L9.41537 11.3064L9.52425 11.5291L9.88564 11.4455L9.93951 11.734L10.2332 11.763L10.2168 12.1452L10.4717 12.2184L10.7997 12.2168C10.7997 12.2168 10.8428 12.3845 10.9446 12.4215C11.0455 12.4522 11.1025 12.1737 11.7255 11.7568C12.3006 11.3661 12.2097 11.1794 12.2097 11.1794L12.0513 10.9702L11.9632 10.7124L11.8173 10.5013C11.7219 10.4634 11.6282 10.4381 11.5273 10.4074L11.504 10.1081L11.278 9.96646L11.2593 9.65369C11.2052 9.59056 11.1512 9.52742 11.0918 9.4715L10.9811 9.23617L10.6477 9.19989L10.6967 8.81956L10.3353 8.81299L10.3374 8.46508L10.2096 8.24507L10.0529 8.04846L9.66542 8.08424L9.57098 7.82729L9.49278 7.54873L9.28653 7.41068L9.17496 7.16905L8.87943 7.12738L8.77869 6.87134L8.60039 6.70355L8.3283 6.64568L8.2988 6.30224L8.08714 6.1714L7.89801 6.01804L7.72513 5.84306L7.57388 5.63925L7.41272 5.45618L7.20826 5.33074L7.02003 5.1837L6.84263 5.02223L6.76804 4.72382L6.45987 4.72902L6.33658 4.49549L6.22412 4.24754L5.96103 4.2077L5.67629 4.19668L5.6035 3.91091L5.35302 3.86928L5.27934 3.57719L5.11455 3.41392L4.89114 3.33627L4.63074 3.31535L4.61478 2.93137L4.45179 2.78072L4.1147 2.89947L4.10663 2.84268C4.10663 2.84268 4.0697 2.80929 4.07153 2.77685C4.05987 2.69482 3.99138 2.71099 3.94363 2.69203C3.91661 2.683 3.8941 2.66046 3.85535 2.65953C3.8175 2.66492 3.76432 2.69823 3.67414 2.7883C3.62906 2.83334 3.58576 2.89099 3.53616 2.94955C3.47664 3.02882 2.94334 2.80851 2.87389 2.90851C2.80533 3.01482 2.73136 3.12834 2.6637 3.24096C2.4499 3.59324 3.08691 3.68292 2.90202 3.92165C2.77124 4.0883 2.68824 4.22884 2.63771 4.32615C2.62868 4.35318 2.61876 4.37393 2.61425 4.38744L2.61063 4.40727Z",
            fill: "#002342"
          }
        ),
        /* @__PURE__ */ j(
          "path",
          {
            d: "M1.23912 17.223C1.23912 17.223 1.25443 17.2401 1.26163 17.2455L1.40035 17.3159L1.76623 17.2639L1.90306 17.4569L2.07605 17.4966L2.26622 17.431L2.43722 17.7285L2.61565 17.716L2.7633 17.8946L2.93632 17.8893L3.25699 18.0626L3.42898 18.2313L3.59475 18.2657L3.75608 18.2234L3.95138 18.5561L4.10377 18.4057L4.29014 18.6303L4.43174 18.4492L4.61097 18.5782L4.76598 18.5369L4.93624 18.6028L5.09664 18.5993L5.28035 18.7599L5.44075 18.7564L5.58321 18.6267L5.77951 18.8305L5.92646 18.7324L6.11109 18.8542L6.24366 18.7001L6.3673 18.4379L6.59318 18.85L6.73472 18.7591L6.91308 18.8367L7.09413 18.9333L7.21866 18.6774L7.33502 18.4999L7.52328 18.6019L7.69985 18.6669L7.87463 18.7193L8.02154 18.6662L8.15498 18.5636L8.25424 18.3563L8.45239 18.4827L8.58403 18.3674L8.82538 18.5712L8.96692 18.4803L9.07877 18.3163C9.07877 18.3163 9.20939 18.375 9.26257 18.3417C9.31576 18.3084 9.34743 18.1236 9.13784 17.5998C8.94083 17.1193 8.81559 17.0985 8.81559 17.0985L8.66871 17.1065L8.50114 17.0595L8.36056 17.0666L7.78497 16.7751L7.6409 16.6217L7.4832 16.6441L7.33733 16.4782L7.18418 16.442L7.03556 16.3473L6.86249 16.4427L6.3402 15.9376L6.23735 16.1196L6.04554 15.9473L5.88338 15.8931L5.73112 15.8633L5.63096 16.0642L5.46342 15.9721L5.29319 15.8612L5.1481 15.8818L4.98235 15.8024L4.84892 15.905L4.68048 15.8067L4.53001 15.7894L4.39299 15.8668L4.2138 15.6928L4.06691 15.7008L3.91644 15.6835L3.76328 15.6474L3.60653 15.586L3.26038 15.7768L3.1126 15.7785L2.96123 15.755L2.80807 15.7188L2.64508 15.5682L2.50534 15.6717L2.34952 15.5716L2.19191 15.4588L2.04499 15.5119L1.89535 15.5911L1.74498 15.4387L1.60347 15.4845L1.45851 15.3249L1.31528 15.268L1.1747 15.2751L1.03499 15.3336L0.891883 15.0965L0.755853 15.045L0.616978 15.1999L0.593569 15.1711C0.593569 15.1711 0.565646 15.1557 0.556648 15.1377C0.524241 15.0908 0.495389 15.1142 0.462951 15.1124C0.444026 15.1151 0.429616 15.1042 0.412485 15.1195C0.394457 15.1285 0.373708 15.1637 0.358338 15.2367C0.351102 15.2763 0.344762 15.3223 0.332114 15.3692C0.322157 15.435 0.28588 15.7684 0.276819 15.8405C0.268654 15.9189 0.635148 16.2788 0.62788 16.3636C0.614179 16.6294 1.24491 16.6749 1.22676 16.8642C1.21405 17.0012 1.21578 17.104 1.23285 17.1788C1.23554 17.1977 1.23733 17.2103 1.24543 17.2221L1.23912 17.223Z",
            fill: "#002342"
          }
        )
      ] })
    ] })
  }
), Xl = ({
  url: t,
  title: o,
  startAt: a,
  customProps: s,
  originalQuestion: l,
  autoPlay: d,
  onVideoEvent: b = (L) => {
  }
}) => {
  const L = "ask-ramsey-video-player", [E, A] = pt(!1), M = {
    file: t
  }, I = () => {
    !E && a && (window.jwplayer("ask-ramsey-video-player").seek(a), A(!0)), b({ type: "play" });
  }, O = () => {
    if (d) {
      const h = window.jwplayer("ask-ramsey-video-player");
      h && h.play();
    }
    b({ type: "view" });
  };
  return /* @__PURE__ */ Re("div", { className: St.containerwithlogo, children: [
    /* @__PURE__ */ j("div", { className: St.asklogo, children: /* @__PURE__ */ j(to, {}) }),
    /* @__PURE__ */ Re(
      "div",
      {
        className: St.container,
        "data-testid": "ask-ramsey-video-container",
        children: [
          /* @__PURE__ */ j("div", { className: St.videowrapper, children: /* @__PURE__ */ j(
            jl,
            {
              playerId: L,
              playerScript: "https://cdn.jwplayer.com/libraries/L1H1ocUG.js",
              aspectRatio: "16:9",
              playlist: [M],
              position: a,
              customProps: s,
              onPause: () => b({ type: "pause" }),
              onReady: O,
              onPlay: I,
              autostart: !0,
              onResume: () => b({ type: "play" }),
              onVideoLoad: () => b({ type: "load" })
            }
          ) }),
          /* @__PURE__ */ j("h2", { className: St.suggestedclip, children: o }),
          l && /* @__PURE__ */ j("h3", { className: St.title, children: `Based on your question: "${l}"` })
        ]
      }
    )
  ] });
}, Ul = Be.createContext({}), no = !0;
function Hl({ baseColor: t, highlightColor: o, width: a, height: s, borderRadius: l, circle: d, direction: b, duration: L, enableAnimation: E = no }) {
  const A = {};
  return b === "rtl" && (A["--animation-direction"] = "reverse"), typeof L == "number" && (A["--animation-duration"] = `${L}s`), E || (A["--pseudo-element-display"] = "none"), (typeof a == "string" || typeof a == "number") && (A.width = a), (typeof s == "string" || typeof s == "number") && (A.height = s), (typeof l == "string" || typeof l == "number") && (A.borderRadius = l), d && (A.borderRadius = "50%"), typeof t < "u" && (A["--base-color"] = t), typeof o < "u" && (A["--highlight-color"] = o), A;
}
function ht({ count: t = 1, wrapper: o, className: a, containerClassName: s, containerTestId: l, circle: d = !1, style: b, ...L }) {
  var E, A, M;
  const I = Be.useContext(Ul), O = { ...L };
  for (const [F, B] of Object.entries(L))
    typeof B > "u" && delete O[F];
  const h = {
    ...I,
    ...O,
    circle: d
  }, X = {
    ...b,
    ...Hl(h)
  };
  let Z = "react-loading-skeleton";
  a && (Z += ` ${a}`);
  const K = (E = h.inline) !== null && E !== void 0 ? E : !1, ce = [], x = Math.ceil(t);
  for (let F = 0; F < x; F++) {
    let B = X;
    if (x > t && F === x - 1) {
      const D = (A = B.width) !== null && A !== void 0 ? A : "100%", U = t % 1, ue = typeof D == "number" ? D * U : `calc(${D} * ${U})`;
      B = { ...B, width: ue };
    }
    const y = Be.createElement("span", { className: Z, style: B, key: F }, "‌");
    K ? ce.push(y) : ce.push(Be.createElement(
      Be.Fragment,
      { key: F },
      y,
      Be.createElement("br", null)
    ));
  }
  return Be.createElement("span", { className: s, "data-testid": l, "aria-live": "polite", "aria-busy": (M = h.enableAnimation) !== null && M !== void 0 ? M : no }, o ? ce.map((F, B) => Be.createElement(o, { key: B }, F)) : ce);
}
const ql = () => /* @__PURE__ */ Re(Fn, { children: [
  /* @__PURE__ */ j(ht, { height: 40, width: 80, style: { margin: "1em 0" } }),
  /* @__PURE__ */ j(ht, { style: { aspectRatio: "16 / 9" } }),
  /* @__PURE__ */ j(ht, { height: 30, style: { marginTop: "1em" } }),
  /* @__PURE__ */ j(ht, { height: 20, style: { marginTop: "1em" } }),
  /* @__PURE__ */ j(ht, { height: 20, style: { marginTop: "1em" } }),
  /* @__PURE__ */ j(ht, { height: 50, style: { marginTop: "1em" } }),
  /* @__PURE__ */ j(ht, { height: 40, style: { marginTop: "1em" }, width: 120 })
] }), ro = /* @__PURE__ */ new Set(), De = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), vt = /* @__PURE__ */ new WeakMap(), kn = /* @__PURE__ */ new WeakMap(), Vl = /* @__PURE__ */ new WeakMap(), Rt = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), zt = /* @__PURE__ */ new WeakSet();
let mt;
const it = "__aa_tgt", An = "__aa_del", Gl = (t) => {
  const o = ef(t);
  o && o.forEach((a) => tf(a));
}, Zl = (t) => {
  t.forEach((o) => {
    o.target === mt && Ql(), De.has(o.target) && gt(o.target);
  });
};
function Jl(t) {
  const o = kn.get(t);
  o == null || o.disconnect();
  let a = De.get(t), s = 0;
  const l = 5;
  a || (a = _t(t), De.set(t, a));
  const { offsetWidth: d, offsetHeight: b } = mt, E = [
    a.top - l,
    d - (a.left + l + a.width),
    b - (a.top + l + a.height),
    a.left - l
  ].map((M) => `${-1 * Math.floor(M)}px`).join(" "), A = new IntersectionObserver(() => {
    ++s > 1 && gt(t);
  }, {
    root: mt,
    threshold: 1,
    rootMargin: E
  });
  A.observe(t), kn.set(t, A);
}
function gt(t) {
  clearTimeout(on.get(t));
  const o = un(t), a = typeof o == "function" ? 500 : o.duration;
  on.set(t, setTimeout(async () => {
    const s = vt.get(t);
    try {
      await (s == null ? void 0 : s.finished), De.set(t, _t(t)), Jl(t);
    } catch {
    }
  }, a));
}
function Ql() {
  clearTimeout(on.get(mt)), on.set(mt, setTimeout(() => {
    ro.forEach((t) => so(t, (o) => oo(() => gt(o))));
  }, 100));
}
function Kl(t) {
  setTimeout(() => {
    Vl.set(t, setInterval(() => oo(gt.bind(null, t)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function oo(t) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => t()) : requestAnimationFrame(() => t());
}
let In, Tt;
typeof window < "u" && (mt = document.documentElement, In = new MutationObserver(Gl), Tt = new ResizeObserver(Zl), Tt.observe(mt));
function ef(t) {
  return t.reduce((s, l) => [
    ...s,
    ...Array.from(l.addedNodes),
    ...Array.from(l.removedNodes)
  ], []).every((s) => s.nodeName === "#comment") ? !1 : t.reduce((s, l) => {
    if (s === !1)
      return !1;
    if (l.target instanceof Element) {
      if (En(l.target), !s.has(l.target)) {
        s.add(l.target);
        for (let d = 0; d < l.target.children.length; d++) {
          const b = l.target.children.item(d);
          if (b) {
            if (An in b)
              return !1;
            En(l.target, b), s.add(b);
          }
        }
      }
      if (l.removedNodes.length)
        for (let d = 0; d < l.removedNodes.length; d++) {
          const b = l.removedNodes[d];
          if (An in b)
            return !1;
          b instanceof Element && (s.add(b), En(l.target, b), Bt.set(b, [
            l.previousSibling,
            l.nextSibling
          ]));
        }
    }
    return s;
  }, /* @__PURE__ */ new Set());
}
function En(t, o) {
  !o && !(it in t) ? Object.defineProperty(t, it, { value: t }) : o && !(it in o) && Object.defineProperty(o, it, { value: t });
}
function tf(t) {
  var o;
  const a = t.isConnected, s = De.has(t);
  a && Bt.has(t) && Bt.delete(t), vt.has(t) && ((o = vt.get(t)) === null || o === void 0 || o.cancel()), s && a ? rf(t) : s && !a ? af(t) : of(t);
}
function Qe(t) {
  return Number(t.replace(/[^0-9.\-]/g, ""));
}
function nf(t) {
  let o = t.parentElement;
  for (; o; ) {
    if (o.scrollLeft || o.scrollTop)
      return { x: o.scrollLeft, y: o.scrollTop };
    o = o.parentElement;
  }
  return { x: 0, y: 0 };
}
function _t(t) {
  const o = t.getBoundingClientRect(), { x: a, y: s } = nf(t);
  return {
    top: o.top + s,
    left: o.left + a,
    width: o.width,
    height: o.height
  };
}
function io(t, o, a) {
  let s = o.width, l = o.height, d = a.width, b = a.height;
  const L = getComputedStyle(t);
  if (L.getPropertyValue("box-sizing") === "content-box") {
    const A = Qe(L.paddingTop) + Qe(L.paddingBottom) + Qe(L.borderTopWidth) + Qe(L.borderBottomWidth), M = Qe(L.paddingLeft) + Qe(L.paddingRight) + Qe(L.borderRightWidth) + Qe(L.borderLeftWidth);
    s -= M, d -= M, l -= A, b -= A;
  }
  return [s, d, l, b].map(Math.round);
}
function un(t) {
  return it in t && Rt.has(t[it]) ? Rt.get(t[it]) : { duration: 250, easing: "ease-in-out" };
}
function ao(t) {
  if (it in t)
    return t[it];
}
function ir(t) {
  const o = ao(t);
  return o ? zt.has(o) : !1;
}
function so(t, ...o) {
  o.forEach((a) => a(t, Rt.has(t)));
  for (let a = 0; a < t.children.length; a++) {
    const s = t.children.item(a);
    s && o.forEach((l) => l(s, Rt.has(s)));
  }
}
function rf(t) {
  const o = De.get(t), a = _t(t);
  if (!ir(t))
    return De.set(t, a);
  let s;
  if (!o)
    return;
  const l = un(t);
  if (typeof l != "function") {
    const d = o.left - a.left, b = o.top - a.top, [L, E, A, M] = io(t, o, a), I = {
      transform: `translate(${d}px, ${b}px)`
    }, O = {
      transform: "translate(0, 0)"
    };
    L !== E && (I.width = `${L}px`, O.width = `${E}px`), A !== M && (I.height = `${A}px`, O.height = `${M}px`), s = t.animate([I, O], {
      duration: l.duration,
      easing: l.easing
    });
  } else
    s = new Animation(l(t, "remain", o, a)), s.play();
  vt.set(t, s), De.set(t, a), s.addEventListener("finish", gt.bind(null, t));
}
function of(t) {
  const o = _t(t);
  De.set(t, o);
  const a = un(t);
  if (!ir(t))
    return;
  let s;
  typeof a != "function" ? s = t.animate([
    { transform: "scale(.98)", opacity: 0 },
    { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
    { transform: "scale(1)", opacity: 1 }
  ], {
    duration: a.duration * 1.5,
    easing: "ease-in"
  }) : (s = new Animation(a(t, "add", o)), s.play()), vt.set(t, s), s.addEventListener("finish", gt.bind(null, t));
}
function af(t) {
  var o;
  if (!Bt.has(t) || !De.has(t))
    return;
  const [a, s] = Bt.get(t);
  Object.defineProperty(t, An, { value: !0 }), s && s.parentNode && s.parentNode instanceof Element ? s.parentNode.insertBefore(t, s) : a && a.parentNode ? a.parentNode.appendChild(t) : (o = ao(t)) === null || o === void 0 || o.appendChild(t);
  function l() {
    var O;
    t.remove(), De.delete(t), Bt.delete(t), vt.delete(t), (O = kn.get(t)) === null || O === void 0 || O.disconnect();
  }
  if (!ir(t))
    return l();
  const [d, b, L, E] = sf(t), A = un(t), M = De.get(t);
  let I;
  Object.assign(t.style, {
    position: "absolute",
    top: `${d}px`,
    left: `${b}px`,
    width: `${L}px`,
    height: `${E}px`,
    margin: 0,
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: 100
  }), typeof A != "function" ? I = t.animate([
    {
      transform: "scale(1)",
      opacity: 1
    },
    {
      transform: "scale(.98)",
      opacity: 0
    }
  ], { duration: A.duration, easing: "ease-out" }) : (I = new Animation(A(t, "remove", M)), I.play()), vt.set(t, I), I.addEventListener("finish", l);
}
function sf(t) {
  const o = De.get(t), [a, , s] = io(t, o, _t(t));
  let l = t.parentElement;
  for (; l && (getComputedStyle(l).position === "static" || l instanceof HTMLBodyElement); )
    l = l.parentElement;
  l || (l = document.body);
  const d = getComputedStyle(l), b = De.get(l) || _t(l), L = Math.round(o.top - b.top) - Qe(d.borderTopWidth), E = Math.round(o.left - b.left) - Qe(d.borderLeftWidth);
  return [L, E, a, s];
}
function co(t, o = {}) {
  return In && Tt && (window.matchMedia("(prefers-reduced-motion: reduce)").matches && typeof o != "function" && !o.disrespectUserMotionPreference || (zt.add(t), getComputedStyle(t).position === "static" && Object.assign(t.style, { position: "relative" }), so(t, gt, Kl, (l) => Tt == null ? void 0 : Tt.observe(l)), typeof o == "function" ? Rt.set(t, o) : Rt.set(t, { duration: 250, easing: "ease-in-out", ...o }), In.observe(t, { childList: !0 }), ro.add(t))), Object.freeze({
    parent: t,
    enable: () => {
      zt.add(t);
    },
    disable: () => {
      zt.delete(t);
    },
    isEnabled: () => zt.has(t)
  });
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var an = function() {
  return an = Object.assign || function(o) {
    for (var a, s = 1, l = arguments.length; s < l; s++) {
      a = arguments[s];
      for (var d in a)
        Object.prototype.hasOwnProperty.call(a, d) && (o[d] = a[d]);
    }
    return o;
  }, an.apply(this, arguments);
};
function cf(t, o) {
  var a = {};
  for (var s in t)
    Object.prototype.hasOwnProperty.call(t, s) && o.indexOf(s) < 0 && (a[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, s = Object.getOwnPropertySymbols(t); l < s.length; l++)
      o.indexOf(s[l]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[l]) && (a[s[l]] = t[s[l]]);
  return a;
}
var uf = function(t, o, a) {
  return {
    "aria-invalid": t || void 0,
    "aria-describedby": o || void 0,
    disabled: a || void 0
  };
}, lf = "rds-textarea-counterID-".concat(Math.random().toString(36).slice(2, 16)), ff = function(t) {
  if (!t)
    return "auto";
  var o = Number(getComputedStyle(t).getPropertyValue("border-width").split("px")[0]), a = Math.round(o);
  return "".concat(t.scrollHeight + a * 2);
}, df = function(t, o, a) {
  var s = an({}, t);
  return o && (s.resize = "none", s.height = a), s;
}, uo = Wn(function(t, o) {
  var a, s = t.className, l = t.autoGrow, d = l === void 0 ? !1 : l, b = t.disabled, L = b === void 0 ? !1 : b, E = t.invalid, A = E === void 0 ? !1 : E, M = t.maxLength, I = t.size, O = I === void 0 ? "md" : I, h = t.style, X = h === void 0 ? {} : h, Z = t.value, K = cf(t, ["className", "autoGrow", "disabled", "invalid", "maxLength", "size", "style", "value"]), ce = Wt("rds-Textarea", (a = {
    "is-disabled": L,
    "is-invalid": A
  }, a["rds-Textarea--".concat(O)] = O !== "md", a), s), x = function(f) {
    typeof o == "function" ? o(f) : o !== null && (o.current = f), U.current = f;
  }, F = pt(M), B = F[0], y = F[1], D = nn(lf);
  rn(function() {
    M && Z !== void 0 && y(M - Z.length);
  }, []);
  var U = nn(null), ue = pt("auto"), de = ue[0], ie = ue[1];
  Fo(function() {
    d && de === "auto" && ie("".concat(ff(U.current), "px"));
  }, [de, d]);
  var te = function(f) {
    var r = f.target.value.length;
    M && y(M - r), d && ie("auto"), K.onChange && K.onChange(f);
  };
  return Be.createElement(
    "div",
    { className: ce },
    !!M && M > 0 && Be.createElement("span", { className: "rds-Textarea-counter", "aria-live": "polite", id: D.current }, B),
    Be.createElement("textarea", an({}, K, uf(A, D.current, L), { ref: x, onChange: te, maxLength: M, value: Z, style: df(X, d, de) }))
  );
});
uo.displayName = "Textarea";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var sn = function() {
  return sn = Object.assign || function(o) {
    for (var a, s = 1, l = arguments.length; s < l; s++) {
      a = arguments[s];
      for (var d in a)
        Object.prototype.hasOwnProperty.call(a, d) && (o[d] = a[d]);
    }
    return o;
  }, sn.apply(this, arguments);
};
function lo(t, o) {
  var a = {};
  for (var s in t)
    Object.prototype.hasOwnProperty.call(t, s) && o.indexOf(s) < 0 && (a[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, s = Object.getOwnPropertySymbols(t); l < s.length; l++)
      o.indexOf(s[l]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[l]) && (a[s[l]] = t[s[l]]);
  return a;
}
var fo = function(t) {
  var o = t.title, a = lo(t, ["title"]);
  return Be.createElement(
    "svg",
    sn({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24 }, a),
    !!o && Be.createElement("title", null, o),
    Be.createElement("path", { d: "M21.001 14h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-3v13a1 1 0 0 0 1 1Zm-18.881.866c.285.089.582.133.881.133h6v3c0 3.824 2.59 4.942 3.958 5a1.017 1.017 0 0 0 .734-.277 1 1 0 0 0 .308-.723v-4.638l4-4.8V0H5.771a2.985 2.985 0 0 0-2.87 2.118l-2.769 9a3 3 0 0 0 1.987 3.75Z" })
  );
};
fo.displayName = "ThumbsDownIcon";
var ho = function(t) {
  var o = t.title, a = lo(t, ["title"]);
  return Be.createElement(
    "svg",
    sn({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24 }, a),
    !!o && Be.createElement("title", null, o),
    Be.createElement("path", { d: "M3 9H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3V10a1 1 0 0 0-1-1zm18.882-.867A2.986 2.986 0 0 0 21 8h-6V5c0-3.824-2.589-4.942-3.958-5a1.017 1.017 0 0 0-.734.277A1 1 0 0 0 10 1v4.638l-4 4.8V23h12.23a2.985 2.985 0 0 0 2.87-2.118l2.769-9a3 3 0 0 0-1.987-3.749z" })
  );
};
ho.displayName = "ThumbsUpIcon";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var zn = function() {
  return zn = Object.assign || function(o) {
    for (var a, s = 1, l = arguments.length; s < l; s++) {
      a = arguments[s];
      for (var d in a)
        Object.prototype.hasOwnProperty.call(a, d) && (o[d] = a[d]);
    }
    return o;
  }, zn.apply(this, arguments);
};
function hf(t, o) {
  var a = {};
  for (var s in t)
    Object.prototype.hasOwnProperty.call(t, s) && o.indexOf(s) < 0 && (a[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, s = Object.getOwnPropertySymbols(t); l < s.length; l++)
      o.indexOf(s[l]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[l]) && (a[s[l]] = t[s[l]]);
  return a;
}
var jn = function(t) {
  var o, a = t.className, s = t.color, l = s === void 0 ? "default" : s, d = t.icon, b = t.size, L = b === void 0 ? "medium" : b, E = t.title, A = hf(t, ["className", "color", "icon", "size", "title"]), M = d, I = Wt("rds-Icon", (o = {}, o["rds-Icon--".concat(l)] = l !== "default", o["rds-Icon--".concat(L)] = L !== "medium", o), a), O = E ? { title: E, role: "img" } : { focusable: !1, "aria-hidden": !0 };
  return Be.createElement(M, zn({ className: I }, O, A));
};
jn.displayName = "Icon";
var ar = {}, po = { exports: {} };
(function(t, o) {
  (function(s, l) {
    t.exports = l();
  })(Wo, () => (
    /******/
    (() => {
      var a = [
        ,
        /* 1 */
        /***/
        (b, L, E) => {
          E.r(L), E.d(L, {
            /* harmony export */
            default: () => M
            /* harmony export */
          });
          var A = (() => {
            var I = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
            return function(O = {}) {
              var h = O, X, Z;
              h.ready = new Promise((n, e) => {
                X = n, Z = e;
              });
              function K() {
                function n(P) {
                  const w = c;
                  i = e = 0, c = /* @__PURE__ */ new Map(), w.forEach((_) => {
                    try {
                      _(P);
                    } catch (T) {
                      console.error(T);
                    }
                  }), this.Qa(), p && p.nb();
                }
                let e = 0, i = 0, c = /* @__PURE__ */ new Map(), p = null, v = null;
                this.requestAnimationFrame = function(P) {
                  e || (e = requestAnimationFrame(n.bind(this)));
                  const w = ++i;
                  return c.set(w, P), w;
                }, this.cancelAnimationFrame = function(P) {
                  c.delete(P), e && c.size == 0 && (cancelAnimationFrame(e), e = 0);
                }, this.lb = function(P) {
                  v && (document.body.remove(v), v = null), P || (v = document.createElement("div"), v.style.backgroundColor = "black", v.style.position = "fixed", v.style.right = 0, v.style.top = 0, v.style.color = "white", v.style.padding = "4px", v.innerHTML = "RIVE FPS", P = function(w) {
                    v.innerHTML = "RIVE FPS " + w.toFixed(1);
                  }, document.body.appendChild(v)), p = new function() {
                    let w = 0, _ = 0;
                    this.nb = function() {
                      var T = performance.now();
                      _ ? (++w, T -= _, 1e3 < T && (P(1e3 * w / T), w = _ = 0)) : (_ = T, w = 0);
                    };
                  }();
                }, this.ib = function() {
                  v && (document.body.remove(v), v = null), p = null;
                }, this.Qa = function() {
                };
              }
              function ce(n) {
                console.assert(!0);
                const e = /* @__PURE__ */ new Map();
                let i = -1 / 0;
                this.push = function(c) {
                  return c = c + ((1 << n) - 1) >> n, e.has(c) && clearTimeout(e.get(c)), e.set(c, setTimeout(function() {
                    e.delete(c), e.length == 0 ? i = -1 / 0 : c == i && (i = Math.max(...e.keys()), console.assert(i < c));
                  }, 1e3)), i = Math.max(c, i), i << n;
                };
              }
              const x = new function() {
                function n() {
                  if (!e) {
                    let Te = function(Oe, ae, he) {
                      if (ae = $.createShader(ae), $.shaderSource(ae, he), $.compileShader(ae), he = $.getShaderInfoLog(ae), 0 < he.length)
                        throw he;
                      $.attachShader(Oe, ae);
                    };
                    var V = document.createElement("canvas"), oe = { alpha: 1, depth: 0, stencil: 0, antialias: 0, premultipliedAlpha: 1, preserveDrawingBuffer: 0, preferLowPowerToHighPerformance: 0, failIfMajorPerformanceCaveat: 0, enableExtensionsByDefault: 1, explicitSwapControl: 1, renderViaOffscreenBackBuffer: 1 };
                    let $ = V.getContext("webgl2", oe);
                    if ($)
                      i = 2;
                    else if ($ = V.getContext("webgl", oe))
                      i = 1;
                    else
                      return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                    if (c = Math.min(
                      $.getParameter($.MAX_RENDERBUFFER_SIZE),
                      $.getParameter($.MAX_TEXTURE_SIZE)
                    ), V = $.createProgram(), Te(V, $.VERTEX_SHADER, `attribute vec2 vertex;
                attribute vec2 uv;
                uniform vec4 mat;
                uniform vec2 translate;
                varying vec2 st;
                void main() {
                    st = uv;
                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);
                }`), Te(V, $.FRAGMENT_SHADER, `precision highp float;
                uniform sampler2D image;
                varying vec2 st;
                void main() {
                    gl_FragColor = texture2D(image, st);
                }`), $.bindAttribLocation(V, 0, "vertex"), $.bindAttribLocation(V, 1, "uv"), $.linkProgram(V), oe = $.getProgramInfoLog(V), 0 < oe.trim().length)
                      throw oe;
                    p = $.getUniformLocation(V, "mat"), v = $.getUniformLocation(V, "translate"), $.useProgram(V), $.bindBuffer($.ARRAY_BUFFER, $.createBuffer()), $.enableVertexAttribArray(0), $.enableVertexAttribArray(1), $.bindBuffer($.ELEMENT_ARRAY_BUFFER, $.createBuffer()), $.uniform1i($.getUniformLocation(V, "image"), 0), $.pixelStorei($.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), e = $;
                  }
                  return !0;
                }
                let e = null, i = 0, c = 0, p = null, v = null, P = 0, w = 0;
                this.wb = function() {
                  return n(), c;
                }, this.gb = function(V) {
                  if (!n())
                    return null;
                  const oe = e.createTexture();
                  return e.bindTexture(e.TEXTURE_2D, oe), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, V), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), i == 2 ? (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR_MIPMAP_LINEAR), e.generateMipmap(e.TEXTURE_2D)) : e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), oe;
                };
                const _ = new ce(8), T = new ce(8), W = new ce(10), H = new ce(10);
                this.kb = function(V, oe, $, Te, Oe) {
                  if (n()) {
                    var ae = _.push(V), he = T.push(oe);
                    (e.canvas.width != ae || e.canvas.height != he) && (e.canvas.width = ae, e.canvas.height = he), e.viewport(0, he - oe, V, oe), e.disable(e.SCISSOR_TEST), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), e.enable(e.SCISSOR_TEST), $.sort((me, ut) => ut.Ua - me.Ua), ae = W.push(Te), P != ae && (e.bufferData(e.ARRAY_BUFFER, 8 * ae, e.DYNAMIC_DRAW), P = ae), ae = 0;
                    for (var Me of $)
                      e.bufferSubData(e.ARRAY_BUFFER, ae, Me.Da), ae += 4 * Me.Da.length;
                    console.assert(ae == 4 * Te);
                    for (var Xe of $)
                      e.bufferSubData(e.ARRAY_BUFFER, ae, Xe.Xa), ae += 4 * Xe.Xa.length;
                    console.assert(ae == 8 * Te), ae = H.push(Oe), w != ae && (e.bufferData(e.ELEMENT_ARRAY_BUFFER, 2 * ae, e.DYNAMIC_DRAW), w = ae), Me = 0;
                    for (var ot of $)
                      e.bufferSubData(
                        e.ELEMENT_ARRAY_BUFFER,
                        Me,
                        ot.indices
                      ), Me += 2 * ot.indices.length;
                    console.assert(Me == 2 * Oe), ot = 0, Xe = !0, ae = Me = 0;
                    for (const me of $) {
                      me.image.za != ot && (e.bindTexture(e.TEXTURE_2D, me.image.cb || null), ot = me.image.za), me.zb ? (e.scissor(me.Ia, he - me.Ja - me.Pa, me.Gb, me.Pa), Xe = !0) : Xe && (e.scissor(0, he - oe, V, oe), Xe = !1), $ = 2 / V;
                      const ut = -2 / oe;
                      e.uniform4f(p, me.oa[0] * $ * me.va, me.oa[1] * ut * me.wa, me.oa[2] * $ * me.va, me.oa[3] * ut * me.wa), e.uniform2f(v, me.oa[4] * $ * me.va + $ * (me.Ia - me.xb * me.va) - 1, me.oa[5] * ut * me.wa + ut * (me.Ja - me.yb * me.wa) + 1), e.vertexAttribPointer(0, 2, e.FLOAT, !1, 0, ae), e.vertexAttribPointer(
                        1,
                        2,
                        e.FLOAT,
                        !1,
                        0,
                        ae + 4 * Te
                      ), e.drawElements(e.TRIANGLES, me.indices.length, e.UNSIGNED_SHORT, Me), ae += 4 * me.Da.length, Me += 2 * me.indices.length;
                    }
                    console.assert(ae == 4 * Te), console.assert(Me == 2 * Oe);
                  }
                }, this.canvas = function() {
                  return n() && e.canvas;
                };
              }();
              h.onRuntimeInitialized = function() {
                function n(z) {
                  switch (z) {
                    case T.srcOver:
                      return "source-over";
                    case T.screen:
                      return "screen";
                    case T.overlay:
                      return "overlay";
                    case T.darken:
                      return "darken";
                    case T.lighten:
                      return "lighten";
                    case T.colorDodge:
                      return "color-dodge";
                    case T.colorBurn:
                      return "color-burn";
                    case T.hardLight:
                      return "hard-light";
                    case T.softLight:
                      return "soft-light";
                    case T.difference:
                      return "difference";
                    case T.exclusion:
                      return "exclusion";
                    case T.multiply:
                      return "multiply";
                    case T.hue:
                      return "hue";
                    case T.saturation:
                      return "saturation";
                    case T.color:
                      return "color";
                    case T.luminosity:
                      return "luminosity";
                  }
                }
                function e(z) {
                  return "rgba(" + ((16711680 & z) >>> 16) + "," + ((65280 & z) >>> 8) + "," + ((255 & z) >>> 0) + "," + ((4278190080 & z) >>> 24) / 255 + ")";
                }
                function i() {
                  0 < Me.length && (x.kb(he.drawWidth(), he.drawHeight(), Me, Xe, ot), Me = [], ot = Xe = 0, he.reset(512, 512));
                  for (const z of ae) {
                    for (const re of z.da)
                      re();
                    z.da = [];
                  }
                  ae.clear();
                }
                var c = h.RenderPaintStyle;
                const p = h.RenderPath, v = h.RenderPaint, P = h.Renderer, w = h.StrokeCap, _ = h.StrokeJoin, T = h.BlendMode, W = c.fill, H = c.stroke, V = h.FillRule.evenOdd;
                let oe = 1;
                var $ = h.RenderImage.extend("CanvasRenderImage", { __construct: function() {
                  this.__parent.__construct.call(this), this.za = oe, oe = oe + 1 & 2147483647 || 1;
                }, decode: function(z) {
                  let re = wn;
                  re.total++;
                  var Le = this, ge = new Image();
                  ge.src = URL.createObjectURL(new Blob([z], { type: "image/png" })), ge.onload = function() {
                    if (Le.ab = ge, Le.cb = x.gb(ge), Le.size(ge.width, ge.height), re.loaded++, re.loaded === re.total) {
                      const Se = re.ready;
                      Se && (Se(), re.ready = null);
                    }
                  };
                } }), Te = p.extend("CanvasRenderPath", { __construct: function() {
                  this.__parent.__construct.call(this), this.ia = new Path2D();
                }, rewind: function() {
                  this.ia = new Path2D();
                }, addPath: function(z, re, Le, ge, Se, _e, ye) {
                  var be = this.ia, qe = be.addPath;
                  z = z.ia;
                  const ze = new DOMMatrix();
                  ze.a = re, ze.b = Le, ze.c = ge, ze.d = Se, ze.e = _e, ze.f = ye, qe.call(be, z, ze);
                }, fillRule: function(z) {
                  this.Ga = z;
                }, moveTo: function(z, re) {
                  this.ia.moveTo(z, re);
                }, lineTo: function(z, re) {
                  this.ia.lineTo(z, re);
                }, cubicTo: function(z, re, Le, ge, Se, _e) {
                  this.ia.bezierCurveTo(z, re, Le, ge, Se, _e);
                }, close: function() {
                  this.ia.closePath();
                } }), Oe = v.extend("CanvasRenderPaint", {
                  color: function(z) {
                    this.Ha = e(z);
                  },
                  thickness: function(z) {
                    this.eb = z;
                  },
                  join: function(z) {
                    switch (z) {
                      case _.miter:
                        this.ya = "miter";
                        break;
                      case _.round:
                        this.ya = "round";
                        break;
                      case _.bevel:
                        this.ya = "bevel";
                    }
                  },
                  cap: function(z) {
                    switch (z) {
                      case w.butt:
                        this.xa = "butt";
                        break;
                      case w.round:
                        this.xa = "round";
                        break;
                      case w.square:
                        this.xa = "square";
                    }
                  },
                  style: function(z) {
                    this.bb = z;
                  },
                  blendMode: function(z) {
                    this.$a = n(z);
                  },
                  clearGradient: function() {
                    this.qa = null;
                  },
                  linearGradient: function(z, re, Le, ge) {
                    this.qa = { Va: z, Wa: re, La: Le, Ma: ge, Ca: [] };
                  },
                  radialGradient: function(z, re, Le, ge) {
                    this.qa = { Va: z, Wa: re, La: Le, Ma: ge, Ca: [], ub: !0 };
                  },
                  addStop: function(z, re) {
                    this.qa.Ca.push({ color: z, stop: re });
                  },
                  completeGradient: function() {
                  },
                  draw: function(z, re, Le) {
                    let ge = this.bb;
                    var Se = this.Ha, _e = this.qa;
                    if (z.globalCompositeOperation = this.$a, _e != null) {
                      Se = _e.Va;
                      var ye = _e.Wa;
                      const qe = _e.La;
                      var be = _e.Ma;
                      const ze = _e.Ca;
                      _e.ub ? (_e = qe - Se, be -= ye, Se = z.createRadialGradient(Se, ye, 0, Se, ye, Math.sqrt(_e * _e + be * be))) : Se = z.createLinearGradient(Se, ye, qe, be);
                      for (let Je = 0, je = ze.length; Je < je; Je++)
                        ye = ze[Je], Se.addColorStop(ye.stop, e(ye.color));
                      this.Ha = Se, this.qa = null;
                    }
                    switch (ge) {
                      case H:
                        z.strokeStyle = Se, z.lineWidth = this.eb, z.lineCap = this.xa, z.lineJoin = this.ya, z.stroke(re);
                        break;
                      case W:
                        z.fillStyle = Se, z.fill(re, Le);
                    }
                  }
                });
                const ae = /* @__PURE__ */ new Set();
                let he = null, Me = [], Xe = 0, ot = 0;
                var me = h.CanvasRenderer = P.extend("Renderer", {
                  __construct: function(z) {
                    this.__parent.__construct.call(this), this.ha = [1, 0, 0, 1, 0, 0], this.ba = z.getContext("2d"), this.Fa = z, this.da = [];
                  },
                  save: function() {
                    this.ha.push(...this.ha.slice(this.ha.length - 6)), this.da.push(this.ba.save.bind(this.ba));
                  },
                  restore: function() {
                    const z = this.ha.length - 6;
                    if (6 > z)
                      throw "restore() called without matching save().";
                    this.ha.splice(z), this.da.push(this.ba.restore.bind(this.ba));
                  },
                  transform: function(z, re, Le, ge, Se, _e) {
                    const ye = this.ha, be = ye.length - 6;
                    ye.splice(be, 6, ye[be] * z + ye[be + 2] * re, ye[be + 1] * z + ye[be + 3] * re, ye[be] * Le + ye[be + 2] * ge, ye[be + 1] * Le + ye[be + 3] * ge, ye[be] * Se + ye[be + 2] * _e + ye[be + 4], ye[be + 1] * Se + ye[be + 3] * _e + ye[be + 5]), this.da.push(this.ba.transform.bind(this.ba, z, re, Le, ge, Se, _e));
                  },
                  rotate: function(z) {
                    const re = Math.sin(z);
                    z = Math.cos(z), this.transform(z, re, -re, z, 0, 0);
                  },
                  _drawPath: function(z, re) {
                    this.da.push(re.draw.bind(re, this.ba, z.ia, z.Ga === V ? "evenodd" : "nonzero"));
                  },
                  drawImage: function(z, ...re) {
                    var Le = this.ba;
                    this.da.push(function() {
                      Le.drawImage(z, ...re);
                    });
                  },
                  _drawRiveImage: function(z, re, Le) {
                    var ge = z.ab;
                    if (ge) {
                      var Se = this.ba, _e = n(re);
                      this.da.push(function() {
                        Se.globalCompositeOperation = _e, Se.globalAlpha = Le, Se.drawImage(ge, 0, 0), Se.globalAlpha = 1;
                      });
                    }
                  },
                  _getMatrix: function(z) {
                    const re = this.ha, Le = re.length - 6;
                    for (let ge = 0; 6 > ge; ++ge)
                      z[ge] = re[Le + ge];
                  },
                  _drawImageMesh: function(z, re, Le, ge, Se, _e, ye, be, qe, ze) {
                    var Je = this.ba.canvas.width, je = this.ba.canvas.height;
                    const _r = qe - ye, xr = ze - be;
                    ye = Math.max(ye, 0), be = Math.max(be, 0), qe = Math.min(qe, Je), ze = Math.min(
                      ze,
                      je
                    );
                    const At = qe - ye, It = ze - be;
                    if (console.assert(At <= Math.min(_r, Je)), console.assert(It <= Math.min(xr, je)), !(0 >= At || 0 >= It)) {
                      qe = At < _r || It < xr, Je = ze = 1;
                      var ft = Math.ceil(At * ze), dt = Math.ceil(It * Je);
                      je = x.wb(), ft > je && (ze *= je / ft, ft = je), dt > je && (Je *= je / dt, dt = je), he || (he = new h.DynamicRectanizer(je), he.reset(512, 512)), je = he.addRect(ft, dt), 0 > je && (i(), ae.add(this), je = he.addRect(ft, dt), console.assert(0 <= je));
                      var Er = je & 65535, Or = je >> 16;
                      Me.push({
                        oa: this.ha.slice(this.ha.length - 6),
                        image: z,
                        Ia: Er,
                        Ja: Or,
                        xb: ye,
                        yb: be,
                        Gb: ft,
                        Pa: dt,
                        va: ze,
                        wa: Je,
                        Da: new Float32Array(ge),
                        Xa: new Float32Array(Se),
                        indices: new Uint16Array(_e),
                        zb: qe,
                        Ua: z.za << 1 | (qe ? 1 : 0)
                      }), Xe += ge.length, ot += _e.length;
                      var Lt = this.ba, jo = n(re);
                      this.da.push(function() {
                        Lt.save(), Lt.resetTransform(), Lt.globalCompositeOperation = jo, Lt.globalAlpha = Le, Lt.drawImage(x.canvas(), Er, Or, ft, dt, ye, be, At, It), Lt.restore();
                      });
                    }
                  },
                  _clipPath: function(z) {
                    this.da.push(this.ba.clip.bind(this.ba, z.ia, z.Ga === V ? "evenodd" : "nonzero"));
                  },
                  clear: function() {
                    ae.add(this), this.da.push(this.ba.clearRect.bind(this.ba, 0, 0, this.Fa.width, this.Fa.height));
                  },
                  flush: function() {
                  },
                  translate: function(z, re) {
                    this.transform(1, 0, 0, 1, z, re);
                  }
                });
                h.makeRenderer = function(z) {
                  return new me(z);
                }, h.renderFactory = { makeRenderPaint: function() {
                  return new Oe();
                }, makeRenderPath: function() {
                  return new Te();
                }, makeRenderImage: function() {
                  return new $();
                } };
                let ut = h.load, wn = null;
                h.load = function(z) {
                  return new Promise(function(re) {
                    let Le = null;
                    wn = { total: 0, loaded: 0, ready: function() {
                      re(Le);
                    } }, Le = ut(z), wn.total == 0 && re(Le);
                  });
                }, c = new K(), h.requestAnimationFrame = c.requestAnimationFrame.bind(c), h.cancelAnimationFrame = c.cancelAnimationFrame.bind(c), h.enableFPSCounter = c.lb.bind(c), h.disableFPSCounter = c.ib, c.Qa = i, h.cleanup = function() {
                  he && he.delete();
                };
              };
              var F = Object.assign({}, h), B = "./this.program", y = typeof window == "object", D = typeof importScripts == "function", U = "", ue, de;
              (y || D) && (D ? U = self.location.href : typeof document < "u" && document.currentScript && (U = document.currentScript.src), I && (U = I), U.indexOf("blob:") !== 0 ? U = U.substr(0, U.replace(/[?#].*/, "").lastIndexOf("/") + 1) : U = "", D && (de = (n) => {
                var e = new XMLHttpRequest();
                return e.open("GET", n, !1), e.responseType = "arraybuffer", e.send(null), new Uint8Array(e.response);
              }), ue = (n, e, i) => {
                var c = new XMLHttpRequest();
                c.open("GET", n, !0), c.responseType = "arraybuffer", c.onload = () => {
                  c.status == 200 || c.status == 0 && c.response ? e(c.response) : i();
                }, c.onerror = i, c.send(null);
              });
              var ie = h.print || console.log.bind(console), te = h.printErr || console.error.bind(console);
              Object.assign(h, F), F = null, h.thisProgram && (B = h.thisProgram);
              var f;
              h.wasmBinary && (f = h.wasmBinary), h.noExitRuntime, typeof WebAssembly != "object" && N("no native wasm support detected");
              var r, u, g = !1, S, R, k, ee, C, m, Y, G;
              function J() {
                var n = r.buffer;
                h.HEAP8 = S = new Int8Array(n), h.HEAP16 = k = new Int16Array(n), h.HEAP32 = C = new Int32Array(n), h.HEAPU8 = R = new Uint8Array(n), h.HEAPU16 = ee = new Uint16Array(n), h.HEAPU32 = m = new Uint32Array(n), h.HEAPF32 = Y = new Float32Array(n), h.HEAPF64 = G = new Float64Array(n);
              }
              var q, Q = [], ne = [], pe = [];
              function ve() {
                var n = h.preRun.shift();
                Q.unshift(n);
              }
              var se = 0, xe = null;
              function N(n) {
                throw h.onAbort && h.onAbort(n), n = "Aborted(" + n + ")", te(n), g = !0, n = new WebAssembly.RuntimeError(n + ". Build with -sASSERTIONS for more info."), Z(n), n;
              }
              function Fe(n) {
                return n.startsWith("data:application/octet-stream;base64,");
              }
              var ke;
              if (ke = "canvas_advanced.wasm", !Fe(ke)) {
                var Ae = ke;
                ke = h.locateFile ? h.locateFile(Ae, U) : U + Ae;
              }
              function Ie(n) {
                if (n == ke && f)
                  return new Uint8Array(f);
                if (de)
                  return de(n);
                throw "both async and sync fetching of the wasm failed";
              }
              function Ue(n) {
                if (!f && (y || D)) {
                  if (typeof fetch == "function" && !n.startsWith("file://"))
                    return fetch(n, { credentials: "same-origin" }).then((e) => {
                      if (!e.ok)
                        throw "failed to load wasm binary file at '" + n + "'";
                      return e.arrayBuffer();
                    }).catch(() => Ie(n));
                  if (ue)
                    return new Promise((e, i) => {
                      ue(n, (c) => e(new Uint8Array(c)), i);
                    });
                }
                return Promise.resolve().then(() => Ie(n));
              }
              function $e(n, e, i) {
                return Ue(n).then((c) => WebAssembly.instantiate(c, e)).then((c) => c).then(i, (c) => {
                  te("failed to asynchronously prepare wasm: " + c), N(c);
                });
              }
              function Ne(n, e) {
                var i = ke;
                return f || typeof WebAssembly.instantiateStreaming != "function" || Fe(i) || i.startsWith("file://") || typeof fetch != "function" ? $e(i, n, e) : fetch(i, { credentials: "same-origin" }).then((c) => WebAssembly.instantiateStreaming(c, n).then(e, function(p) {
                  return te("wasm streaming compile failed: " + p), te("falling back to ArrayBuffer instantiation"), $e(i, n, e);
                }));
              }
              var at = (n) => {
                for (; 0 < n.length; )
                  n.shift()(h);
              };
              function sr(n) {
                if (n === void 0)
                  return "_unknown";
                n = n.replace(/[^a-zA-Z0-9_]/g, "$");
                var e = n.charCodeAt(0);
                return 48 <= e && 57 >= e ? `_${n}` : n;
              }
              function $t(n, e) {
                return n = sr(n), { [n]: function() {
                  return e.apply(this, arguments);
                } }[n];
              }
              function cr() {
                this.ja = [void 0], this.Oa = [];
              }
              var He = new cr(), bt = void 0;
              function le(n) {
                throw new bt(n);
              }
              var st = (n) => (n || le("Cannot use deleted val. handle = " + n), He.get(n).value), Ke = (n) => {
                switch (n) {
                  case void 0:
                    return 1;
                  case null:
                    return 2;
                  case !0:
                    return 3;
                  case !1:
                    return 4;
                  default:
                    return He.Ya({ Ta: 1, value: n });
                }
              };
              function ur(n) {
                var e = Error, i = $t(n, function(c) {
                  this.name = n, this.message = c, c = Error(c).stack, c !== void 0 && (this.stack = this.toString() + `
` + c.replace(/^Error(:[^\n]*)?\n/, ""));
                });
                return i.prototype = Object.create(e.prototype), i.prototype.constructor = i, i.prototype.toString = function() {
                  return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
                }, i;
              }
              var lr = void 0, fr = void 0;
              function Ee(n) {
                for (var e = ""; R[n]; )
                  e += fr[R[n++]];
                return e;
              }
              var xt = [];
              function ln() {
                for (; xt.length; ) {
                  var n = xt.pop();
                  n.W.na = !1, n.delete();
                }
              }
              var Et = void 0, et = {};
              function fn(n, e) {
                for (e === void 0 && le("ptr should not be undefined"); n.$; )
                  e = n.ra(e), n = n.$;
                return e;
              }
              var lt = {};
              function dr(n) {
                n = Br(n);
                var e = Ee(n);
                return rt(n), e;
              }
              function Ot(n, e) {
                var i = lt[n];
                return i === void 0 && le(e + " has unknown type " + dr(n)), i;
              }
              function Dt() {
              }
              var dn = !1;
              function hr(n) {
                --n.count.value, n.count.value === 0 && (n.ca ? n.fa.ka(n.ca) : n.Z.X.ka(n.Y));
              }
              function pr(n, e, i) {
                return e === i ? n : i.$ === void 0 ? null : (n = pr(n, e, i.$), n === null ? null : i.jb(n));
              }
              var vr = {};
              function mo(n, e) {
                return e = fn(n, e), et[e];
              }
              var mr = void 0;
              function Nt(n) {
                throw new mr(n);
              }
              function Yt(n, e) {
                return e.Z && e.Y || Nt("makeClassHandle requires ptr and ptrType"), !!e.fa != !!e.ca && Nt("Both smartPtrType and smartPtr must be specified"), e.count = { value: 1 }, Ct(Object.create(n, { W: { value: e } }));
              }
              function Ct(n) {
                return typeof FinalizationRegistry > "u" ? (Ct = (e) => e, n) : (dn = new FinalizationRegistry((e) => {
                  hr(e.W);
                }), Ct = (e) => {
                  var i = e.W;
                  return i.ca && dn.register(e, { W: i }, e), e;
                }, Dt = (e) => {
                  dn.unregister(e);
                }, Ct(n));
              }
              var Xt = {};
              function Mt(n) {
                for (; n.length; ) {
                  var e = n.pop();
                  n.pop()(e);
                }
              }
              function kt(n) {
                return this.fromWireType(C[n >> 2]);
              }
              var wt = {}, Ut = {};
              function Ye(n, e, i) {
                function c(w) {
                  w = i(w), w.length !== n.length && Nt("Mismatched type converter count");
                  for (var _ = 0; _ < n.length; ++_)
                    Ze(n[_], w[_]);
                }
                n.forEach(function(w) {
                  Ut[w] = e;
                });
                var p = Array(e.length), v = [], P = 0;
                e.forEach((w, _) => {
                  lt.hasOwnProperty(w) ? p[_] = lt[w] : (v.push(w), wt.hasOwnProperty(w) || (wt[w] = []), wt[w].push(() => {
                    p[_] = lt[w], ++P, P === v.length && c(p);
                  }));
                }), v.length === 0 && c(p);
              }
              function Ht(n) {
                switch (n) {
                  case 1:
                    return 0;
                  case 2:
                    return 1;
                  case 4:
                    return 2;
                  case 8:
                    return 3;
                  default:
                    throw new TypeError(`Unknown type size: ${n}`);
                }
              }
              function yo(n, e, i = {}) {
                var c = e.name;
                if (n || le(`type "${c}" must have a positive integer typeid pointer`), lt.hasOwnProperty(n)) {
                  if (i.tb)
                    return;
                  le(`Cannot register type '${c}' twice`);
                }
                lt[n] = e, delete Ut[n], wt.hasOwnProperty(n) && (e = wt[n], delete wt[n], e.forEach((p) => p()));
              }
              function Ze(n, e, i = {}) {
                if (!("argPackAdvance" in e))
                  throw new TypeError("registerType registeredInstance requires argPackAdvance");
                yo(n, e, i);
              }
              function hn(n) {
                le(n.W.Z.X.name + " instance already deleted");
              }
              function ct() {
              }
              function pn(n, e, i) {
                if (n[e].aa === void 0) {
                  var c = n[e];
                  n[e] = function() {
                    return n[e].aa.hasOwnProperty(arguments.length) || le(`Function '${i}' called with an invalid number of arguments (${arguments.length}) - expects one of (${n[e].aa})!`), n[e].aa[arguments.length].apply(this, arguments);
                  }, n[e].aa = [], n[e].aa[c.ma] = c;
                }
              }
              function vn(n, e, i) {
                h.hasOwnProperty(n) ? ((i === void 0 || h[n].aa !== void 0 && h[n].aa[i] !== void 0) && le(`Cannot register public name '${n}' twice`), pn(h, n, n), h.hasOwnProperty(i) && le(`Cannot register multiple overloads of a function with the same number of arguments (${i})!`), h[n].aa[i] = e) : (h[n] = e, i !== void 0 && (h[n].Hb = i));
              }
              function go(n, e, i, c, p, v, P, w) {
                this.name = n, this.constructor = e, this.ga = i, this.ka = c, this.$ = p, this.ob = v, this.ra = P, this.jb = w, this.Ra = [];
              }
              function qt(n, e, i) {
                for (; e !== i; )
                  e.ra || le(`Expected null or instance of ${i.name}, got an instance of ${e.name}`), n = e.ra(n), e = e.$;
                return n;
              }
              function bo(n, e) {
                return e === null ? (this.Aa && le(`null is not a valid ${this.name}`), 0) : (e.W || le(`Cannot pass "${yn(e)}" as a ${this.name}`), e.W.Y || le(`Cannot pass deleted object as a pointer of type ${this.name}`), qt(e.W.Y, e.W.Z.X, this.X));
              }
              function Co(n, e) {
                if (e === null) {
                  if (this.Aa && le(`null is not a valid ${this.name}`), this.ua) {
                    var i = this.Ba();
                    return n !== null && n.push(this.ka, i), i;
                  }
                  return 0;
                }
                if (e.W || le(`Cannot pass "${yn(e)}" as a ${this.name}`), e.W.Y || le(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.ta && e.W.Z.ta && le(`Cannot convert argument of type ${e.W.fa ? e.W.fa.name : e.W.Z.name} to parameter type ${this.name}`), i = qt(e.W.Y, e.W.Z.X, this.X), this.ua)
                  switch (e.W.ca === void 0 && le("Passing raw pointer to smart pointer is illegal"), this.Fb) {
                    case 0:
                      e.W.fa === this ? i = e.W.ca : le(`Cannot convert argument of type ${e.W.fa ? e.W.fa.name : e.W.Z.name} to parameter type ${this.name}`);
                      break;
                    case 1:
                      i = e.W.ca;
                      break;
                    case 2:
                      if (e.W.fa === this)
                        i = e.W.ca;
                      else {
                        var c = e.clone();
                        i = this.Bb(i, Ke(function() {
                          c.delete();
                        })), n !== null && n.push(this.ka, i);
                      }
                      break;
                    default:
                      le("Unsupporting sharing policy");
                  }
                return i;
              }
              function wo(n, e) {
                return e === null ? (this.Aa && le(`null is not a valid ${this.name}`), 0) : (e.W || le(`Cannot pass "${yn(e)}" as a ${this.name}`), e.W.Y || le(`Cannot pass deleted object as a pointer of type ${this.name}`), e.W.Z.ta && le(`Cannot convert argument of type ${e.W.Z.name} to parameter type ${this.name}`), qt(e.W.Y, e.W.Z.X, this.X));
              }
              function tt(n, e, i, c) {
                this.name = n, this.X = e, this.Aa = i, this.ta = c, this.ua = !1, this.ka = this.Bb = this.Ba = this.Sa = this.Fb = this.Ab = void 0, e.$ !== void 0 ? this.toWireType = Co : (this.toWireType = c ? bo : wo, this.ea = null);
              }
              function yr(n, e, i) {
                h.hasOwnProperty(n) || Nt("Replacing nonexistant public symbol"), h[n].aa !== void 0 && i !== void 0 ? h[n].aa[i] = e : (h[n] = e, h[n].ma = i);
              }
              var Lo = (n, e) => {
                var i = [];
                return function() {
                  if (i.length = 0, Object.assign(i, arguments), n.includes("j")) {
                    var c = h["dynCall_" + n];
                    c = i && i.length ? c.apply(null, [e].concat(i)) : c.call(null, e);
                  } else
                    c = q.get(e).apply(null, i);
                  return c;
                };
              };
              function We(n, e) {
                n = Ee(n);
                var i = n.includes("j") ? Lo(n, e) : q.get(e);
                return typeof i != "function" && le(`unknown function pointer with signature ${n}: ${e}`), i;
              }
              var gr = void 0;
              function nt(n, e) {
                function i(v) {
                  p[v] || lt[v] || (Ut[v] ? Ut[v].forEach(i) : (c.push(v), p[v] = !0));
                }
                var c = [], p = {};
                throw e.forEach(i), new gr(`${n}: ` + c.map(dr).join([", "]));
              }
              function Vt(n, e, i, c, p) {
                var v = e.length;
                2 > v && le("argTypes array size mismatch! Must at least get return value and 'this' types!");
                var P = e[1] !== null && i !== null, w = !1;
                for (i = 1; i < e.length; ++i)
                  if (e[i] !== null && e[i].ea === void 0) {
                    w = !0;
                    break;
                  }
                var _ = e[0].name !== "void", T = v - 2, W = Array(T), H = [], V = [];
                return function() {
                  if (arguments.length !== T && le(`function ${n} called with ${arguments.length} arguments, expected ${T} args!`), V.length = 0, H.length = P ? 2 : 1, H[0] = p, P) {
                    var oe = e[1].toWireType(V, this);
                    H[1] = oe;
                  }
                  for (var $ = 0; $ < T; ++$)
                    W[$] = e[$ + 2].toWireType(V, arguments[$]), H.push(W[$]);
                  if ($ = c.apply(null, H), w)
                    Mt(V);
                  else
                    for (var Te = P ? 1 : 2; Te < e.length; Te++) {
                      var Oe = Te === 1 ? oe : W[Te - 2];
                      e[Te].ea !== null && e[Te].ea(Oe);
                    }
                  return oe = _ ? e[0].fromWireType($) : void 0, oe;
                };
              }
              function Gt(n, e) {
                for (var i = [], c = 0; c < n; c++)
                  i.push(m[e + 4 * c >> 2]);
                return i;
              }
              function br(n, e, i) {
                return n instanceof Object || le(`${i} with invalid "this": ${n}`), n instanceof e.X.constructor || le(`${i} incompatible with "this" of type ${n.constructor.name}`), n.W.Y || le(`cannot call emscripten binding method ${i} on deleted object`), qt(n.W.Y, n.W.Z.X, e.X);
              }
              function mn(n) {
                n >= He.Ea && --He.get(n).Ta === 0 && He.Za(n);
              }
              function So(n, e, i) {
                switch (e) {
                  case 0:
                    return function(c) {
                      return this.fromWireType((i ? S : R)[c]);
                    };
                  case 1:
                    return function(c) {
                      return this.fromWireType((i ? k : ee)[c >> 1]);
                    };
                  case 2:
                    return function(c) {
                      return this.fromWireType((i ? C : m)[c >> 2]);
                    };
                  default:
                    throw new TypeError("Unknown integer type: " + n);
                }
              }
              function yn(n) {
                if (n === null)
                  return "null";
                var e = typeof n;
                return e === "object" || e === "array" || e === "function" ? n.toString() : "" + n;
              }
              function Po(n, e) {
                switch (e) {
                  case 2:
                    return function(i) {
                      return this.fromWireType(Y[i >> 2]);
                    };
                  case 3:
                    return function(i) {
                      return this.fromWireType(G[i >> 3]);
                    };
                  default:
                    throw new TypeError("Unknown float type: " + n);
                }
              }
              function To(n, e, i) {
                switch (e) {
                  case 0:
                    return i ? function(c) {
                      return S[c];
                    } : function(c) {
                      return R[c];
                    };
                  case 1:
                    return i ? function(c) {
                      return k[c >> 1];
                    } : function(c) {
                      return ee[c >> 1];
                    };
                  case 2:
                    return i ? function(c) {
                      return C[c >> 2];
                    } : function(c) {
                      return m[c >> 2];
                    };
                  default:
                    throw new TypeError("Unknown integer type: " + n);
                }
              }
              var Cr = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, wr = (n, e, i) => {
                var c = e + i;
                for (i = e; n[i] && !(i >= c); )
                  ++i;
                if (16 < i - e && n.buffer && Cr)
                  return Cr.decode(n.subarray(e, i));
                for (c = ""; e < i; ) {
                  var p = n[e++];
                  if (p & 128) {
                    var v = n[e++] & 63;
                    if ((p & 224) == 192)
                      c += String.fromCharCode((p & 31) << 6 | v);
                    else {
                      var P = n[e++] & 63;
                      p = (p & 240) == 224 ? (p & 15) << 12 | v << 6 | P : (p & 7) << 18 | v << 12 | P << 6 | n[e++] & 63, 65536 > p ? c += String.fromCharCode(p) : (p -= 65536, c += String.fromCharCode(55296 | p >> 10, 56320 | p & 1023));
                    }
                  } else
                    c += String.fromCharCode(p);
                }
                return c;
              }, Lr = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, Bo = (n, e) => {
                for (var i = n >> 1, c = i + e / 2; !(i >= c) && ee[i]; )
                  ++i;
                if (i <<= 1, 32 < i - n && Lr)
                  return Lr.decode(R.subarray(n, i));
                for (i = "", c = 0; !(c >= e / 2); ++c) {
                  var p = k[n + 2 * c >> 1];
                  if (p == 0)
                    break;
                  i += String.fromCharCode(p);
                }
                return i;
              }, Ro = (n, e, i) => {
                if (i === void 0 && (i = 2147483647), 2 > i)
                  return 0;
                i -= 2;
                var c = e;
                i = i < 2 * n.length ? i / 2 : n.length;
                for (var p = 0; p < i; ++p)
                  k[e >> 1] = n.charCodeAt(p), e += 2;
                return k[e >> 1] = 0, e - c;
              }, _o = (n) => 2 * n.length, xo = (n, e) => {
                for (var i = 0, c = ""; !(i >= e / 4); ) {
                  var p = C[n + 4 * i >> 2];
                  if (p == 0)
                    break;
                  ++i, 65536 <= p ? (p -= 65536, c += String.fromCharCode(55296 | p >> 10, 56320 | p & 1023)) : c += String.fromCharCode(p);
                }
                return c;
              }, Eo = (n, e, i) => {
                if (i === void 0 && (i = 2147483647), 4 > i)
                  return 0;
                var c = e;
                i = c + i - 4;
                for (var p = 0; p < n.length; ++p) {
                  var v = n.charCodeAt(p);
                  if (55296 <= v && 57343 >= v) {
                    var P = n.charCodeAt(++p);
                    v = 65536 + ((v & 1023) << 10) | P & 1023;
                  }
                  if (C[e >> 2] = v, e += 4, e + 4 > i)
                    break;
                }
                return C[e >> 2] = 0, e - c;
              }, Oo = (n) => {
                for (var e = 0, i = 0; i < n.length; ++i) {
                  var c = n.charCodeAt(i);
                  55296 <= c && 57343 >= c && ++i, e += 4;
                }
                return e;
              }, Mo = {};
              function Zt(n) {
                var e = Mo[n];
                return e === void 0 ? Ee(n) : e;
              }
              var Jt = [];
              function ko(n) {
                var e = Jt.length;
                return Jt.push(n), e;
              }
              function Ao(n, e) {
                for (var i = Array(n), c = 0; c < n; ++c)
                  i[c] = Ot(m[e + 4 * c >> 2], "parameter " + c);
                return i;
              }
              var Sr = [], gn = {}, Pr = () => {
                if (!bn) {
                  var n = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: B || "./this.program" }, e;
                  for (e in gn)
                    gn[e] === void 0 ? delete n[e] : n[e] = gn[e];
                  var i = [];
                  for (e in n)
                    i.push(`${e}=${n[e]}`);
                  bn = i;
                }
                return bn;
              }, bn, Io = [null, [], []];
              Object.assign(cr.prototype, { get(n) {
                return this.ja[n];
              }, has(n) {
                return this.ja[n] !== void 0;
              }, Ya(n) {
                var e = this.Oa.pop() || this.ja.length;
                return this.ja[e] = n, e;
              }, Za(n) {
                this.ja[n] = void 0, this.Oa.push(n);
              } }), bt = h.BindingError = class extends Error {
                constructor(n) {
                  super(n), this.name = "BindingError";
                }
              }, He.ja.push({ value: void 0 }, { value: null }, { value: !0 }, { value: !1 }), He.Ea = He.ja.length, h.count_emval_handles = function() {
                for (var n = 0, e = He.Ea; e < He.ja.length; ++e)
                  He.ja[e] !== void 0 && ++n;
                return n;
              }, lr = h.PureVirtualError = ur("PureVirtualError");
              for (var Tr = Array(256), Qt = 0; 256 > Qt; ++Qt)
                Tr[Qt] = String.fromCharCode(Qt);
              fr = Tr, h.getInheritedInstanceCount = function() {
                return Object.keys(et).length;
              }, h.getLiveInheritedInstances = function() {
                var n = [], e;
                for (e in et)
                  et.hasOwnProperty(e) && n.push(et[e]);
                return n;
              }, h.flushPendingDeletes = ln, h.setDelayFunction = function(n) {
                Et = n, xt.length && Et && Et(ln);
              }, mr = h.InternalError = class extends Error {
                constructor(n) {
                  super(n), this.name = "InternalError";
                }
              }, ct.prototype.isAliasOf = function(n) {
                if (!(this instanceof ct && n instanceof ct))
                  return !1;
                var e = this.W.Z.X, i = this.W.Y, c = n.W.Z.X;
                for (n = n.W.Y; e.$; )
                  i = e.ra(i), e = e.$;
                for (; c.$; )
                  n = c.ra(n), c = c.$;
                return e === c && i === n;
              }, ct.prototype.clone = function() {
                if (this.W.Y || hn(this), this.W.pa)
                  return this.W.count.value += 1, this;
                var n = Ct, e = Object, i = e.create, c = Object.getPrototypeOf(this), p = this.W;
                return n = n(i.call(e, c, { W: { value: { count: p.count, na: p.na, pa: p.pa, Y: p.Y, Z: p.Z, ca: p.ca, fa: p.fa } } })), n.W.count.value += 1, n.W.na = !1, n;
              }, ct.prototype.delete = function() {
                this.W.Y || hn(this), this.W.na && !this.W.pa && le("Object already scheduled for deletion"), Dt(this), hr(this.W), this.W.pa || (this.W.ca = void 0, this.W.Y = void 0);
              }, ct.prototype.isDeleted = function() {
                return !this.W.Y;
              }, ct.prototype.deleteLater = function() {
                return this.W.Y || hn(this), this.W.na && !this.W.pa && le("Object already scheduled for deletion"), xt.push(this), xt.length === 1 && Et && Et(ln), this.W.na = !0, this;
              }, tt.prototype.pb = function(n) {
                return this.Sa && (n = this.Sa(n)), n;
              }, tt.prototype.Ka = function(n) {
                this.ka && this.ka(n);
              }, tt.prototype.argPackAdvance = 8, tt.prototype.readValueFromPointer = kt, tt.prototype.deleteObject = function(n) {
                n !== null && n.delete();
              }, tt.prototype.fromWireType = function(n) {
                function e() {
                  return this.ua ? Yt(this.X.ga, { Z: this.Ab, Y: i, fa: this, ca: n }) : Yt(this.X.ga, { Z: this, Y: n });
                }
                var i = this.pb(n);
                if (!i)
                  return this.Ka(n), null;
                var c = mo(this.X, i);
                if (c !== void 0)
                  return c.W.count.value === 0 ? (c.W.Y = i, c.W.ca = n, c.clone()) : (c = c.clone(), this.Ka(n), c);
                if (c = this.X.ob(i), c = vr[c], !c)
                  return e.call(this);
                c = this.ta ? c.fb : c.pointerType;
                var p = pr(i, this.X, c.X);
                return p === null ? e.call(this) : this.ua ? Yt(c.X.ga, { Z: c, Y: p, fa: this, ca: n }) : Yt(c.X.ga, { Z: c, Y: p });
              }, gr = h.UnboundTypeError = ur("UnboundTypeError");
              var zo = {
                I: function(n, e, i) {
                  n = Ee(n), e = Ot(e, "wrapper"), i = st(i);
                  var c = [].slice, p = e.X, v = p.ga, P = p.$.ga, w = p.$.constructor;
                  n = $t(n, function() {
                    p.$.Ra.forEach((function(T) {
                      if (this[T] === P[T])
                        throw new lr(`Pure virtual function ${T} must be implemented in JavaScript`);
                    }).bind(this)), Object.defineProperty(this, "__parent", { value: v }), this.__construct.apply(this, c.call(arguments));
                  }), v.__construct = function() {
                    this === v && le("Pass correct 'this' to __construct");
                    var T = w.implement.apply(void 0, [this].concat(c.call(arguments)));
                    Dt(T);
                    var W = T.W;
                    T.notifyOnDestruction(), W.pa = !0, Object.defineProperties(this, { W: { value: W } }), Ct(this), T = W.Y, T = fn(p, T), et.hasOwnProperty(T) ? le(`Tried to register registered instance: ${T}`) : et[T] = this;
                  }, v.__destruct = function() {
                    this === v && le("Pass correct 'this' to __destruct"), Dt(this);
                    var T = this.W.Y;
                    T = fn(p, T), et.hasOwnProperty(T) ? delete et[T] : le(`Tried to unregister unregistered instance: ${T}`);
                  }, n.prototype = Object.create(v);
                  for (var _ in i)
                    n.prototype[_] = i[_];
                  return Ke(n);
                },
                L: function(n) {
                  var e = Xt[n];
                  delete Xt[n];
                  var i = e.Ba, c = e.ka, p = e.Na, v = p.map((P) => P.sb).concat(p.map((P) => P.Db));
                  Ye([n], v, (P) => {
                    var w = {};
                    return p.forEach((_, T) => {
                      var W = P[T], H = _.qb, V = _.rb, oe = P[T + p.length], $ = _.Cb, Te = _.Eb;
                      w[_.mb] = { read: (Oe) => W.fromWireType(H(V, Oe)), write: (Oe, ae) => {
                        var he = [];
                        $(Te, Oe, oe.toWireType(he, ae)), Mt(he);
                      } };
                    }), [{ name: e.name, fromWireType: function(_) {
                      var T = {}, W;
                      for (W in w)
                        T[W] = w[W].read(_);
                      return c(_), T;
                    }, toWireType: function(_, T) {
                      for (var W in w)
                        if (!(W in T))
                          throw new TypeError(`Missing field: "${W}"`);
                      var H = i();
                      for (W in w)
                        w[W].write(H, T[W]);
                      return _ !== null && _.push(c, H), H;
                    }, argPackAdvance: 8, readValueFromPointer: kt, ea: c }];
                  });
                },
                z: function() {
                },
                G: function(n, e, i, c, p) {
                  var v = Ht(i);
                  e = Ee(e), Ze(n, { name: e, fromWireType: function(P) {
                    return !!P;
                  }, toWireType: function(P, w) {
                    return w ? c : p;
                  }, argPackAdvance: 8, readValueFromPointer: function(P) {
                    if (i === 1)
                      var w = S;
                    else if (i === 2)
                      w = k;
                    else if (i === 4)
                      w = C;
                    else
                      throw new TypeError("Unknown boolean type size: " + e);
                    return this.fromWireType(w[P >> v]);
                  }, ea: null });
                },
                e: function(n, e, i, c, p, v, P, w, _, T, W, H, V) {
                  W = Ee(W), v = We(p, v), w && (w = We(P, w)), T && (T = We(_, T)), V = We(H, V);
                  var oe = sr(W);
                  vn(oe, function() {
                    nt(`Cannot construct ${W} due to unbound types`, [c]);
                  }), Ye([n, e, i], c ? [c] : [], function($) {
                    if ($ = $[0], c)
                      var Te = $.X, Oe = Te.ga;
                    else
                      Oe = ct.prototype;
                    $ = $t(oe, function() {
                      if (Object.getPrototypeOf(this) !== ae)
                        throw new bt("Use 'new' to construct " + W);
                      if (he.la === void 0)
                        throw new bt(W + " has no accessible constructor");
                      var Xe = he.la[arguments.length];
                      if (Xe === void 0)
                        throw new bt(`Tried to invoke ctor of ${W} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(he.la).toString()}) parameters instead!`);
                      return Xe.apply(this, arguments);
                    });
                    var ae = Object.create(Oe, { constructor: { value: $ } });
                    $.prototype = ae;
                    var he = new go(W, $, ae, V, Te, v, w, T);
                    he.$ && (he.$.sa === void 0 && (he.$.sa = []), he.$.sa.push(he)), Te = new tt(W, he, !0, !1), Oe = new tt(W + "*", he, !1, !1);
                    var Me = new tt(W + " const*", he, !1, !0);
                    return vr[n] = { pointerType: Oe, fb: Me }, yr(oe, $), [Te, Oe, Me];
                  });
                },
                k: function(n, e, i, c, p, v, P) {
                  var w = Gt(i, c);
                  e = Ee(e), v = We(p, v), Ye([], [n], function(_) {
                    function T() {
                      nt(`Cannot call ${W} due to unbound types`, w);
                    }
                    _ = _[0];
                    var W = `${_.name}.${e}`;
                    e.startsWith("@@") && (e = Symbol[e.substring(2)]);
                    var H = _.X.constructor;
                    return H[e] === void 0 ? (T.ma = i - 1, H[e] = T) : (pn(H, e, W), H[e].aa[i - 1] = T), Ye([], w, function(V) {
                      if (V = Vt(W, [V[0], null].concat(V.slice(1)), null, v, P), H[e].aa === void 0 ? (V.ma = i - 1, H[e] = V) : H[e].aa[i - 1] = V, _.X.sa)
                        for (const oe of _.X.sa)
                          oe.constructor.hasOwnProperty(e) || (oe.constructor[e] = V);
                      return [];
                    }), [];
                  });
                },
                s: function(n, e, i, c, p, v, P, w) {
                  e = Ee(e), v = We(p, v), Ye([], [n], function(_) {
                    _ = _[0];
                    var T = `${_.name}.${e}`, W = { get() {
                      nt(`Cannot access ${T} due to unbound types`, [i]);
                    }, enumerable: !0, configurable: !0 };
                    return W.set = w ? () => {
                      nt(`Cannot access ${T} due to unbound types`, [i]);
                    } : () => {
                      le(`${T} is a read-only property`);
                    }, Object.defineProperty(_.X.constructor, e, W), Ye([], [i], function(H) {
                      H = H[0];
                      var V = { get() {
                        return H.fromWireType(v(c));
                      }, enumerable: !0 };
                      return w && (w = We(P, w), V.set = (oe) => {
                        var $ = [];
                        w(c, H.toWireType($, oe)), Mt($);
                      }), Object.defineProperty(_.X.constructor, e, V), [];
                    }), [];
                  });
                },
                o: function(n, e, i, c, p, v) {
                  var P = Gt(e, i);
                  p = We(c, p), Ye([], [n], function(w) {
                    w = w[0];
                    var _ = `constructor ${w.name}`;
                    if (w.X.la === void 0 && (w.X.la = []), w.X.la[e - 1] !== void 0)
                      throw new bt(`Cannot register multiple constructors with identical number of parameters (${e - 1}) for class '${w.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                    return w.X.la[e - 1] = () => {
                      nt(`Cannot construct ${w.name} due to unbound types`, P);
                    }, Ye([], P, function(T) {
                      return T.splice(1, 0, null), w.X.la[e - 1] = Vt(_, T, null, p, v), [];
                    }), [];
                  });
                },
                a: function(n, e, i, c, p, v, P, w) {
                  var _ = Gt(i, c);
                  e = Ee(e), v = We(p, v), Ye([], [n], function(T) {
                    function W() {
                      nt(
                        `Cannot call ${H} due to unbound types`,
                        _
                      );
                    }
                    T = T[0];
                    var H = `${T.name}.${e}`;
                    e.startsWith("@@") && (e = Symbol[e.substring(2)]), w && T.X.Ra.push(e);
                    var V = T.X.ga, oe = V[e];
                    return oe === void 0 || oe.aa === void 0 && oe.className !== T.name && oe.ma === i - 2 ? (W.ma = i - 2, W.className = T.name, V[e] = W) : (pn(V, e, H), V[e].aa[i - 2] = W), Ye([], _, function($) {
                      return $ = Vt(H, $, T, v, P), V[e].aa === void 0 ? ($.ma = i - 2, V[e] = $) : V[e].aa[i - 2] = $, [];
                    }), [];
                  });
                },
                d: function(n, e, i, c, p, v, P, w, _, T) {
                  e = Ee(e), p = We(c, p), Ye([], [n], function(W) {
                    W = W[0];
                    var H = `${W.name}.${e}`, V = { get() {
                      nt(
                        `Cannot access ${H} due to unbound types`,
                        [i, P]
                      );
                    }, enumerable: !0, configurable: !0 };
                    return V.set = _ ? () => {
                      nt(`Cannot access ${H} due to unbound types`, [i, P]);
                    } : () => {
                      le(H + " is a read-only property");
                    }, Object.defineProperty(W.X.ga, e, V), Ye([], _ ? [i, P] : [i], function(oe) {
                      var $ = oe[0], Te = { get() {
                        var ae = br(this, W, H + " getter");
                        return $.fromWireType(p(v, ae));
                      }, enumerable: !0 };
                      if (_) {
                        _ = We(w, _);
                        var Oe = oe[1];
                        Te.set = function(ae) {
                          var he = br(this, W, H + " setter"), Me = [];
                          _(T, he, Oe.toWireType(Me, ae)), Mt(Me);
                        };
                      }
                      return Object.defineProperty(W.X.ga, e, Te), [];
                    }), [];
                  });
                },
                F: function(n, e) {
                  e = Ee(e), Ze(n, {
                    name: e,
                    fromWireType: function(i) {
                      var c = st(i);
                      return mn(i), c;
                    },
                    toWireType: function(i, c) {
                      return Ke(c);
                    },
                    argPackAdvance: 8,
                    readValueFromPointer: kt,
                    ea: null
                  });
                },
                l: function(n, e, i, c) {
                  function p() {
                  }
                  i = Ht(i), e = Ee(e), p.values = {}, Ze(n, { name: e, constructor: p, fromWireType: function(v) {
                    return this.constructor.values[v];
                  }, toWireType: function(v, P) {
                    return P.value;
                  }, argPackAdvance: 8, readValueFromPointer: So(e, i, c), ea: null }), vn(e, p);
                },
                c: function(n, e, i) {
                  var c = Ot(n, "enum");
                  e = Ee(e), n = c.constructor, c = Object.create(c.constructor.prototype, {
                    value: { value: i },
                    constructor: { value: $t(`${c.name}_${e}`, function() {
                    }) }
                  }), n.values[i] = c, n[e] = c;
                },
                u: function(n, e, i) {
                  i = Ht(i), e = Ee(e), Ze(n, { name: e, fromWireType: function(c) {
                    return c;
                  }, toWireType: function(c, p) {
                    return p;
                  }, argPackAdvance: 8, readValueFromPointer: Po(e, i), ea: null });
                },
                q: function(n, e, i, c, p, v) {
                  var P = Gt(e, i);
                  n = Ee(n), p = We(c, p), vn(n, function() {
                    nt(`Cannot call ${n} due to unbound types`, P);
                  }, e - 1), Ye([], P, function(w) {
                    return yr(n, Vt(n, [w[0], null].concat(w.slice(1)), null, p, v), e - 1), [];
                  });
                },
                j: function(n, e, i, c, p) {
                  e = Ee(e), p === -1 && (p = 4294967295), p = Ht(i);
                  var v = (w) => w;
                  if (c === 0) {
                    var P = 32 - 8 * i;
                    v = (w) => w << P >>> P;
                  }
                  i = e.includes("unsigned") ? function(w, _) {
                    return _ >>> 0;
                  } : function(w, _) {
                    return _;
                  }, Ze(n, { name: e, fromWireType: v, toWireType: i, argPackAdvance: 8, readValueFromPointer: To(e, p, c !== 0), ea: null });
                },
                g: function(n, e, i) {
                  function c(v) {
                    v >>= 2;
                    var P = m;
                    return new p(P.buffer, P[v + 1], P[v]);
                  }
                  var p = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][e];
                  i = Ee(i), Ze(n, { name: i, fromWireType: c, argPackAdvance: 8, readValueFromPointer: c }, { tb: !0 });
                },
                v: function(n, e) {
                  e = Ee(e);
                  var i = e === "std::string";
                  Ze(n, { name: e, fromWireType: function(c) {
                    var p = m[c >> 2], v = c + 4;
                    if (i)
                      for (var P = v, w = 0; w <= p; ++w) {
                        var _ = v + w;
                        if (w == p || R[_] == 0) {
                          if (P = P ? wr(R, P, _ - P) : "", T === void 0)
                            var T = P;
                          else
                            T += String.fromCharCode(0), T += P;
                          P = _ + 1;
                        }
                      }
                    else {
                      for (T = Array(p), w = 0; w < p; ++w)
                        T[w] = String.fromCharCode(R[v + w]);
                      T = T.join("");
                    }
                    return rt(c), T;
                  }, toWireType: function(c, p) {
                    p instanceof ArrayBuffer && (p = new Uint8Array(p));
                    var v, P = typeof p == "string";
                    P || p instanceof Uint8Array || p instanceof Uint8ClampedArray || p instanceof Int8Array || le("Cannot pass non-string to std::string");
                    var w;
                    if (i && P)
                      for (v = w = 0; v < p.length; ++v) {
                        var _ = p.charCodeAt(v);
                        127 >= _ ? w++ : 2047 >= _ ? w += 2 : 55296 <= _ && 57343 >= _ ? (w += 4, ++v) : w += 3;
                      }
                    else
                      w = p.length;
                    if (v = w, w = Cn(4 + v + 1), _ = w + 4, m[w >> 2] = v, i && P) {
                      if (P = _, _ = v + 1, v = R, 0 < _) {
                        _ = P + _ - 1;
                        for (var T = 0; T < p.length; ++T) {
                          var W = p.charCodeAt(T);
                          if (55296 <= W && 57343 >= W) {
                            var H = p.charCodeAt(++T);
                            W = 65536 + ((W & 1023) << 10) | H & 1023;
                          }
                          if (127 >= W) {
                            if (P >= _)
                              break;
                            v[P++] = W;
                          } else {
                            if (2047 >= W) {
                              if (P + 1 >= _)
                                break;
                              v[P++] = 192 | W >> 6;
                            } else {
                              if (65535 >= W) {
                                if (P + 2 >= _)
                                  break;
                                v[P++] = 224 | W >> 12;
                              } else {
                                if (P + 3 >= _)
                                  break;
                                v[P++] = 240 | W >> 18, v[P++] = 128 | W >> 12 & 63;
                              }
                              v[P++] = 128 | W >> 6 & 63;
                            }
                            v[P++] = 128 | W & 63;
                          }
                        }
                        v[P] = 0;
                      }
                    } else if (P)
                      for (P = 0; P < v; ++P)
                        T = p.charCodeAt(P), 255 < T && (rt(_), le("String has UTF-16 code units that do not fit in 8 bits")), R[_ + P] = T;
                    else
                      for (P = 0; P < v; ++P)
                        R[_ + P] = p[P];
                    return c !== null && c.push(rt, w), w;
                  }, argPackAdvance: 8, readValueFromPointer: kt, ea: function(c) {
                    rt(c);
                  } });
                },
                t: function(n, e, i) {
                  if (i = Ee(i), e === 2)
                    var c = Bo, p = Ro, v = _o, P = () => ee, w = 1;
                  else
                    e === 4 && (c = xo, p = Eo, v = Oo, P = () => m, w = 2);
                  Ze(n, { name: i, fromWireType: function(_) {
                    for (var T = m[_ >> 2], W = P(), H, V = _ + 4, oe = 0; oe <= T; ++oe) {
                      var $ = _ + 4 + oe * e;
                      (oe == T || W[$ >> w] == 0) && (V = c(V, $ - V), H === void 0 ? H = V : (H += String.fromCharCode(0), H += V), V = $ + e);
                    }
                    return rt(_), H;
                  }, toWireType: function(_, T) {
                    typeof T != "string" && le(`Cannot pass non-string to C++ string type ${i}`);
                    var W = v(T), H = Cn(4 + W + e);
                    return m[H >> 2] = W >> w, p(T, H + 4, W + e), _ !== null && _.push(rt, H), H;
                  }, argPackAdvance: 8, readValueFromPointer: kt, ea: function(_) {
                    rt(_);
                  } });
                },
                N: function(n, e, i, c, p, v) {
                  Xt[n] = { name: Ee(e), Ba: We(
                    i,
                    c
                  ), ka: We(p, v), Na: [] };
                },
                M: function(n, e, i, c, p, v, P, w, _, T) {
                  Xt[n].Na.push({ mb: Ee(e), sb: i, qb: We(c, p), rb: v, Db: P, Cb: We(w, _), Eb: T });
                },
                H: function(n, e) {
                  e = Ee(e), Ze(n, { vb: !0, name: e, argPackAdvance: 0, fromWireType: function() {
                  }, toWireType: function() {
                  } });
                },
                r: function(n, e, i) {
                  n = st(n), e = Ot(e, "emval::as");
                  var c = [], p = Ke(c);
                  return m[i >> 2] = p, e.toWireType(c, n);
                },
                w: function(n, e, i, c, p) {
                  n = Jt[n], e = st(e), i = Zt(i);
                  var v = [];
                  return m[c >> 2] = Ke(v), n(e, i, v, p);
                },
                i: function(n, e, i, c) {
                  n = Jt[n], e = st(e), i = Zt(i), n(e, i, null, c);
                },
                f: mn,
                h: function(n, e) {
                  var i = Ao(n, e), c = i[0];
                  e = c.name + "_$" + i.slice(1).map(function(P) {
                    return P.name;
                  }).join("_") + "$";
                  var p = Sr[e];
                  if (p !== void 0)
                    return p;
                  var v = Array(n - 1);
                  return p = ko((P, w, _, T) => {
                    for (var W = 0, H = 0; H < n - 1; ++H)
                      v[H] = i[H + 1].readValueFromPointer(T + W), W += i[H + 1].argPackAdvance;
                    for (P = P[w].apply(P, v), H = 0; H < n - 1; ++H)
                      i[H + 1].hb && i[H + 1].hb(v[H]);
                    if (!c.vb)
                      return c.toWireType(_, P);
                  }), Sr[e] = p;
                },
                p: function(n) {
                  return n = Zt(n), Ke(h[n]);
                },
                K: function(n, e) {
                  return n = st(n), e = st(e), Ke(n[e]);
                },
                m: function(n) {
                  4 < n && (He.get(n).Ta += 1);
                },
                J: function(n) {
                  return Ke(Zt(n));
                },
                n: function(n) {
                  var e = st(n);
                  Mt(e), mn(n);
                },
                x: function(n, e) {
                  return n = Ot(n, "_emval_take_value"), n = n.readValueFromPointer(e), Ke(n);
                },
                b: () => {
                  N("");
                },
                A: (n) => {
                  var e = R.length;
                  if (n >>>= 0, 2147483648 < n)
                    return !1;
                  for (var i = 1; 4 >= i; i *= 2) {
                    var c = e * (1 + 0.2 / i);
                    c = Math.min(c, n + 100663296);
                    var p = Math;
                    c = Math.max(n, c);
                    e: {
                      p = p.min.call(p, 2147483648, c + (65536 - c % 65536) % 65536) - r.buffer.byteLength + 65535 >>> 16;
                      try {
                        r.grow(p), J();
                        var v = 1;
                        break e;
                      } catch {
                      }
                      v = void 0;
                    }
                    if (v)
                      return !0;
                  }
                  return !1;
                },
                B: (n, e) => {
                  var i = 0;
                  return Pr().forEach(function(c, p) {
                    var v = e + i;
                    for (p = m[n + 4 * p >> 2] = v, v = 0; v < c.length; ++v)
                      S[p++ >> 0] = c.charCodeAt(v);
                    S[p >> 0] = 0, i += c.length + 1;
                  }), 0;
                },
                C: (n, e) => {
                  var i = Pr();
                  m[n >> 2] = i.length;
                  var c = 0;
                  return i.forEach(function(p) {
                    c += p.length + 1;
                  }), m[e >> 2] = c, 0;
                },
                D: () => 52,
                y: function() {
                  return 70;
                },
                E: (n, e, i, c) => {
                  for (var p = 0, v = 0; v < i; v++) {
                    var P = m[e >> 2], w = m[e + 4 >> 2];
                    e += 8;
                    for (var _ = 0; _ < w; _++) {
                      var T = R[P + _], W = Io[n];
                      T === 0 || T === 10 ? ((n === 1 ? ie : te)(wr(W, 0)), W.length = 0) : W.push(T);
                    }
                    p += w;
                  }
                  return m[c >> 2] = p, 0;
                }
              };
              (function() {
                function n(i) {
                  if (u = i = i.exports, r = u.O, J(), q = u.U, ne.unshift(u.P), se--, h.monitorRunDependencies && h.monitorRunDependencies(se), se == 0 && xe) {
                    var c = xe;
                    xe = null, c();
                  }
                  return i;
                }
                var e = { a: zo };
                if (se++, h.monitorRunDependencies && h.monitorRunDependencies(se), h.instantiateWasm)
                  try {
                    return h.instantiateWasm(e, n);
                  } catch (i) {
                    te("Module.instantiateWasm callback failed with error: " + i), Z(i);
                  }
                return Ne(e, function(i) {
                  n(i.instance);
                }).catch(Z), {};
              })();
              var rt = (n) => (rt = u.Q)(n), Cn = (n) => (Cn = u.R)(n), Br = (n) => (Br = u.S)(n);
              h.__embind_initialize_bindings = () => (h.__embind_initialize_bindings = u.T)(), h.dynCall_jiji = (n, e, i, c, p) => (h.dynCall_jiji = u.V)(n, e, i, c, p);
              var Kt;
              xe = function n() {
                Kt || Rr(), Kt || (xe = n);
              };
              function Rr() {
                function n() {
                  if (!Kt && (Kt = !0, h.calledRun = !0, !g)) {
                    if (at(ne), X(h), h.onRuntimeInitialized && h.onRuntimeInitialized(), h.postRun)
                      for (typeof h.postRun == "function" && (h.postRun = [h.postRun]); h.postRun.length; ) {
                        var e = h.postRun.shift();
                        pe.unshift(e);
                      }
                    at(pe);
                  }
                }
                if (!(0 < se)) {
                  if (h.preRun)
                    for (typeof h.preRun == "function" && (h.preRun = [h.preRun]); h.preRun.length; )
                      ve();
                  at(Q), 0 < se || (h.setStatus ? (h.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                      h.setStatus("");
                    }, 1), n();
                  }, 1)) : n());
                }
              }
              if (h.preInit)
                for (typeof h.preInit == "function" && (h.preInit = [h.preInit]); 0 < h.preInit.length; )
                  h.preInit.pop()();
              return Rr(), O.ready;
            };
          })();
          const M = A;
        },
        /* 2 */
        /***/
        (b) => {
          b.exports = JSON.parse(`{"name":"@rive-app/canvas","version":"2.1.5","description":"Rive's canvas based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)"],"license":"MIT","files":["rive.js","rive.js.map","rive.wasm","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}`);
        },
        /* 3 */
        /***/
        (b, L, E) => {
          E.r(L), E.d(L, {
            /* harmony export */
            registerTouchInteractions: () => (
              /* reexport safe */
              A.registerTouchInteractions
            )
            /* harmony export */
          });
          var A = E(4);
        },
        /* 4 */
        /***/
        (b, L, E) => {
          E.r(L), E.d(L, {
            /* harmony export */
            registerTouchInteractions: () => (
              /* binding */
              I
            )
            /* harmony export */
          });
          var A = void 0, M = function(O) {
            var h, X;
            return ["touchstart", "touchmove"].indexOf(O.type) > -1 && (!((h = O.touches) === null || h === void 0) && h.length) ? (O.preventDefault(), {
              clientX: O.touches[0].clientX,
              clientY: O.touches[0].clientY
            }) : O.type === "touchend" && (!((X = O.changedTouches) === null || X === void 0) && X.length) ? {
              clientX: O.changedTouches[0].clientX,
              clientY: O.changedTouches[0].clientY
            } : {
              clientX: O.clientX,
              clientY: O.clientY
            };
          }, I = function(O) {
            var h = O.canvas, X = O.artboard, Z = O.stateMachines, K = Z === void 0 ? [] : Z, ce = O.renderer, x = O.rive, F = O.fit, B = O.alignment;
            if (!h || !K.length || !ce || !x || !X || typeof window > "u")
              return null;
            var y = function(U) {
              var ue = U.currentTarget.getBoundingClientRect(), de = M(U), ie = de.clientX, te = de.clientY;
              if (!(!ie && !te)) {
                var f = ie - ue.left, r = te - ue.top, u = x.computeAlignment(F, B, {
                  minX: 0,
                  minY: 0,
                  maxX: ue.width,
                  maxY: ue.height
                }, X.bounds), g = new x.Mat2D();
                u.invert(g);
                var S = new x.Vec2D(f, r), R = x.mapXY(g, S), k = R.x(), ee = R.y();
                switch (R.delete(), g.delete(), S.delete(), u.delete(), U.type) {
                  case "touchmove":
                  case "mouseover":
                  case "mouseout":
                  case "mousemove": {
                    for (var C = 0, m = K; C < m.length; C++) {
                      var Y = m[C];
                      Y.pointerMove(k, ee);
                    }
                    break;
                  }
                  case "touchstart":
                  case "mousedown": {
                    for (var G = 0, J = K; G < J.length; G++) {
                      var Y = J[G];
                      Y.pointerDown(k, ee);
                    }
                    break;
                  }
                  case "touchend":
                  case "mouseup": {
                    for (var q = 0, Q = K; q < Q.length; q++) {
                      var Y = Q[q];
                      Y.pointerUp(k, ee);
                    }
                    break;
                  }
                }
              }
            }, D = y.bind(A);
            return h.addEventListener("mouseover", D), h.addEventListener("mouseout", D), h.addEventListener("mousemove", D), h.addEventListener("mousedown", D), h.addEventListener("mouseup", D), h.addEventListener("touchmove", D), h.addEventListener("touchstart", D), h.addEventListener("touchend", D), function() {
              h.removeEventListener("mouseover", D), h.removeEventListener("mouseout", D), h.removeEventListener("mousemove", D), h.removeEventListener("mousedown", D), h.removeEventListener("mouseup", D), h.removeEventListener("touchmove", D), h.removeEventListener("touchstart", D), h.removeEventListener("touchend", D);
            };
          };
        }
        /******/
      ], s = {};
      function l(b) {
        var L = s[b];
        if (L !== void 0)
          return L.exports;
        var E = s[b] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return a[b](E, E.exports, l), E.exports;
      }
      l.d = (b, L) => {
        for (var E in L)
          l.o(L, E) && !l.o(b, E) && Object.defineProperty(b, E, { enumerable: !0, get: L[E] });
      }, l.o = (b, L) => Object.prototype.hasOwnProperty.call(b, L), l.r = (b) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(b, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(b, "__esModule", { value: !0 });
      };
      var d = {};
      return (() => {
        l.r(d), l.d(d, {
          /* harmony export */
          Alignment: () => (
            /* binding */
            O
          ),
          /* harmony export */
          EventType: () => (
            /* binding */
            B
          ),
          /* harmony export */
          Fit: () => (
            /* binding */
            I
          ),
          /* harmony export */
          Layout: () => (
            /* binding */
            h
          ),
          /* harmony export */
          LoopType: () => (
            /* binding */
            y
          ),
          /* harmony export */
          Rive: () => (
            /* binding */
            ue
          ),
          /* harmony export */
          RuntimeLoader: () => (
            /* binding */
            X
          ),
          /* harmony export */
          StateMachineInput: () => (
            /* binding */
            ce
          ),
          /* harmony export */
          StateMachineInputType: () => (
            /* binding */
            K
          ),
          /* harmony export */
          Testing: () => (
            /* binding */
            te
          )
          /* harmony export */
        });
        var b = l(1), L = l(2), E = l(3), A = function(f, r, u, g) {
          function S(R) {
            return R instanceof u ? R : new u(function(k) {
              k(R);
            });
          }
          return new (u || (u = Promise))(function(R, k) {
            function ee(Y) {
              try {
                m(g.next(Y));
              } catch (G) {
                k(G);
              }
            }
            function C(Y) {
              try {
                m(g.throw(Y));
              } catch (G) {
                k(G);
              }
            }
            function m(Y) {
              Y.done ? R(Y.value) : S(Y.value).then(ee, C);
            }
            m((g = g.apply(f, r || [])).next());
          });
        }, M = function(f, r) {
          var u = { label: 0, sent: function() {
            if (R[0] & 1)
              throw R[1];
            return R[1];
          }, trys: [], ops: [] }, g, S, R, k;
          return k = { next: ee(0), throw: ee(1), return: ee(2) }, typeof Symbol == "function" && (k[Symbol.iterator] = function() {
            return this;
          }), k;
          function ee(m) {
            return function(Y) {
              return C([m, Y]);
            };
          }
          function C(m) {
            if (g)
              throw new TypeError("Generator is already executing.");
            for (; k && (k = 0, m[0] && (u = 0)), u; )
              try {
                if (g = 1, S && (R = m[0] & 2 ? S.return : m[0] ? S.throw || ((R = S.return) && R.call(S), 0) : S.next) && !(R = R.call(S, m[1])).done)
                  return R;
                switch (S = 0, R && (m = [m[0] & 2, R.value]), m[0]) {
                  case 0:
                  case 1:
                    R = m;
                    break;
                  case 4:
                    return u.label++, { value: m[1], done: !1 };
                  case 5:
                    u.label++, S = m[1], m = [0];
                    continue;
                  case 7:
                    m = u.ops.pop(), u.trys.pop();
                    continue;
                  default:
                    if (R = u.trys, !(R = R.length > 0 && R[R.length - 1]) && (m[0] === 6 || m[0] === 2)) {
                      u = 0;
                      continue;
                    }
                    if (m[0] === 3 && (!R || m[1] > R[0] && m[1] < R[3])) {
                      u.label = m[1];
                      break;
                    }
                    if (m[0] === 6 && u.label < R[1]) {
                      u.label = R[1], R = m;
                      break;
                    }
                    if (R && u.label < R[2]) {
                      u.label = R[2], u.ops.push(m);
                      break;
                    }
                    R[2] && u.ops.pop(), u.trys.pop();
                    continue;
                }
                m = r.call(f, u);
              } catch (Y) {
                m = [6, Y], S = 0;
              } finally {
                g = R = 0;
              }
            if (m[0] & 5)
              throw m[1];
            return { value: m[0] ? m[1] : void 0, done: !0 };
          }
        }, I;
        (function(f) {
          f.Cover = "cover", f.Contain = "contain", f.Fill = "fill", f.FitWidth = "fitWidth", f.FitHeight = "fitHeight", f.None = "none", f.ScaleDown = "scaleDown";
        })(I || (I = {}));
        var O;
        (function(f) {
          f.Center = "center", f.TopLeft = "topLeft", f.TopCenter = "topCenter", f.TopRight = "topRight", f.CenterLeft = "centerLeft", f.CenterRight = "centerRight", f.BottomLeft = "bottomLeft", f.BottomCenter = "bottomCenter", f.BottomRight = "bottomRight";
        })(O || (O = {}));
        var h = (
          /** @class */
          function() {
            function f(r) {
              var u, g, S, R, k, ee;
              this.fit = (u = r == null ? void 0 : r.fit) !== null && u !== void 0 ? u : I.Contain, this.alignment = (g = r == null ? void 0 : r.alignment) !== null && g !== void 0 ? g : O.Center, this.minX = (S = r == null ? void 0 : r.minX) !== null && S !== void 0 ? S : 0, this.minY = (R = r == null ? void 0 : r.minY) !== null && R !== void 0 ? R : 0, this.maxX = (k = r == null ? void 0 : r.maxX) !== null && k !== void 0 ? k : 0, this.maxY = (ee = r == null ? void 0 : r.maxY) !== null && ee !== void 0 ? ee : 0;
            }
            return f.new = function(r) {
              var u = r.fit, g = r.alignment, S = r.minX, R = r.minY, k = r.maxX, ee = r.maxY;
              return console.warn("This function is deprecated: please use `new Layout({})` instead"), new f({ fit: u, alignment: g, minX: S, minY: R, maxX: k, maxY: ee });
            }, f.prototype.copyWith = function(r) {
              var u = r.fit, g = r.alignment, S = r.minX, R = r.minY, k = r.maxX, ee = r.maxY;
              return new f({
                fit: u ?? this.fit,
                alignment: g ?? this.alignment,
                minX: S ?? this.minX,
                minY: R ?? this.minY,
                maxX: k ?? this.maxX,
                maxY: ee ?? this.maxY
              });
            }, f.prototype.runtimeFit = function(r) {
              if (this.cachedRuntimeFit)
                return this.cachedRuntimeFit;
              var u;
              return this.fit === I.Cover ? u = r.Fit.cover : this.fit === I.Contain ? u = r.Fit.contain : this.fit === I.Fill ? u = r.Fit.fill : this.fit === I.FitWidth ? u = r.Fit.fitWidth : this.fit === I.FitHeight ? u = r.Fit.fitHeight : this.fit === I.ScaleDown ? u = r.Fit.scaleDown : u = r.Fit.none, this.cachedRuntimeFit = u, u;
            }, f.prototype.runtimeAlignment = function(r) {
              if (this.cachedRuntimeAlignment)
                return this.cachedRuntimeAlignment;
              var u;
              return this.alignment === O.TopLeft ? u = r.Alignment.topLeft : this.alignment === O.TopCenter ? u = r.Alignment.topCenter : this.alignment === O.TopRight ? u = r.Alignment.topRight : this.alignment === O.CenterLeft ? u = r.Alignment.centerLeft : this.alignment === O.CenterRight ? u = r.Alignment.centerRight : this.alignment === O.BottomLeft ? u = r.Alignment.bottomLeft : this.alignment === O.BottomCenter ? u = r.Alignment.bottomCenter : this.alignment === O.BottomRight ? u = r.Alignment.bottomRight : u = r.Alignment.center, this.cachedRuntimeAlignment = u, u;
            }, f;
          }()
        ), X = (
          /** @class */
          function() {
            function f() {
            }
            return f.loadRuntime = function() {
              b.default({
                // Loads Wasm bundle
                locateFile: function() {
                  return f.wasmURL;
                }
              }).then(function(r) {
                var u;
                for (f.runtime = r; f.callBackQueue.length > 0; )
                  (u = f.callBackQueue.shift()) === null || u === void 0 || u(f.runtime);
              }).catch(function() {
                var r = "https://cdn.jsdelivr.net/npm/".concat(L.name, "@").concat(L.version, "/rive.wasm");
                f.wasmURL.toLowerCase() !== r ? (console.warn("Failed to load WASM from ".concat(f.wasmURL, ", trying jsdelivr as a backup")), f.setWasmUrl(r), f.loadRuntime()) : console.error("Could not load Rive WASM file from unpkg or jsdelivr, network connection may be down, or 	        you may need to call set a new WASM source via RuntimeLoader.setWasmUrl() and call 	        RuntimeLoader.loadRuntime() again");
              });
            }, f.getInstance = function(r) {
              f.isLoading || (f.isLoading = !0, f.loadRuntime()), f.runtime ? r(f.runtime) : f.callBackQueue.push(r);
            }, f.awaitInstance = function() {
              return new Promise(function(r) {
                return f.getInstance(function(u) {
                  return r(u);
                });
              });
            }, f.setWasmUrl = function(r) {
              f.wasmURL = r;
            }, f.isLoading = !1, f.callBackQueue = [], f.wasmURL = "https://unpkg.com/".concat(L.name, "@").concat(L.version, "/rive.wasm"), f;
          }()
        ), Z = (
          /** @class */
          function() {
            function f(r, u, g, S) {
              this.animation = r, this.artboard = u, this.playing = S, this.loopCount = 0, this.scrubTo = null, this.instance = new g.LinearAnimationInstance(r, u);
            }
            return Object.defineProperty(f.prototype, "name", {
              // Returns the animation's name
              get: function() {
                return this.animation.name;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "time", {
              // Returns the animation's current time
              get: function() {
                return this.instance.time;
              },
              // Sets the animation's current time
              set: function(r) {
                this.instance.time = r;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "loopValue", {
              // Returns the animation's loop type
              get: function() {
                return this.animation.loopValue;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.advance = function(r) {
              this.scrubTo === null ? this.instance.advance(r) : (this.instance.time = 0, this.instance.advance(this.scrubTo), this.scrubTo = null);
            }, f.prototype.apply = function(r) {
              this.instance.apply(r);
            }, Object.defineProperty(f.prototype, "needsScrub", {
              get: function() {
                return this.scrubTo !== null;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.cleanup = function() {
              this.instance.delete();
            }, f;
          }()
        ), K;
        (function(f) {
          f[f.Number = 56] = "Number", f[f.Trigger = 58] = "Trigger", f[f.Boolean = 59] = "Boolean";
        })(K || (K = {}));
        var ce = (
          /** @class */
          function() {
            function f(r, u) {
              this.type = r, this.runtimeInput = u;
            }
            return Object.defineProperty(f.prototype, "name", {
              /**
               * Returns the name of the input
               */
              get: function() {
                return this.runtimeInput.name;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "value", {
              /**
               * Returns the current value of the input
               */
              get: function() {
                return this.runtimeInput.value;
              },
              /**
               * Sets the value of the input
               */
              set: function(r) {
                this.runtimeInput.value = r;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.fire = function() {
              this.type === K.Trigger && this.runtimeInput.fire();
            }, f;
          }()
        ), x = (
          /** @class */
          function() {
            function f(r, u, g, S) {
              this.stateMachine = r, this.playing = g, this.artboard = S, this.inputs = [], this.instance = new u.StateMachineInstance(r, S), this.initInputs(u);
            }
            return Object.defineProperty(f.prototype, "name", {
              get: function() {
                return this.stateMachine.name;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "statesChanged", {
              /**
               * Returns a list of state names that have changed on this frame
               */
              get: function() {
                for (var r = [], u = 0; u < this.instance.stateChangedCount(); u++)
                  r.push(this.instance.stateChangedNameByIndex(u));
                return r;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.advance = function(r) {
              this.instance.advance(r);
            }, f.prototype.initInputs = function(r) {
              for (var u = 0; u < this.instance.inputCount(); u++) {
                var g = this.instance.input(u);
                this.inputs.push(this.mapRuntimeInput(g, r));
              }
            }, f.prototype.mapRuntimeInput = function(r, u) {
              if (r.type === u.SMIInput.bool)
                return new ce(K.Boolean, r.asBool());
              if (r.type === u.SMIInput.number)
                return new ce(K.Number, r.asNumber());
              if (r.type === u.SMIInput.trigger)
                return new ce(K.Trigger, r.asTrigger());
            }, f.prototype.cleanup = function() {
              this.instance.delete();
            }, f;
          }()
        ), F = (
          /** @class */
          function() {
            function f(r, u, g, S, R) {
              S === void 0 && (S = []), R === void 0 && (R = []), this.runtime = r, this.artboard = u, this.eventManager = g, this.animations = S, this.stateMachines = R;
            }
            return f.prototype.add = function(r, u, g) {
              if (g === void 0 && (g = !0), r = ie(r), r.length === 0)
                this.animations.forEach(function(q) {
                  return q.playing = u;
                }), this.stateMachines.forEach(function(q) {
                  return q.playing = u;
                });
              else
                for (var S = this.animations.map(function(q) {
                  return q.name;
                }), R = this.stateMachines.map(function(q) {
                  return q.name;
                }), k = 0; k < r.length; k++) {
                  var ee = S.indexOf(r[k]), C = R.indexOf(r[k]);
                  if (ee >= 0 || C >= 0)
                    ee >= 0 ? this.animations[ee].playing = u : this.stateMachines[C].playing = u;
                  else {
                    var m = this.artboard.animationByName(r[k]);
                    if (m) {
                      var Y = new Z(m, this.artboard, this.runtime, u);
                      Y.advance(0), Y.apply(1), this.animations.push(Y);
                    } else {
                      var G = this.artboard.stateMachineByName(r[k]);
                      if (G) {
                        var J = new x(G, this.runtime, u, this.artboard);
                        this.stateMachines.push(J);
                      }
                    }
                  }
                }
              return g && (u ? this.eventManager.fire({
                type: B.Play,
                data: this.playing
              }) : this.eventManager.fire({
                type: B.Pause,
                data: this.paused
              })), u ? this.playing : this.paused;
            }, f.prototype.play = function(r) {
              return this.add(r, !0);
            }, f.prototype.pause = function(r) {
              return this.add(r, !1);
            }, f.prototype.scrub = function(r, u) {
              var g = this.animations.filter(function(S) {
                return r.includes(S.name);
              });
              return g.forEach(function(S) {
                return S.scrubTo = u;
              }), g.map(function(S) {
                return S.name;
              });
            }, Object.defineProperty(f.prototype, "playing", {
              /**
               * Returns a list of names of all animations and state machines currently
               * playing
               */
              get: function() {
                return this.animations.filter(function(r) {
                  return r.playing;
                }).map(function(r) {
                  return r.name;
                }).concat(this.stateMachines.filter(function(r) {
                  return r.playing;
                }).map(function(r) {
                  return r.name;
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "paused", {
              /**
               * Returns a list of names of all animations and state machines currently
               * paused
               */
              get: function() {
                return this.animations.filter(function(r) {
                  return !r.playing;
                }).map(function(r) {
                  return r.name;
                }).concat(this.stateMachines.filter(function(r) {
                  return !r.playing;
                }).map(function(r) {
                  return r.name;
                }));
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.stop = function(r) {
              var u = this;
              r = ie(r);
              var g = [];
              if (r.length === 0)
                g = this.animations.map(function(k) {
                  return k.name;
                }).concat(this.stateMachines.map(function(k) {
                  return k.name;
                })), this.animations.forEach(function(k) {
                  return k.cleanup();
                }), this.stateMachines.forEach(function(k) {
                  return k.cleanup();
                }), this.animations.splice(0, this.animations.length), this.stateMachines.splice(0, this.stateMachines.length);
              else {
                var S = this.animations.filter(function(k) {
                  return r.includes(k.name);
                });
                S.forEach(function(k) {
                  k.cleanup(), u.animations.splice(u.animations.indexOf(k), 1);
                });
                var R = this.stateMachines.filter(function(k) {
                  return r.includes(k.name);
                });
                R.forEach(function(k) {
                  k.cleanup(), u.stateMachines.splice(u.stateMachines.indexOf(k), 1);
                }), g = S.map(function(k) {
                  return k.name;
                }).concat(R.map(function(k) {
                  return k.name;
                }));
              }
              return this.eventManager.fire({
                type: B.Stop,
                data: g
              }), g;
            }, Object.defineProperty(f.prototype, "isPlaying", {
              /**
               * Returns true if at least one animation is active
               */
              get: function() {
                return this.animations.reduce(function(r, u) {
                  return r || u.playing;
                }, !1) || this.stateMachines.reduce(function(r, u) {
                  return r || u.playing;
                }, !1);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "isPaused", {
              /**
               * Returns true if all animations are paused and there's at least one animation
               */
              get: function() {
                return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "isStopped", {
              /**
               * Returns true if there are no playing or paused animations/state machines
               */
              get: function() {
                return this.animations.length === 0 && this.stateMachines.length === 0;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.atLeastOne = function(r, u) {
              u === void 0 && (u = !0);
              var g;
              return this.animations.length === 0 && this.stateMachines.length === 0 && (this.artboard.animationCount() > 0 ? this.add([g = this.artboard.animationByIndex(0).name], r, u) : this.artboard.stateMachineCount() > 0 && this.add([g = this.artboard.stateMachineByIndex(0).name], r, u)), g;
            }, f.prototype.handleLooping = function() {
              for (var r = 0, u = this.animations.filter(function(S) {
                return S.playing;
              }); r < u.length; r++) {
                var g = u[r];
                g.loopValue === 0 && g.loopCount ? (g.loopCount = 0, this.stop(g.name)) : g.loopValue === 1 && g.loopCount ? (this.eventManager.fire({
                  type: B.Loop,
                  data: { animation: g.name, type: y.Loop }
                }), g.loopCount = 0) : g.loopValue === 2 && g.loopCount > 1 && (this.eventManager.fire({
                  type: B.Loop,
                  data: { animation: g.name, type: y.PingPong }
                }), g.loopCount = 0);
              }
            }, f.prototype.handleStateChanges = function() {
              for (var r = [], u = 0, g = this.stateMachines.filter(function(R) {
                return R.playing;
              }); u < g.length; u++) {
                var S = g[u];
                r.push.apply(r, S.statesChanged);
              }
              r.length > 0 && this.eventManager.fire({
                type: B.StateChange,
                data: r
              });
            }, f.prototype.handleAdvancing = function(r) {
              this.eventManager.fire({
                type: B.Advance,
                data: r
              });
            }, f;
          }()
        ), B;
        (function(f) {
          f.Load = "load", f.LoadError = "loaderror", f.Play = "play", f.Pause = "pause", f.Stop = "stop", f.Loop = "loop", f.Draw = "draw", f.Advance = "advance", f.StateChange = "statechange";
        })(B || (B = {}));
        var y;
        (function(f) {
          f.OneShot = "oneshot", f.Loop = "loop", f.PingPong = "pingpong";
        })(y || (y = {}));
        var D = (
          /** @class */
          function() {
            function f(r) {
              r === void 0 && (r = []), this.listeners = r;
            }
            return f.prototype.getListeners = function(r) {
              return this.listeners.filter(function(u) {
                return u.type === r;
              });
            }, f.prototype.add = function(r) {
              this.listeners.includes(r) || this.listeners.push(r);
            }, f.prototype.remove = function(r) {
              for (var u = 0; u < this.listeners.length; u++) {
                var g = this.listeners[u];
                if (g.type === r.type && g.callback === r.callback) {
                  this.listeners.splice(u, 1);
                  break;
                }
              }
            }, f.prototype.removeAll = function(r) {
              var u = this;
              r ? this.listeners.filter(function(g) {
                return g.type === r;
              }).forEach(function(g) {
                return u.remove(g);
              }) : this.listeners.splice(0, this.listeners.length);
            }, f.prototype.fire = function(r) {
              var u = this.getListeners(r.type);
              u.forEach(function(g) {
                return g.callback(r);
              });
            }, f;
          }()
        ), U = (
          /** @class */
          function() {
            function f(r) {
              this.eventManager = r, this.queue = [];
            }
            return f.prototype.add = function(r) {
              this.queue.push(r);
            }, f.prototype.process = function() {
              for (; this.queue.length > 0; ) {
                var r = this.queue.shift();
                r != null && r.action && r.action(), r != null && r.event && this.eventManager.fire(r.event);
              }
            }, f;
          }()
        ), ue = (
          /** @class */
          function() {
            function f(r) {
              var u;
              this.loaded = !1, this.readyForPlaying = !1, this.artboard = null, this.eventCleanup = null, this.shouldDisableRiveListeners = !1, this.durations = [], this.frameTimes = [], this.frameCount = 0, this.renderSecondTimer = 0, this.canvas = r.canvas, this.src = r.src, this.buffer = r.buffer, this.layout = (u = r.layout) !== null && u !== void 0 ? u : new h(), this.shouldDisableRiveListeners = !!r.shouldDisableRiveListeners, this.eventManager = new D(), r.onLoad && this.on(B.Load, r.onLoad), r.onLoadError && this.on(B.LoadError, r.onLoadError), r.onPlay && this.on(B.Play, r.onPlay), r.onPause && this.on(B.Pause, r.onPause), r.onStop && this.on(B.Stop, r.onStop), r.onLoop && this.on(B.Loop, r.onLoop), r.onStateChange && this.on(B.StateChange, r.onStateChange), r.onAdvance && this.on(B.Advance, r.onAdvance), r.onload && !r.onLoad && this.on(B.Load, r.onload), r.onloaderror && !r.onLoadError && this.on(B.LoadError, r.onloaderror), r.onplay && !r.onPlay && this.on(B.Play, r.onplay), r.onpause && !r.onPause && this.on(B.Pause, r.onpause), r.onstop && !r.onStop && this.on(B.Stop, r.onstop), r.onloop && !r.onLoop && this.on(B.Loop, r.onloop), r.onstatechange && !r.onStateChange && this.on(B.StateChange, r.onstatechange), this.taskQueue = new U(this.eventManager), this.init({
                src: this.src,
                buffer: this.buffer,
                autoplay: r.autoplay,
                animations: r.animations,
                stateMachines: r.stateMachines,
                artboard: r.artboard,
                useOffscreenRenderer: r.useOffscreenRenderer
              });
            }
            return f.new = function(r) {
              return console.warn("This function is deprecated: please use `new Rive({})` instead"), new f(r);
            }, f.prototype.init = function(r) {
              var u = this, g = r.src, S = r.buffer, R = r.animations, k = r.stateMachines, ee = r.artboard, C = r.autoplay, m = C === void 0 ? !1 : C, Y = r.useOffscreenRenderer, G = Y === void 0 ? !1 : Y;
              if (this.src = g, this.buffer = S, !this.src && !this.buffer)
                throw new Error(f.missingErrorMessage);
              var J = ie(R), q = ie(k);
              this.loaded = !1, this.readyForPlaying = !1, X.awaitInstance().then(function(Q) {
                u.runtime = Q, u.renderer = u.runtime.makeRenderer(u.canvas, G), u.canvas.width || u.canvas.height || u.resizeDrawingSurfaceToCanvas(), u.initData(ee, J, q, m).then(function() {
                  return u.setupRiveListeners();
                }).catch(function(ne) {
                  console.error(ne);
                });
              }).catch(function(Q) {
                console.error(Q);
              });
            }, f.prototype.setupRiveListeners = function() {
              var r = this;
              if (!this.shouldDisableRiveListeners) {
                var u = (this.animator.stateMachines || []).filter(function(g) {
                  return g.playing && r.runtime.hasListeners(g.instance);
                }).map(function(g) {
                  return g.instance;
                });
                this.eventCleanup = (0, E.registerTouchInteractions)({
                  canvas: this.canvas,
                  artboard: this.artboard,
                  stateMachines: u,
                  renderer: this.renderer,
                  rive: this.runtime,
                  fit: this._layout.runtimeFit(this.runtime),
                  alignment: this._layout.runtimeAlignment(this.runtime)
                });
              }
            }, f.prototype.initData = function(r, u, g, S) {
              var R;
              return A(this, void 0, void 0, function() {
                var k, ee, C;
                return M(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return this.src ? (k = this, [4, de(this.src)]) : [3, 2];
                    case 1:
                      k.buffer = m.sent(), m.label = 2;
                    case 2:
                      return ee = this, [4, this.runtime.load(new Uint8Array(this.buffer))];
                    case 3:
                      return ee.file = m.sent(), this.file ? (this.initArtboard(r, u, g, S), this.loaded = !0, this.eventManager.fire({
                        type: B.Load,
                        data: (R = this.src) !== null && R !== void 0 ? R : "buffer"
                      }), this.readyForPlaying = !0, this.taskQueue.process(), this.drawFrame(), [2, Promise.resolve()]) : (C = "Problem loading file; may be corrupt!", console.warn(C), this.eventManager.fire({ type: B.LoadError, data: C }), [2, Promise.reject(C)]);
                  }
                });
              });
            }, f.prototype.initArtboard = function(r, u, g, S) {
              var R = r ? this.file.artboardByName(r) : this.file.defaultArtboard();
              if (!R) {
                var k = "Invalid artboard name or no default artboard";
                console.warn(k), this.eventManager.fire({ type: B.LoadError, data: k });
                return;
              }
              if (this.artboard = R, this.artboard.animationCount() < 1) {
                var k = "Artboard has no animations";
                throw this.eventManager.fire({ type: B.LoadError, data: k }), k;
              }
              this.animator = new F(this.runtime, this.artboard, this.eventManager);
              var ee;
              u.length > 0 || g.length > 0 ? (ee = u.concat(g), this.animator.add(ee, S, !1)) : ee = [this.animator.atLeastOne(S, !1)], this.taskQueue.add({
                event: {
                  type: S ? B.Play : B.Pause,
                  data: ee
                }
              });
            }, f.prototype.drawFrame = function() {
              this.startRendering();
            }, f.prototype.draw = function(r, u) {
              var g = performance.now();
              this.frameRequestId = null, this.lastRenderTime || (this.lastRenderTime = r), this.renderSecondTimer += r - this.lastRenderTime, this.renderSecondTimer > 5e3 && (this.renderSecondTimer = 0, u == null || u());
              var S = (r - this.lastRenderTime) / 1e3;
              this.lastRenderTime = r;
              for (var R = this.animator.animations.filter(function(ne) {
                return ne.playing || ne.needsScrub;
              }).sort(function(ne) {
                return ne.needsScrub ? -1 : 1;
              }), k = 0, ee = R; k < ee.length; k++) {
                var C = ee[k];
                C.advance(S), C.instance.didLoop && (C.loopCount += 1), C.apply(1);
              }
              for (var m = this.animator.stateMachines.filter(function(ne) {
                return ne.playing;
              }), Y = 0, G = m; Y < G.length; Y++) {
                var J = G[Y];
                J.advance(S);
              }
              this.artboard.advance(S);
              var q = this.renderer;
              q.clear(), q.save(), this.alignRenderer(), this.artboard.draw(q), q.restore(), q.flush(), this.animator.handleLooping(), this.animator.handleStateChanges(), this.animator.handleAdvancing(S), this.frameCount++;
              var Q = performance.now();
              for (this.frameTimes.push(Q), this.durations.push(Q - g); this.frameTimes[0] <= Q - 1e3; )
                this.frameTimes.shift(), this.durations.shift();
              this.animator.isPlaying ? this.startRendering() : this.animator.isPaused ? this.lastRenderTime = 0 : this.animator.isStopped && (this.lastRenderTime = 0);
            }, f.prototype.alignRenderer = function() {
              var r = this, u = r.renderer, g = r.runtime, S = r._layout, R = r.artboard;
              u.align(S.runtimeFit(g), S.runtimeAlignment(g), {
                minX: S.minX,
                minY: S.minY,
                maxX: S.maxX,
                maxY: S.maxY
              }, R.bounds);
            }, Object.defineProperty(f.prototype, "fps", {
              get: function() {
                return this.durations.length;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "frameTime", {
              get: function() {
                return this.durations.length === 0 ? 0 : (this.durations.reduce(function(r, u) {
                  return r + u;
                }, 0) / this.durations.length).toFixed(4);
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.cleanup = function() {
              var r, u;
              this.stopRendering(), this.cleanupInstances(), (r = this.renderer) === null || r === void 0 || r.delete(), this.renderer = null, (u = this.file) === null || u === void 0 || u.delete(), this.file = null;
            }, f.prototype.cleanupInstances = function() {
              this.eventCleanup !== null && this.eventCleanup(), this.stop(), this.artboard && (this.artboard.delete(), this.artboard = null);
            }, f.prototype.retrieveTextRun = function(r) {
              var u;
              if (!r) {
                console.warn("No text run name provided");
                return;
              }
              if (!this.artboard) {
                console.warn("Tried to access text run, but the Artboard is null");
                return;
              }
              var g = this.artboard.textRun(r);
              if (!g) {
                console.warn("Could not access a text run with name '".concat(r, "' in the '").concat((u = this.artboard) === null || u === void 0 ? void 0 : u.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                return;
              }
              return g;
            }, f.prototype.getTextRunValue = function(r) {
              var u = this.retrieveTextRun(r);
              return u ? u.text : void 0;
            }, f.prototype.setTextRunValue = function(r, u) {
              var g = this.retrieveTextRun(r);
              g && (g.text = u);
            }, f.prototype.play = function(r, u) {
              var g = this;
              if (r = ie(r), !this.readyForPlaying) {
                this.taskQueue.add({
                  action: function() {
                    return g.play(r, u);
                  }
                });
                return;
              }
              this.animator.play(r), this.eventCleanup && this.eventCleanup(), this.setupRiveListeners(), this.startRendering();
            }, f.prototype.pause = function(r) {
              var u = this;
              if (r = ie(r), !this.readyForPlaying) {
                this.taskQueue.add({
                  action: function() {
                    return u.pause(r);
                  }
                });
                return;
              }
              this.eventCleanup && this.eventCleanup(), this.animator.pause(r);
            }, f.prototype.scrub = function(r, u) {
              var g = this;
              if (r = ie(r), !this.readyForPlaying) {
                this.taskQueue.add({
                  action: function() {
                    return g.scrub(r, u);
                  }
                });
                return;
              }
              this.animator.scrub(r, u || 0), this.drawFrame();
            }, f.prototype.stop = function(r) {
              var u = this;
              if (r = ie(r), !this.readyForPlaying) {
                this.taskQueue.add({
                  action: function() {
                    return u.stop(r);
                  }
                });
                return;
              }
              this.animator.stop(r), this.eventCleanup && this.eventCleanup();
            }, f.prototype.reset = function(r) {
              var u, g = r == null ? void 0 : r.artboard, S = ie(r == null ? void 0 : r.animations), R = ie(r == null ? void 0 : r.stateMachines), k = (u = r == null ? void 0 : r.autoplay) !== null && u !== void 0 ? u : !1;
              this.cleanupInstances(), this.initArtboard(g, S, R, k), this.taskQueue.process();
            }, f.prototype.load = function(r) {
              this.stop(), this.init(r);
            }, Object.defineProperty(f.prototype, "layout", {
              /**
               * Returns the current layout. Note that layout should be treated as
               * immutable. If you want to change the layout, create a new one use the
               * layout setter
               */
              get: function() {
                return this._layout;
              },
              // Sets a new layout
              set: function(r) {
                this._layout = r, (!r.maxX || !r.maxY) && this.resizeToCanvas(), this.loaded && !this.animator.isPlaying && this.drawFrame();
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.resizeToCanvas = function() {
              this._layout = this.layout.copyWith({
                minX: 0,
                minY: 0,
                maxX: this.canvas.width,
                maxY: this.canvas.height
              });
            }, f.prototype.resizeDrawingSurfaceToCanvas = function() {
              if (this.canvas instanceof HTMLCanvasElement && window) {
                var r = this.canvas.getBoundingClientRect(), u = r.width, g = r.height, S = window.devicePixelRatio || 1;
                this.canvas.width = S * u, this.canvas.height = S * g, this.startRendering(), this.resizeToCanvas();
              }
            }, Object.defineProperty(f.prototype, "source", {
              // Returns the animation source, which may be undefined
              get: function() {
                return this.src;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "activeArtboard", {
              /**
               * Returns the name of the active artboard
               */
              get: function() {
                return this.artboard ? this.artboard.name : "";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "animationNames", {
              // Returns a list of animation names on the chosen artboard
              get: function() {
                if (!this.loaded)
                  return [];
                for (var r = [], u = 0; u < this.artboard.animationCount(); u++)
                  r.push(this.artboard.animationByIndex(u).name);
                return r;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "stateMachineNames", {
              /**
               * Returns a list of state machine names from the current artboard
               */
              get: function() {
                if (!this.loaded)
                  return [];
                for (var r = [], u = 0; u < this.artboard.stateMachineCount(); u++)
                  r.push(this.artboard.stateMachineByIndex(u).name);
                return r;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.stateMachineInputs = function(r) {
              if (this.loaded) {
                var u = this.animator.stateMachines.find(function(g) {
                  return g.name === r;
                });
                return u == null ? void 0 : u.inputs;
              }
            }, Object.defineProperty(f.prototype, "playingStateMachineNames", {
              // Returns a list of playing machine names
              get: function() {
                return this.loaded ? this.animator.stateMachines.filter(function(r) {
                  return r.playing;
                }).map(function(r) {
                  return r.name;
                }) : [];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "playingAnimationNames", {
              // Returns a list of playing animation names
              get: function() {
                return this.loaded ? this.animator.animations.filter(function(r) {
                  return r.playing;
                }).map(function(r) {
                  return r.name;
                }) : [];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "pausedAnimationNames", {
              // Returns a list of paused animation names
              get: function() {
                return this.loaded ? this.animator.animations.filter(function(r) {
                  return !r.playing;
                }).map(function(r) {
                  return r.name;
                }) : [];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "pausedStateMachineNames", {
              /**
               *  Returns a list of paused machine names
               * @returns a list of state machine names that are paused
               */
              get: function() {
                return this.loaded ? this.animator.stateMachines.filter(function(r) {
                  return !r.playing;
                }).map(function(r) {
                  return r.name;
                }) : [];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "isPlaying", {
              /**
               * @returns true if any animation is playing
               */
              get: function() {
                return this.animator.isPlaying;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "isPaused", {
              /**
               * @returns true if all instanced animations are paused
               */
              get: function() {
                return this.animator.isPaused;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "isStopped", {
              /**
               * @returns true if no animations are playing or paused
               */
              get: function() {
                return this.animator.isStopped;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(f.prototype, "bounds", {
              /**
               * @returns the bounds of the current artboard, or undefined if the artboard
               * isn't loaded yet.
               */
              get: function() {
                return this.artboard ? this.artboard.bounds : void 0;
              },
              enumerable: !1,
              configurable: !0
            }), f.prototype.on = function(r, u) {
              this.eventManager.add({
                type: r,
                callback: u
              });
            }, f.prototype.off = function(r, u) {
              this.eventManager.remove({
                type: r,
                callback: u
              });
            }, f.prototype.unsubscribe = function(r, u) {
              console.warn("This function is deprecated: please use `off()` instead."), this.off(r, u);
            }, f.prototype.removeAllRiveEventListeners = function(r) {
              this.eventManager.removeAll(r);
            }, f.prototype.unsubscribeAll = function(r) {
              console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead."), this.removeAllRiveEventListeners(r);
            }, f.prototype.stopRendering = function() {
              this.loaded && this.frameRequestId && (this.runtime.cancelAnimationFrame ? this.runtime.cancelAnimationFrame(this.frameRequestId) : cancelAnimationFrame(this.frameRequestId), this.frameRequestId = null);
            }, f.prototype.startRendering = function() {
              this.loaded && this.artboard && !this.frameRequestId && (this.runtime.requestAnimationFrame ? this.frameRequestId = this.runtime.requestAnimationFrame(this.draw.bind(this)) : this.frameRequestId = requestAnimationFrame(this.draw.bind(this)));
            }, f.prototype.enableFPSCounter = function(r) {
              this.runtime.enableFPSCounter(r);
            }, f.prototype.disableFPSCounter = function() {
              this.runtime.disableFPSCounter();
            }, Object.defineProperty(f.prototype, "contents", {
              /**
               * Returns the contents of a Rive file: the artboards, animations, and state machines
               */
              get: function() {
                if (this.loaded) {
                  for (var r = {
                    artboards: []
                  }, u = 0; u < this.file.artboardCount(); u++) {
                    for (var g = this.file.artboardByIndex(u), S = {
                      name: g.name,
                      animations: [],
                      stateMachines: []
                    }, R = 0; R < g.animationCount(); R++) {
                      var k = g.animationByIndex(R);
                      S.animations.push(k.name);
                    }
                    for (var ee = 0; ee < g.stateMachineCount(); ee++) {
                      for (var C = g.stateMachineByIndex(ee), m = C.name, Y = new this.runtime.StateMachineInstance(C, g), G = [], J = 0; J < Y.inputCount(); J++) {
                        var q = Y.input(J);
                        G.push({ name: q.name, type: q.type });
                      }
                      S.stateMachines.push({
                        name: m,
                        inputs: G
                      });
                    }
                    r.artboards.push(S);
                  }
                  return r;
                }
              },
              enumerable: !1,
              configurable: !0
            }), f.missingErrorMessage = "Rive source file or data buffer required", f;
          }()
        ), de = function(f) {
          return A(void 0, void 0, void 0, function() {
            var r, u, g;
            return M(this, function(S) {
              switch (S.label) {
                case 0:
                  return r = new Request(f), [4, fetch(r)];
                case 1:
                  return u = S.sent(), [4, u.arrayBuffer()];
                case 2:
                  return g = S.sent(), [2, g];
              }
            });
          });
        }, ie = function(f) {
          return typeof f == "string" ? [f] : f instanceof Array ? f : [];
        }, te = {
          EventManager: D,
          TaskQueueManager: U
        };
      })(), d;
    })()
  ));
})(po);
var pf = po.exports;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var o = Be, a = pf;
  function s(x) {
    return x && typeof x == "object" && "default" in x ? x : { default: x };
  }
  var l = s(o), d = function() {
    return d = Object.assign || function(x) {
      for (var F, B = 1, y = arguments.length; B < y; B++)
        for (var D in F = arguments[B])
          Object.prototype.hasOwnProperty.call(F, D) && (x[D] = F[D]);
      return x;
    }, d.apply(this, arguments);
  };
  function b(x, F) {
    var B = {};
    for (var y in x)
      Object.prototype.hasOwnProperty.call(x, y) && F.indexOf(y) < 0 && (B[y] = x[y]);
    if (x != null && typeof Object.getOwnPropertySymbols == "function") {
      var D = 0;
      for (y = Object.getOwnPropertySymbols(x); D < y.length; D++)
        F.indexOf(y[D]) < 0 && Object.prototype.propertyIsEnumerable.call(x, y[D]) && (B[y[D]] = x[y[D]]);
    }
    return B;
  }
  function L() {
    var x = typeof window < "u" && typeof window.devicePixelRatio == "number" ? window.devicePixelRatio : 1;
    return Math.min(Math.max(1, x), 3);
  }
  typeof SuppressedError == "function" && SuppressedError;
  var E = function() {
    function x() {
    }
    return x.prototype.observe = function() {
    }, x.prototype.unobserve = function() {
    }, x.prototype.disconnect = function() {
    }, x;
  }(), A = globalThis.ResizeObserver || E, M = globalThis.ResizeObserver !== void 0, I = !M;
  function O(x, F) {
    F === void 0 && (F = !0);
    var B = o.useState({ width: 0, height: 0 }), y = B[0], D = B[1];
    o.useEffect(function() {
      if (typeof window < "u" && F) {
        var te = function() {
          D({ width: window.innerWidth, height: window.innerHeight });
        };
        return I && (te(), window.addEventListener("resize", te)), function() {
          return window.removeEventListener("resize", te);
        };
      }
    }, []);
    var U, ue, de, ie = o.useRef(new A((U = function(te) {
      M && D({ width: te[te.length - 1].contentRect.width, height: te[te.length - 1].contentRect.height });
    }, ue = 0, de = 0, function() {
      for (var te = this, f = [], r = 0; r < arguments.length; r++)
        f[r] = arguments[r];
      clearTimeout(de), de = window.setTimeout(function() {
        return U.apply(te, f);
      }, ue);
    })));
    return o.useEffect(function() {
      var te = ie.current;
      if (F) {
        var f = x.current;
        return x.current && M && te.observe(x.current), function() {
          te.disconnect(), f && M && te.unobserve(f);
        };
      }
      te.disconnect();
    }, [x, ie]), y;
  }
  var h = { useDevicePixelRatio: !0, fitCanvasToArtboardHeight: !1, useOffscreenRenderer: !0, shouldResizeCanvasToContainer: !0 };
  function X(x) {
    return Object.assign({}, h, x);
  }
  function Z(x) {
    var F = x.riveLoaded, B = F !== void 0 && F, y = x.canvasRef, D = x.containerRef, U = x.options, ue = U === void 0 ? {} : U, de = x.onCanvasHasResized, ie = x.artboardBounds, te = X(ue), f = o.useState({ height: 0, width: 0 }), r = f[0], u = r.height, g = r.width, S = f[1], R = o.useState({ height: 0, width: 0 }), k = R[0], ee = k.height, C = k.width, m = R[1], Y = o.useState(!0), G = Y[0], J = Y[1], q = te.fitCanvasToArtboardHeight, Q = te.shouldResizeCanvasToContainer, ne = te.useDevicePixelRatio, pe = O(D, Q), ve = function() {
      var ke = L(), Ae = o.useState(ke), Ie = Ae[0], Ue = Ae[1];
      return o.useEffect(function() {
        if (typeof window < "u" && "matchMedia" in window) {
          var $e = function() {
            var at = L();
            Ue(at);
          }, Ne = window.matchMedia("screen and (resolution: ".concat(Ie, "dppx)"));
          return Ne.hasOwnProperty("addEventListener") ? Ne.addEventListener("change", $e) : Ne.addListener($e), function() {
            Ne.hasOwnProperty("removeEventListener") ? Ne.removeEventListener("change", $e) : Ne.removeListener($e);
          };
        }
      }, [Ie]), Ie;
    }(), se = ie ?? {}, xe = se.maxX, N = se.maxY, Fe = o.useCallback(function() {
      var ke, Ae, Ie, Ue, $e = (Ae = (ke = D.current) === null || ke === void 0 ? void 0 : ke.clientWidth) !== null && Ae !== void 0 ? Ae : 0, Ne = (Ue = (Ie = D.current) === null || Ie === void 0 ? void 0 : Ie.clientHeight) !== null && Ue !== void 0 ? Ue : 0;
      return q && ie ? { width: $e, height: $e * (ie.maxY / ie.maxX) } : { width: $e, height: Ne };
    }, [D, q, xe, N]);
    o.useEffect(function() {
      if (Q && D.current && B) {
        var ke = Fe(), Ae = ke.width, Ie = ke.height, Ue = !1;
        if (y.current) {
          var $e = Ae !== g || Ie !== u;
          if (te.fitCanvasToArtboardHeight && $e && (D.current.style.height = Ie + "px", Ue = !0), te.useDevicePixelRatio) {
            if ($e || Ae * ve !== C || Ie * ve !== ee) {
              var Ne = ve * Ae, at = ve * Ie;
              y.current.width = Ne, y.current.height = at, y.current.style.width = Ae + "px", y.current.style.height = Ie + "px", m({ width: Ne, height: at }), Ue = !0;
            }
          } else
            $e && (y.current.width = Ae, y.current.height = Ie, m({ width: Ae, height: Ie }), Ue = !0);
          S({ width: Ae, height: Ie });
        }
        de && (G || Ue) && de && de(), G && J(!1);
      }
    }, [y, D, pe, ve, Fe, G, J, ee, C, u, g, de, Q, q, ne, B]);
  }
  function K(x) {
    var F = x.setContainerRef, B = x.setCanvasRef, y = x.className, D = y === void 0 ? "" : y, U = x.style, ue = x.children, de = b(x, ["setContainerRef", "setCanvasRef", "className", "style", "children"]), ie = d({ width: "100%", height: "100%" }, U);
    return l.default.createElement("div", d({ ref: F, className: D }, !D && { style: ie }), l.default.createElement("canvas", d({ ref: B, style: { verticalAlign: "top", width: 0, height: 0 } }, de), ue));
  }
  function ce(x, F) {
    F === void 0 && (F = {});
    var B = o.useRef(null), y = o.useRef(null), D = o.useState(null), U = D[0], ue = D[1], de = !!x, ie = X(F), te = o.useCallback(function() {
      U && (U.startRendering(), U.resizeToCanvas());
    }, [U]);
    Z({ riveLoaded: !!U, canvasRef: B, containerRef: y, options: ie, onCanvasHasResized: te, artboardBounds: U == null ? void 0 : U.bounds });
    var f = o.useCallback(function(S) {
      if (S && x && de) {
        var R = ie.useOffscreenRenderer, k = new a.Rive(d(d({ useOffscreenRenderer: R }, x), { canvas: S }));
        k.on(a.EventType.Load, function() {
          B.current ? ue(k) : k.cleanup();
        });
      } else
        S === null && B.current && (B.current.height = 0, B.current.width = 0);
      B.current = S;
    }, [de]), r = o.useCallback(function(S) {
      y.current = S;
    }, []);
    o.useEffect(function() {
      var S = new IntersectionObserver(function(R) {
        R[0].isIntersecting ? U && U.startRendering() : U && U.stopRendering();
      });
      return B.current && S.observe(B.current), function() {
        S.disconnect();
      };
    }, [U]), o.useEffect(function() {
      return function() {
        U && (U.cleanup(), ue(null));
      };
    }, [U]);
    var u = x == null ? void 0 : x.animations;
    o.useEffect(function() {
      U && u && (U.isPlaying ? (U.stop(U.animationNames), U.play(u)) : U.isPaused && (U.stop(U.animationNames), U.pause(u)));
    }, [u, U]);
    var g = o.useCallback(function(S) {
      return l.default.createElement(K, d({ setContainerRef: r, setCanvasRef: f }, S));
    }, [f, r]);
    return { canvas: B.current, container: y.current, setCanvasRef: f, setContainerRef: r, rive: U, RiveComponent: g };
  }
  t.default = function(x) {
    var F = x.src, B = x.artboard, y = x.animations, D = x.stateMachines, U = x.layout, ue = x.useOffscreenRenderer, de = ue === void 0 || ue, ie = x.shouldDisableRiveListeners, te = ie !== void 0 && ie, f = x.shouldResizeCanvasToContainer, r = f === void 0 || f, u = x.children, g = b(x, ["src", "artboard", "animations", "stateMachines", "layout", "useOffscreenRenderer", "shouldDisableRiveListeners", "shouldResizeCanvasToContainer", "children"]), S = ce({ src: F, artboard: B, animations: y, layout: U, stateMachines: D, autoplay: !0, shouldDisableRiveListeners: te }, { useOffscreenRenderer: de, shouldResizeCanvasToContainer: r }).RiveComponent;
    return l.default.createElement(S, d({}, g), u);
  }, t.useResizeCanvas = Z, t.useRive = ce, t.useStateMachineInput = function(x, F, B, y) {
    var D = o.useState(null), U = D[0], ue = D[1];
    return o.useEffect(function() {
      function de() {
        if (x && F && B || ue(null), x && F && B) {
          var ie = x.stateMachineInputs(F);
          if (ie) {
            var te = ie.find(function(f) {
              return f.name === B;
            });
            y !== void 0 && te && (te.value = y), ue(te || null);
          }
        } else
          ue(null);
      }
      de(), x && x.on(a.EventType.Play, function() {
        de();
      });
    }, [x]), U;
  }, Object.keys(a).forEach(function(x) {
    x === "default" || t.hasOwnProperty(x) || Object.defineProperty(t, x, { enumerable: !0, get: function() {
      return a[x];
    } });
  });
})(ar);
const vf = ({ src: t, onPress: o = () => {
} }) => {
  const { rive: a, RiveComponent: s } = ar.useRive({
    src: t,
    artboard: "ThumbsUp",
    autoplay: !1,
    useOffscreenRenderer: !0
  });
  return /* @__PURE__ */ Re(
    "div",
    {
      style: {
        width: "70px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      },
      children: [
        /* @__PURE__ */ j(s, { onMouseUp: () => {
          a == null || a.play("Press"), setTimeout(() => {
            a == null || a.pause(), a == null || a.play("Hold");
          }, 400), setTimeout(() => {
            a == null || a.pause(), a == null || a.play("Release");
          }, 800), setTimeout(() => {
            a == null || a.pause();
          }, 1500), o();
        } }),
        "Yes"
      ]
    }
  );
}, mf = ({ src: t, onPress: o = () => {
} }) => {
  const { rive: a, RiveComponent: s } = ar.useRive({
    src: t,
    artboard: "ThumbsDown",
    autoplay: !1
  });
  return /* @__PURE__ */ Re(
    "div",
    {
      style: {
        width: "70px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      },
      children: [
        /* @__PURE__ */ j(
          s,
          {
            style: { marginLeft: ".5em" },
            onMouseUp: () => {
              a == null || a.play("Press"), setTimeout(() => {
                a == null || a.pause(), a == null || a.play("Hold");
              }, 400), setTimeout(() => {
                a == null || a.pause(), a == null || a.play("Release");
              }, 800), setTimeout(() => {
                a == null || a.pause();
              }, 1500), o();
            }
          }
        ),
        "No"
      ]
    }
  );
}, yf = "_wrapper_t4aj8_1", gf = "_thumbswrapper_t4aj8_6", bf = "_icon_t4aj8_15", tn = {
  wrapper: yf,
  thumbswrapper: gf,
  icon: bf
}, Cf = ({
  thumbsUpRivePath: t,
  thumbsDownRivePath: o,
  searchResultId: a,
  useMockData: s = !1,
  baseUrl: l = "/",
  onFeedback: d = (L) => {
  },
  csrfToken: b
}) => {
  const [L, E] = pt(""), [A, M] = pt(!1), I = nn(null);
  rn(() => {
    I.current && co(I.current);
  }, [I]);
  const O = (F) => ({
    event: F,
    type: "FeedbackRequestedEvent"
  }), h = (F) => ({
    event: F,
    type: "FeedbackResponseEvent"
  }), X = async () => {
    const F = { feedback_text: L };
    d(O(F));
    const B = s ? Sn : pu;
    try {
      const y = await B(l, a, F, b);
      d(h(y)), E("");
    } catch (y) {
      d({
        event: y,
        type: "FeedbackResponseError"
      });
    }
  }, Z = async () => {
    const F = { thumbs_up: !0 };
    d(O(F));
    const B = s ? Sn : kr;
    try {
      const y = await B(l, a, F, b);
      d(h(y));
    } catch (y) {
      d({
        event: y,
        type: "FeedbackResponseError"
      });
    }
    M(!0);
  }, K = async () => {
    const F = { thumbs_up: !1 };
    d(O(F));
    const B = s ? Sn : kr;
    try {
      const y = await B(l, a, F, b);
      d(h(y));
    } catch (y) {
      d({
        event: y,
        type: "FeedbackResponseError"
      });
    }
    M(!0);
  }, ce = () => t ? /* @__PURE__ */ j(vf, { src: t, onPress: Z }) : /* @__PURE__ */ Re(Pt, { appearance: "subtle", size: "small", onClick: Z, children: [
    /* @__PURE__ */ j(jn, { className: tn.icon, icon: ho }),
    "Yes"
  ] }), x = () => o ? /* @__PURE__ */ j(mf, { src: o, onPress: K }) : /* @__PURE__ */ Re(Pt, { appearance: "subtle", size: "small", onClick: K, children: [
    /* @__PURE__ */ j(jn, { className: tn.icon, icon: fo }),
    "No"
  ] });
  return /* @__PURE__ */ Re("div", { className: tn.wrapper, ref: I, children: [
    /* @__PURE__ */ Re("div", { className: tn.thumbswrapper, children: [
      /* @__PURE__ */ j("p", { style: { marginBottom: 0 }, children: "Was this clip relevant to your question?" }),
      /* @__PURE__ */ j("div", { style: { flex: "1 1 auto" } }),
      ce(),
      x()
    ] }),
    A && /* @__PURE__ */ Re(Fn, { children: [
      /* @__PURE__ */ j(
        uo,
        {
          placeholder: "tell us what you think!",
          style: { margin: ".5em 0" },
          onChange: (F) => E(F.target.value),
          value: L
        }
      ),
      /* @__PURE__ */ Re("div", { style: { display: "flex", justifyContent: "flex-end" }, children: [
        /* @__PURE__ */ j(Pt, { style: { marginRight: ".5em" }, appearance: "ghost", onClick: () => E(""), children: "Clear Feedback" }),
        /* @__PURE__ */ j(
          Pt,
          {
            appearance: "primary",
            onClick: () => X(),
            children: "Send Feedback"
          }
        )
      ] })
    ] })
  ] });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ft = function() {
  return Ft = Object.assign || function(o) {
    for (var a, s = 1, l = arguments.length; s < l; s++) {
      a = arguments[s];
      for (var d in a)
        Object.prototype.hasOwnProperty.call(a, d) && (o[d] = a[d]);
    }
    return o;
  }, Ft.apply(this, arguments);
};
function wf(t, o) {
  var a = {};
  for (var s in t)
    Object.prototype.hasOwnProperty.call(t, s) && o.indexOf(s) < 0 && (a[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, s = Object.getOwnPropertySymbols(t); l < s.length; l++)
      o.indexOf(s[l]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[l]) && (a[s[l]] = t[s[l]]);
  return a;
}
var Lf = function(t, o) {
  return {
    "aria-invalid": t || void 0,
    disabled: o || void 0
  };
}, Hr = function(t) {
  var o, a = t === "md" || t === "lg" ? 16 : 14;
  return o = {
    fill: "currentColor",
    className: "rds-Input-icon",
    height: a,
    width: a
  }, o["aria-hidden"] = !0, o.focusable = !1, o;
}, vo = Wn(function(t, o) {
  var a, s = t.className, l = t.disabled, d = l === void 0 ? !1 : l, b = t.icon, L = t.iconPosition, E = L === void 0 ? "left" : L, A = t.invalid, M = A === void 0 ? !1 : A, I = t.length, O = t.size, h = O === void 0 ? "md" : O, X = wf(t, ["className", "disabled", "icon", "iconPosition", "invalid", "length", "size"]), Z = Wt("rds-Input", (a = {
    "is-disabled": d,
    "is-invalid": M
  }, a["rds-Input--".concat(h)] = h !== "md", a["rds-Input--length".concat(I == null ? void 0 : I.toUpperCase())] = I, a), s);
  return Be.createElement(
    "div",
    { className: Z },
    b && E === "left" && Be.createElement(b, Ft({}, Hr(h))),
    Be.createElement("input", Ft({ ref: o }, X, Lf(M, d))),
    b && E === "right" && Be.createElement(b, Ft({}, Hr(h)))
  );
});
vo.displayName = "Input";
const Sf = "_containerwrapper_dcs4y_1", Pf = "_wrapper_dcs4y_6", Tf = "_samples_dcs4y_18", Bf = "_h3wrapper_dcs4y_24", Rf = "_inputwrapper_dcs4y_62", _f = "_rdsinput_dcs4y_68", xf = "_disclaimer_dcs4y_73", Ef = "_submitbutton_dcs4y_79", Ve = {
  containerwrapper: Sf,
  wrapper: Pf,
  samples: Tf,
  h3wrapper: Bf,
  inputwrapper: Rf,
  rdsinput: _f,
  disclaimer: xf,
  submitbutton: Ef
}, Of = "_containerwrapper_1k8tr_1", Mf = "_wrapper_1k8tr_5", qr = {
  containerwrapper: Of,
  wrapper: Mf
}, kf = () => /* @__PURE__ */ j("div", { className: qr.containerwrapper, children: /* @__PURE__ */ Re("div", { className: qr.wrapper, children: [
  /* @__PURE__ */ j(to, {}),
  /* @__PURE__ */ j("img", { src: "https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/app/ask/ramsey_hero_text@2x.png" }),
  /* @__PURE__ */ j("p", { children: "BETA" })
] }) }), Af = ({
  inputBackgroundPath: t,
  defaultSearchText: o,
  onInputChange: a,
  onShowSearching: s,
  onUserSuggestionClicked: l
}) => {
  const d = o || "", [b, L] = pt(d), E = [
    "How do I prepare for emergencies?",
    "Should I cash out my 401k?",
    "What is the Debt Snowball?",
    "How can I increase my income?"
  ], A = (h) => {
    const X = h.target.value;
    L(X), a(X);
  }, M = () => /* @__PURE__ */ j(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ j(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4707 2.86128C10.2104 2.60093 9.78828 2.60093 9.52793 2.86128C9.26758 3.12163 9.26758 3.54374 9.52793 3.80409L13.0565 7.33269H1.33268C0.964492 7.33269 0.666016 7.63116 0.666016 7.99935C0.666016 8.36754 0.964492 8.66602 1.33268 8.66602H13.0565L9.52793 12.1946C9.26758 12.455 9.26758 12.8771 9.52793 13.1374C9.78828 13.3978 10.2104 13.3978 10.4707 13.1374L15.1347 8.47342C15.144 8.4643 15.1529 8.45491 15.1616 8.44526C15.2103 8.39123 15.2486 8.33116 15.2765 8.26762C15.3126 8.18554 15.3327 8.09479 15.3327 7.99935C15.3327 7.90536 15.3132 7.81591 15.2781 7.73481C15.2483 7.6657 15.2062 7.60061 15.1519 7.54284C15.1466 7.53726 15.1413 7.53177 15.1358 7.52637L10.4707 2.86128Z",
          fill: "white"
        }
      )
    }
  ), I = (h) => {
    L(h), l(h);
  }, O = (h) => {
    h.key === "Enter" && s(!0);
  };
  return /* @__PURE__ */ j("div", { className: Ve.containerwrapper, children: /* @__PURE__ */ Re(
    "div",
    {
      className: Ve.wrapper,
      style: { backgroundImage: `url(${t})` },
      children: [
        /* @__PURE__ */ j(kf, {}),
        /* @__PURE__ */ Re("div", { className: Ve.samples, children: [
          /* @__PURE__ */ j("div", { className: Ve.h3wrapper, children: /* @__PURE__ */ j("button", { onClick: () => I(E[0]), children: /* @__PURE__ */ Re("h3", { children: [
            E[0],
            " ",
            M()
          ] }) }) }),
          /* @__PURE__ */ j("div", { className: Ve.h3wrapper, children: /* @__PURE__ */ j("button", { onClick: () => I(E[1]), children: /* @__PURE__ */ Re("h3", { children: [
            E[1],
            " ",
            M()
          ] }) }) }),
          /* @__PURE__ */ j("div", { className: Ve.h3wrapper, children: /* @__PURE__ */ j("button", { onClick: () => I(E[2]), children: /* @__PURE__ */ Re("h3", { children: [
            E[2],
            " ",
            M()
          ] }) }) }),
          /* @__PURE__ */ j("div", { className: Ve.h3wrapper, children: /* @__PURE__ */ j("button", { onClick: () => I(E[3]), children: /* @__PURE__ */ Re("h3", { children: [
            E[3],
            " ",
            M()
          ] }) }) })
        ] }),
        /* @__PURE__ */ Re("div", { className: Ve.inputwrapper, children: [
          /* @__PURE__ */ j(
            vo,
            {
              className: Ve.rdsinput,
              value: b,
              onChange: A,
              placeholder: " Type your question...",
              "data-testid": "ask-ramsey-input",
              onKeyDown: O
            }
          ),
          /* @__PURE__ */ j("div", { children: /* @__PURE__ */ j(
            Pt,
            {
              className: Ve.submitbutton,
              appearance: "primary",
              onClick: () => s(!0),
              "data-testid": "ask-ramsey-search-button",
              children: "Ask Question"
            }
          ) })
        ] }),
        /* @__PURE__ */ j("div", { className: Ve.disclaimer, children: /* @__PURE__ */ j("p", { children: "This will search hundreds of hours of video broadcasted from The Ramsey Show since January 2023." }) })
      ]
    }
  ) });
};
const jf = ({
  application_name: t,
  user_id: o,
  default_search_text: a,
  model_name: s = "trs-search-v1",
  base_url: l = "/app/ask",
  use_mock_data: d = !1,
  thumbsUpRivePath: b,
  thumbsDownRivePath: L,
  inputBackgroundPath: E = "https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/app/ask/ask_hero@2x.jpg",
  titleOverride: A,
  csrfToken: M,
  autoPlay: I = !0,
  onEvent: O = (h) => {
  }
}) => {
  const h = a || "", [X, Z] = pt({
    searchText: h,
    errorText: "",
    feedbackText: "",
    show: "input",
    videoResults: void 0
  }), K = nn(null);
  rn(() => {
    K.current && co(K.current);
  }, [K]);
  const ce = (u) => ({
    event: u,
    type: "SearchRequestedEvent"
  }), x = (u) => ({
    event: u,
    type: "SearchResponseEvent"
  }), F = (u) => ({
    event: u,
    type: "SearchResponseError"
  });
  rn(() => {
    if (!X.errorText && X.show === "searching") {
      const u = {
        search_text: X.searchText,
        application_name: t,
        user_id: o,
        model_name: s
      };
      O(ce(u)), (d ? vu : hu)(l, u, M).then((S) => {
        Z({
          ...X,
          show: "video",
          videoResults: S,
          errorText: ""
        }), O(x(S));
      }).catch((S) => {
        Z({
          ...X,
          errorText: S.message,
          show: "input",
          videoResults: void 0,
          feedbackText: ""
        }), O(F(S));
      });
    }
  }, [X]);
  const B = () => {
    if (X.show === "searching")
      return /* @__PURE__ */ j(ql, {});
    if (X.show === "video" && setTimeout(() => {
      Z({
        ...X,
        show: "feedback"
      });
    }, 3e3), X.show === "video" || X.show === "feedback") {
      if (!X.videoResults)
        return null;
      const u = X.videoResults.search_results[0], g = A || u.call_title;
      return /* @__PURE__ */ j(
        Xl,
        {
          originalQuestion: X.searchText,
          url: u.resource_uri,
          title: g,
          startAt: u.start_time,
          autoPlay: I
        }
      );
    }
    return null;
  }, y = () => /* @__PURE__ */ j(
    "svg",
    {
      style: { marginRight: ".8em" },
      width: "21",
      height: "23",
      viewBox: "0 0 21 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ j(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 9.6143L19.5358 0.826172L16.5128 3.84913C14.7452 2.55695 12.625 1.848 10.3979 1.848C4.66488 1.848 0 6.51288 0 12.2459C0 17.9789 4.66488 22.6438 10.3979 22.6438C14.5325 22.6438 18.2739 20.1956 19.93 16.406C20.1389 15.9277 19.9205 15.37 19.4422 15.1611C18.9648 14.9541 18.4071 15.1706 18.1973 15.6489C16.8427 18.7493 13.781 20.7533 10.3979 20.7533C5.70751 20.7533 1.89053 16.9363 1.89053 12.2459C1.89053 7.55551 5.70751 3.73853 10.3979 3.73853C12.1192 3.73853 13.7649 4.25276 15.1611 5.20086L12.2119 8.15008L21 9.6143Z",
          fill: "white"
        }
      )
    }
  ), D = () => {
    X.searchText.length < 5 ? Z({
      ...X,
      errorText: "Please enter more text!",
      show: "error",
      videoResults: void 0,
      feedbackText: ""
    }) : Z({
      ...X,
      errorText: "",
      show: "searching",
      videoResults: void 0,
      feedbackText: ""
    });
  }, U = () => {
    D();
  }, ue = () => {
    if (X.show === "feedback" && X.videoResults) {
      const u = X.videoResults.search_results[0];
      return /* @__PURE__ */ Re(Fn, { children: [
        /* @__PURE__ */ j(
          Cf,
          {
            baseUrl: l,
            useMockData: d,
            searchResultId: u.search_result_id,
            thumbsUpRivePath: b,
            thumbsDownRivePath: L,
            onFeedback: O,
            csrfToken: M
          }
        ),
        /* @__PURE__ */ Re(Pt, { appearance: "primary", onClick: f, children: [
          y(),
          "Ask Another Question"
        ] })
      ] });
    }
    return null;
  }, de = (u) => {
    Z({
      ...X,
      errorText: "",
      searchText: u,
      show: "searching",
      videoResults: void 0,
      feedbackText: ""
    });
  }, ie = () => X.show !== "input" && X.show !== "error" ? null : /* @__PURE__ */ j(
    Af,
    {
      inputBackgroundPath: E,
      defaultSearchText: a,
      onInputChange: te,
      onShowSearching: U,
      onUserSuggestionClicked: de
    }
  ), te = (u) => {
    Z({
      ...X,
      searchText: u,
      show: "input"
    });
  }, f = () => {
    Z({
      searchText: "",
      errorText: "",
      feedbackText: "",
      show: "input",
      videoResults: void 0
    });
  };
  return /* @__PURE__ */ Re("div", { ref: K, children: [
    (() => X.show !== "error" ? null : /* @__PURE__ */ j("h3", { "data-testid": "error-text", children: X.errorText }))(),
    ie(),
    B(),
    ue()
  ] });
};
export {
  jf as AskRamsey
};
